var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useContext, useEffect, useMemo, useRef, useState, } from 'react';
import Header from '../components/Header';
import Sidebar from '../components/Sidebar';
import WhiteBoard from '../components/WhiteBoard';
import globalStore from '../store';
import { leftSideTools, } from '../interface/gameController';
import { DataContext } from './DataContext';
import '../styles/gameController.scss';
import '../helper/performanceDebug';
import { findEmptyCells, calculateTokenPosition } from '../helper/tokenDropHelper';
import { getDisabledButtonsByLock } from '../helper/contextMenuHelper';
import { useRegionNavigation } from '../helper/hooks/useRegionNavigation';
import { announce } from '../helper/announcer';
import { trackEvent, AnalyticsCategory } from '../helper/analytics';
import { markAsDuplicated } from '../helper/hooks/useDuplicateAnnounce';
import { t } from 'i18next';
import { getContentLockArray } from '../helper/helper';
import ColoredTileController from '../components/ColoredTileController';
import { NF_CELL_SIZE } from '../constants/gridConstants';
import { getGroupRightConfigKey } from '../helper/groupHelper';
import { NMP_PIECE_TYPE_CONFIG } from '../constants/nmpConstants';
import { nmpAnimationTicker } from '../helper/nmpAnimationTicker';
import { SHAPE_BOUNDS, UNIT } from '../widgets/patternShapesConstants';
import ManipulativeTool from '../components/ManipulativeTool';
import FractionTileController from '../components/FractionTileController';
import Footer from '../components/Footer';
import EnterKeyModal from '../components/EnterKeyModal';
import SaveEditsReminderModal, { isSaveEditsReminderSuppressed, } from '../components/SaveEditsReminderModal';
import ResetModal from '../components/ResetModal';
import SplitFractionTileModal from '../components/SplitFractionTileModal';
import ZoomAndPanController from '../components/ZoomAndPanController';
import { ColorEnum } from '../components/ColorPicker';
import ManipulativePopup from '../widgets/popup/ManipulativePopup';
import Eraser from '../components/Eraser';
import ToolBottomPanel, { toolsWithBottomPanel } from '../components/ToolBottomPanel';
import RightSideToolPanel from '../components/RightSideToolPanel';
import customEventHandler, { getSkipTableDuplicate, setSkipTableDuplicate, } from '../helper/customEvents';
import DummyCanvas from '../components/DummyCanvas';
import KeyboardShortcutsModal from '../components/KeyboardShortcutsModal';
import InsertTablePopup from '../components/popups/InsertTablePopup';
import { v4 as uuidv4 } from 'uuid';
import { executeRedo, executeUndo, saveState, resetState } from '../helper/stateManagerHelper';
import { useMultiSelectFollowerEngine } from '../helper/hooks/useMultiSelectDrag';
import { playAudio } from '../helper/audioHelper';
import React from 'react';
import ReactDOM from 'react-dom';
var GameController = function (props) {
    var _a, _b;
    var _c = props.displayNone, displayNone = _c === void 0 ? false : _c;
    // All shared state comes from DataContextProvider (wrapped in PlayerMainContainer)
    var _d = useContext(DataContext), tool = _d.tool, setTool = _d.setTool, selectedTool = _d.selectedTool, setSelectedTool = _d.setSelectedTool, setDrawCommands = _d.setDrawCommands, annotations = _d.annotations, setAnnotations = _d.setAnnotations, text = _d.text, setText = _d.setText, table = _d.table, setTable = _d.setTable, shades = _d.shades, setShades = _d.setShades, savedState = _d.savedState, showChoralDrawer = _d.showChoralDrawer, setShowChoralDrawer = _d.setShowChoralDrawer, showStampEveryPopup = _d.showStampEveryPopup, setShowStampEveryPopup = _d.setShowStampEveryPopup, color = _d.color, setColor = _d.setColor, showEnterKeyModal = _d.showEnterKeyModal, setShowEnterKeyModal = _d.setShowEnterKeyModal, setWidthIndex = _d.setWidthIndex, thickness = _d.thickness, showTablePopup = _d.showTablePopup, setTablePopup = _d.setTablePopup, setShowShareModal = _d.setShowShareModal, setShowIwbSharePopup = _d.setShowIwbSharePopup, setShowSaveModal = _d.setShowSaveModal, showSplitFractionTileModal = _d.showSplitFractionTileModal, setShowSplitFractionTileModal = _d.setShowSplitFractionTileModal, splitFractionTileCurrentDenominator = _d.splitFractionTileCurrentDenominator, splitFractionTileCurrentNumerator = _d.splitFractionTileCurrentNumerator, setRecenterPan = _d.setRecenterPan, setRecenterPanOffset = _d.setRecenterPanOffset, setPanningEnable = _d.setPanningEnable, showTooManyItemsModal = _d.showTooManyItemsModal, setShowTooManyItemsModal = _d.setShowTooManyItemsModal, manipulative = _d.manipulative, drawCommands = _d.drawCommands, setManipulative = _d.setManipulative, selectedManipulativeId = _d.selectedManipulativeId, setSelectedManipulativeId = _d.setSelectedManipulativeId, setActiveManipulator = _d.setActiveManipulator, activeManipulator = _d.activeManipulator, setManiplulatorComponentVisible = _d.setManiplulatorComponentVisible, maniplulatorComponentVisible = _d.maniplulatorComponentVisible, getPositionForNewItem = _d.getPositionForNewItem, setManipulativeBtnState = _d.setManipulativeBtnState;
    // GameController-only state
    var _e = useState(false), showResetModal = _e[0], setShowResetModal = _e[1];
    var _f = useState(false), showShortcutsModal = _f[0], setShowShortcutsModal = _f[1];
    var _g = useState(false), showSaveEditsReminder = _g[0], setShowSaveEditsReminder = _g[1];
    // Focus restoration for SplitFractionTileModal — points to the tile that triggered the split
    var splitModalReturnFocusRef = useRef(null);
    useEffect(function () {
        var _a;
        if (showSplitFractionTileModal) {
            var tileId = selectedTool[0];
            if (tileId) {
                splitModalReturnFocusRef.current =
                    (_a = document.querySelector("[data-manipulative-id=\"".concat(tileId, "\"]"))) !== null && _a !== void 0 ? _a : null;
            }
        }
    }, [showSplitFractionTileModal]);
    var _h = globalStore.useStoreState(function (state) { return state.playerStore; }), gameLoaded = _h.gameLoaded, displayMode = _h.displayMode, zoomLevel = _h.zoomLevel, playerBgPattern = _h.playerBgPattern, isAdmin = _h.isAdmin, _j = _h.isLoggedIn, isLoggedIn = _j === void 0 ? true : _j, language = _h.language, isIDM = _h.isIDM, isSwp = _h.isSwp, activityMeta = _h.activityMeta, shareCode = _h.shareCode, storedManipulativeBtnState = _h.manipulativeBtnState, pageData = _h.pageData, currentPage = _h.currentPage, canvasWidth = _h.canvasWidth, canvasHeight = _h.canvasHeight;
    var hideTrayCounter = (_b = (_a = pageData[currentPage - 1]) === null || _a === void 0 ? void 0 : _a.hideTrayCounter) !== null && _b !== void 0 ? _b : false;
    // Seed DataContext manipulativeBtnState from the share-code payload once on load.
    // null = field absent in old share codes → leave DataContext state as-is (defaults to null = show all).
    var btnStateSeeded = useRef(false);
    useEffect(function () {
        if (btnStateSeeded.current)
            return;
        if (storedManipulativeBtnState !== null) {
            btnStateSeeded.current = true;
            setManipulativeBtnState(storedManipulativeBtnState);
        }
    }, [storedManipulativeBtnState]);
    var _k = globalStore.useStoreActions(function (actions) { return actions.playerStore; }), applyLanguage = _k.applyLanguage, setViewEditMode = _k.setViewEditMode, setUserZoom = _k.setUserZoom;
    // Initial view/edit mode is driven by ownership (isAdmin): your own code (or
    // your own workspace) opens in edit mode, while someone else's share code
    // opens in view mode. isAdmin settles once after checkAuth, so this runs at
    // load and doesn't fight the user's manual toggles afterwards.
    useEffect(function () {
        setViewEditMode(isAdmin ? 'edit' : 'view');
    }, [isAdmin]);
    var _l = globalStore.useStoreState(function (store) { return store.jsonDataStore; }), btnConfig = _l.btnConfig, mainConfig = _l.mainConfig, rightConfigStore = _l.rightConfig, bottomConfigStore = _l.bottomConfig;
    // Disable sidebar delete + toolbox while NMP animation is running
    var _m = useState(function () { return nmpAnimationTicker.isAnimating; }), nmpIsAnimating = _m[0], setNmpIsAnimating = _m[1];
    useEffect(function () { return nmpAnimationTicker.subscribe(function () { return setNmpIsAnimating(nmpAnimationTicker.isAnimating); }); }, []);
    // Refs to avoid re-attaching event listeners on every state change
    var manipulativeRef = useRef(manipulative);
    manipulativeRef.current = manipulative;
    var textRef = useRef(text);
    textRef.current = text;
    var annotationsRef = useRef(annotations);
    annotationsRef.current = annotations;
    var shadesRef = useRef(shades);
    shadesRef.current = shades;
    var tableRef = useRef(table);
    tableRef.current = table;
    var selectedToolRef = useRef(selectedTool);
    selectedToolRef.current = selectedTool;
    var colorRef = useRef(color);
    colorRef.current = color;
    var thicknessRef = useRef(thickness);
    thicknessRef.current = thickness;
    var toolRef = useRef(tool);
    toolRef.current = tool;
    var languageRef = useRef(language);
    languageRef.current = language;
    var zoomLevelRef = useRef(zoomLevel);
    zoomLevelRef.current = zoomLevel;
    // The headerClicked listener below is registered with [zoomLevel] deps —
    // its closure would otherwise pin shareCode/isLoggedIn/isIDM to their
    // initial values, so the save-edits reminder check on view→edit toggle
    // would silently skip after these flags update post-load.
    var shareCodeRef = useRef(shareCode);
    shareCodeRef.current = shareCode;
    var isLoggedInRef = useRef(isLoggedIn);
    isLoggedInRef.current = isLoggedIn;
    var isIDMRef = useRef(isIDM);
    isIDMRef.current = isIDM;
    var isAdminRef = useRef(isAdmin);
    isAdminRef.current = isAdmin;
    useMultiSelectFollowerEngine(manipulative, setManipulative, text, setText, selectedTool, canvasWidth, canvasHeight);
    // Compute whether right panel has content so we can fully unmount it when empty (avoids detached DOM)
    var hasRightPanelContent = useMemo(function () {
        var _a, _b, _c;
        // IDM sessions show the panel only when tray counters exist (that's what
        // the panel hosts). Without tray counters, fall through to the normal
        // selection-based checks below so the panel stays hidden when nothing's
        // relevant.
        if ((isIDM || isSwp) &&
            !hideTrayCounter &&
            ((_b = (_a = activityMeta === null || activityMeta === void 0 ? void 0 : activityMeta.trayCounters) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) > 0)
            return true;
        // Coins & Counters drawer — explicit gate scoped to this manipulative.
        // The drawer's content is dynamic (driven by the popup's selections),
        // not by btnData's rightConfig, so the standard rightConfig lookup
        // below would otherwise return false and hide the panel.
        // Mounted when the user is "in coins mode" — selectedTool is the dummy
        // id from the popup, or a placed counter (`coinsAndCounters_<uuid>`).
        // Click on empty canvas clears selectedTool, which unmounts the panel
        // (matching Pattern Shapes' behavior — re-clicking a placed counter
        // re-mounts because the drawer state in context is preserved).
        // Individual coin selected (or dummy ID while in coins mode with no counters placed yet).
        if ((_c = selectedTool[0]) === null || _c === void 0 ? void 0 : _c.startsWith('coinsAndCounters_'))
            return true;
        // Also show when ALL selected items are CC pieces/groups (mixed selections included).
        if (selectedTool.length > 0) {
            var allCCIds = selectedTool.every(function (id) { return id.startsWith('coinsAndCounters_') || id.startsWith('manipulativeGroup_'); });
            if (allCCIds) {
                var resolvedMembers = manipulative.filter(function (m) {
                    var _a, _b;
                    if (!(m === null || m === void 0 ? void 0 : m.data))
                        return false;
                    return (selectedTool.includes((_a = m.data.id) !== null && _a !== void 0 ? _a : '') ||
                        selectedTool.includes((_b = m.data.groupId) !== null && _b !== void 0 ? _b : ''));
                });
                if (resolvedMembers.length > 0 && resolvedMembers.every(function (m) { return m.data.type === 'coinsAndCounters'; })) {
                    return true;
                }
            }
        }
        // The `manipulative` array can briefly contain holes during state
        // transitions (e.g. an item being created/removed mid-render). Filter
        // out any falsy entries up front so downstream `.filter`/`.every`
        // callbacks don't crash on `undefined.data`.
        var safeManipulative = manipulative.filter(function (m) { return m && m.data; });
        if (selectedTool.length > 0) {
            // Handle manipulativeGroup_ selections — resolve via group members
            var allGroups = selectedTool.length >= 1 && selectedTool.every(function (t) { return t.startsWith('manipulativeGroup_'); });
            if (allGroups) {
                var members = safeManipulative.filter(function (m) { var _a; return selectedTool.includes((_a = m.data.groupId) !== null && _a !== void 0 ? _a : ''); });
                var configKey = getGroupRightConfigKey(members);
                if (configKey) {
                    var cfg_1 = rightConfigStore[configKey];
                    return Boolean(cfg_1 && cfg_1.length > 0);
                }
                // Mixed pieceTypes — check if common tools exist across configs
                var allNmp = members.every(function (m) { return (m === null || m === void 0 ? void 0 : m.type) === 'numberPiece' || (m === null || m === void 0 ? void 0 : m.type) === 'moneyPiece'; });
                if (allNmp && members.length > 0) {
                    var keys = Array.from(new Set(members.map(function (m) { var _a; return (_a = m.data) === null || _a === void 0 ? void 0 : _a.pieceType; })))
                        .map(function (pt) { return (pt ? NMP_PIECE_TYPE_CONFIG[pt] : undefined); })
                        .filter(function (k) { return !!k; });
                    var configs_1 = keys.map(function (k) { return rightConfigStore[k]; }).filter(function (c) { return c && c.length > 0; });
                    if (configs_1.length > 1) {
                        var hasCommon = configs_1[0].some(function (item) {
                            return configs_1.every(function (config) { return config.some(function (ci) { return ci === item; }); });
                        });
                        return hasCommon;
                    }
                    return configs_1.length === 1;
                }
                return false;
            }
            var configs_2 = selectedTool
                .map(function (t) {
                var _a, _b, _c;
                var toolKey = t.split('_')[0];
                if (t.includes('annotation')) {
                    var num = Number(t.split('_')[1]);
                    return rightConfigStore[(_a = annotations[num]) === null || _a === void 0 ? void 0 : _a.type];
                }
                // Tray counters use `counter_` prefix and `'counter'` type;
                // NumberFrame counters use `numberFrameCounter_` prefix and
                // `'numberFrameCounter'` type. Strict 1-to-1 invariant. Route by real type.
                var item = safeManipulative.find(function (m) { var _a; return ((_a = m.data) === null || _a === void 0 ? void 0 : _a.id) === t; });
                if (((_b = item === null || item === void 0 ? void 0 : item.data) === null || _b === void 0 ? void 0 : _b.type) === 'counter' && item.data.customImageBack) {
                    return rightConfigStore['trayCounterCard'];
                }
                // numberFrameCounter (frame tokens, in-frame or free-floating) get the
                // editNumberFrame config. Tray counters (`type === 'counter'`) are not
                // part of the NumberFrame ecosystem and don't get this config.
                if (((_c = item === null || item === void 0 ? void 0 : item.data) === null || _c === void 0 ? void 0 : _c.type) === 'numberFrameCounter') {
                    return rightConfigStore['numberFrameCounter'];
                }
                // Jump bars and custom ticks inherit the parent number line's
                // right-panel config so selecting them mounts the panel with the
                // line's tools (jumpBar / jumpLabel / lineMasking / customTickMark).
                // Mirrors the same fallback in RightSideToolPanel.tsx — both
                // gates have to agree or the panel won't mount even when the
                // resolved config has buttons.
                if ((toolKey === 'jumpBar' || toolKey === 'customTick') &&
                    rightConfigStore['numberLine']) {
                    return rightConfigStore['numberLine'];
                }
                return rightConfigStore[toolKey];
            })
                .filter(function (c) { return c != null; });
            if (configs_2.length > 0) {
                if (configs_2.length === 1)
                    return configs_2[0].length > 0;
                var common = configs_2[0].filter(function (item) {
                    return configs_2.every(function (config) {
                        return config.some(function (ci) {
                            return typeof item === 'string' && typeof ci === 'string' ? item === ci : item === ci;
                        });
                    });
                });
                return common.length > 0;
            }
            // No right config found — still show panel for linking cubes
            return selectedTool.every(function (s) { return s.startsWith('linkingCube'); });
        }
        var cfg = rightConfigStore[tool];
        return Boolean(cfg && cfg.length > 0);
    }, [
        selectedTool,
        tool,
        rightConfigStore,
        annotations,
        manipulative,
        isIDM,
        isSwp,
        activityMeta,
        hideTrayCounter,
    ]);
    var toolChange = function (tool) {
        setTool(tool);
    };
    var hasBottomPanelContent = useMemo(function () {
        var _a;
        // First, check if there's a selectedTool
        if (selectedTool.length > 0) {
            // Hide bottom panel when the selected item's editing is locked,
            // but keep it visible for table cell selections so the lock icon
            // correctly reflects the cell's lock state (editing lock is per-cell
            // on tables, so the user needs the panel to see/toggle the lock).
            var contentLock = getContentLockArray({
                selectedTool: selectedTool,
                text: text,
                table: table,
                annotations: annotations,
                manipulative: manipulative,
            });
            var isTableCellSelection = selectedTool.some(function (t) { return t.startsWith('tableText_'); });
            var isNumberFrameSelection = selectedTool.some(function (t) {
                return t.startsWith('numberFrame_') ||
                    t.startsWith('counter_') ||
                    t.startsWith('numberFrameCounter_');
            });
            if (contentLock.editing && !isTableCellSelection && !isNumberFrameSelection)
                return false;
            // Get configs for all selected tools
            var configs_3 = selectedTool
                .map(function (tool) {
                var _a;
                var toolKey = tool.split('_')[0];
                if (tool.includes('annotation')) {
                    var num = Number(tool.split('_')[1]);
                    // `annotations[num]` can be undefined briefly when an annotation
                    // is deleted while still in `selectedTool` (selection updates lag
                    // by a render). Optional-chain so the lookup falls through to
                    // the `null/undefined` filter below instead of crashing.
                    return bottomConfigStore[(_a = annotations[num]) === null || _a === void 0 ? void 0 : _a.type];
                }
                return bottomConfigStore[toolKey];
            })
                .filter(function (config) { return config !== null && config !== undefined; });
            if (configs_3.length > 0) {
                // Find common config (intersection of all configs)
                if (configs_3.length === 1) {
                    return configs_3[0].length > 0;
                }
                // Find common elements across all configs
                var commonConfig = configs_3[0].filter(function (item) {
                    return configs_3.every(function (config) {
                        // Check if item exists in all other configs
                        return config.some(function (configItem) {
                            // Compare by value if both are strings, or by reference if objects
                            if (typeof item === 'string' && typeof configItem === 'string') {
                                return item === configItem;
                            }
                            // For objects, compare by reference or by a unique identifier if available
                            return item === configItem;
                        });
                    });
                });
                return commonConfig.length > 0;
            }
        }
        // If no selectedTool config found, check if the active tool should show bottomPanel
        if (toolsWithBottomPanel.includes(tool)) {
            var toolKey = tool;
            return ((_a = bottomConfigStore[toolKey]) === null || _a === void 0 ? void 0 : _a.length) > 0;
        }
        return false;
    }, [selectedTool, tool, bottomConfigStore, text, table, annotations, manipulative]);
    // Helper functions for manipulative types
    var getManipulativeType = function (_select) {
        if (_select.startsWith('dice'))
            return 'dice';
        if (_select.startsWith('card'))
            return 'card';
        if (_select.startsWith('protractor'))
            return 'protractor';
        if (_select.startsWith('table'))
            return 'table';
        if (_select.startsWith('deck'))
            return 'deck';
        if (_select.startsWith('manipulativeGroup'))
            return 'manipulativeGroup';
        if (_select.startsWith('spinner'))
            return 'spinner';
        if (_select.startsWith('numberChart'))
            return 'numberChart';
        // Order matters: 'numberFrameCounter_' must be checked before 'numberFrame_'
        // because the latter is a prefix of the former (without the trailing underscore).
        if (_select.startsWith('numberFrameCounter_'))
            return 'numberFrameCounter';
        if (_select.startsWith('numberFrame_'))
            return 'numberFrame';
        if (_select.startsWith('counter_'))
            return 'counter';
        if (_select.startsWith('timer'))
            return 'timer';
        if (_select.startsWith('patternShapes'))
            return 'patternShapes';
        if (_select.startsWith('analog'))
            return 'analog';
        if (_select.startsWith('arrayModel'))
            return 'arrayModel';
        if (_select.startsWith('coloredTiles'))
            return 'coloredTiles';
        if (_select.startsWith('linearPiece'))
            return 'linearPiece';
        if (_select.startsWith('linkingCube'))
            return 'linkingCube';
        if (_select.startsWith('numberRacks'))
            return 'numberRacks';
        if (_select.startsWith('fractionTiles'))
            return 'fractionTiles';
        if (_select.startsWith('jumpBar'))
            return 'jumpBar';
        if (_select.startsWith('customTick'))
            return 'customTick';
        if (_select.startsWith('numberLine'))
            return 'numberLine';
        if (_select.startsWith('numberPiece'))
            return 'numberPiece';
        if (_select.startsWith('moneyPiece'))
            return 'moneyPiece';
        if (_select.startsWith('coinsAndCounters'))
            return 'coinsAndCounters';
        return null;
    };
    useEffect(function () {
        var handleGlobalClick = function (event) {
            var target = event.target;
            var isInsideChoralDrawer = target.closest('.choralControlsPopup');
            var isInsideChoralBtn = target.closest('.choralBtnWrapper');
            var isInsideStampPopup = target.closest('.stamp-every-popup');
            var isInsideStampBtn = target.closest('.stampEveryBtnWrapper');
            if (showChoralDrawer && !isInsideChoralDrawer && !isInsideChoralBtn) {
                setShowChoralDrawer(false);
            }
            if (showStampEveryPopup && !isInsideStampPopup && !isInsideStampBtn) {
                setShowStampEveryPopup(false);
            }
        };
        window.addEventListener('pointerdown', handleGlobalClick);
        return function () {
            window.removeEventListener('pointerdown', handleGlobalClick);
        };
    }, [showChoralDrawer, showStampEveryPopup]);
    var getNewIdPrefix = function (type) {
        var _a;
        var overrides = { timer: 'timer_clock_', analog: 'analog_clock_' };
        var validTypes = new Set([
            'dice',
            'protractor',
            'spinner',
            'numberChart',
            'linkingCube',
            'patternShapes',
            'deck',
            'card',
            'arrayModel',
            'coloredTiles',
            'numberRacks',
            'counter',
            'numberFrameCounter',
            'fractionTiles',
            'numberFrame',
            'numberPiece',
            'moneyPiece',
            'numberLine',
            'jumpBar',
            'customTick',
            'linearPiece',
            'coinsAndCounters',
        ]);
        return (_a = overrides[type]) !== null && _a !== void 0 ? _a : (validTypes.has(type) ? "".concat(type, "_") : '');
    };
    var getManipulativeTypeForDuplicate = function (type) {
        var _a;
        var overrides = {
            numberChart: 'numberCharts',
            linkingCube: 'linkingCubes',
            numberFrame: 'numberFrames',
            arrayModel: 'arrayModels',
        };
        var validTypes = new Set([
            'spinner',
            'protractor',
            'counter',
            'numberFrameCounter',
            'timer',
            'analog',
            'patternShapes',
            'deck',
            'coloredTiles',
            'numberRacks',
            'fractionTiles',
            'numberPiece',
            'moneyPiece',
            'numberLine',
            'jumpBar',
            'customTick',
            'linearPiece',
            'coinsAndCounters',
        ]);
        return (_a = overrides[type]) !== null && _a !== void 0 ? _a : (validTypes.has(type) ? type : undefined);
    };
    var duplicateManipulative = function (_select, setManipulative, newStateToSave, newSelectedIds) {
        var _a, _b, _c, _d, _e;
        var type = getManipulativeType(_select);
        if (!type)
            return;
        if (type === 'manipulativeGroup') {
            // Pre-generate group ID before setState so it's available synchronously
            var commonGroupId_1 = "manipulativeGroup_".concat(uuidv4().replace(/-/g, ''));
            newSelectedIds === null || newSelectedIds === void 0 ? void 0 : newSelectedIds.push(commonGroupId_1);
            setManipulative(function (prev) {
                var original = prev.filter(function (m) { return m.data.groupId === _select; });
                if (original.length === 0)
                    return prev;
                // Assign z-indices above the current max so the duplicate set renders on top as a unit
                var maxZ = prev
                    .filter(function (m) { return m.data.type === 'numberPiece' || m.data.type === 'moneyPiece'; })
                    .reduce(function (acc, m) { var _a; return Math.max(acc, (_a = m.data.zIndex) !== null && _a !== void 0 ? _a : 1); }, 0);
                var nextZ = maxZ + 1;
                var clonedGroupCounters = [];
                // Pre-generate IDs for linearPiece members so coloredTiles snap arrays
                // can be remapped before duplicates are created.
                var lpIdMap = new Map();
                original.forEach(function (m) {
                    if (m.data.type === 'linearPiece') {
                        lpIdMap.set(m.data.id, "linearPiece_".concat(uuidv4().replace(/-/g, '')));
                    }
                });
                var _orgCopy = original.map(function (_org) {
                    var _a, _b, _c, _d, _e;
                    var _cloned = structuredClone(_org);
                    var newFrameId = _cloned.data.type === 'linearPiece'
                        ? lpIdMap.get(_cloned.data.id)
                        : "".concat(_cloned.data.type || 'dice', "_").concat(uuidv4().replace(/-/g, ''));
                    var isNmp = _cloned.data.type === 'numberPiece' || _cloned.data.type === 'moneyPiece';
                    var cloned = __assign(__assign({}, _cloned), { widgetId: newFrameId, data: __assign(__assign(__assign(__assign({}, _cloned.data), { id: newFrameId, groupId: commonGroupId_1, 
                            // Strip only positioning lock on duplicate. Editing locks and
                            // JB-specific length locks were set by the teacher for a
                            // reason and should persist across copies; positioning is the
                            // one that surprises a teacher when they can't move the new
                            // copy.
                            lock: __assign(__assign({}, ((_a = _cloned.data.lock) !== null && _a !== void 0 ? _a : {})), { positioning: false }), center: {
                                x: Number(((_c = (_b = _cloned.data) === null || _b === void 0 ? void 0 : _b.center) === null || _c === void 0 ? void 0 : _c.x) || 0) + 30,
                                y: Number(((_e = (_d = _cloned.data) === null || _d === void 0 ? void 0 : _d.center) === null || _e === void 0 ? void 0 : _e.y) || 0) + 30,
                            } }), (_cloned.data.groupCenter && {
                            groupCenter: {
                                x: _cloned.data.groupCenter.x + 30,
                                y: _cloned.data.groupCenter.y + 30,
                            },
                        })), (isNmp && { zIndex: nextZ++ })) });
                    // Remap coloredTiles snap arrays to reference the new linearPiece IDs.
                    if (_cloned.data.type === 'coloredTiles' && lpIdMap.size > 0) {
                        var td = cloned.data;
                        var remap = function (arr) {
                            return arr === null || arr === void 0 ? void 0 : arr.map(function (pid) { return (pid && lpIdMap.has(pid) ? lpIdMap.get(pid) : pid); });
                        };
                        if (td.snappedVerticalPieceIds)
                            td.snappedVerticalPieceIds = remap(td.snappedVerticalPieceIds);
                        if (td.snappedRightVerticalPieceIds)
                            td.snappedRightVerticalPieceIds = remap(td.snappedRightVerticalPieceIds);
                        if (td.snappedHorizontalPieceIds)
                            td.snappedHorizontalPieceIds = remap(td.snappedHorizontalPieceIds);
                        if (td.snappedBottomHorizontalPieceIds)
                            td.snappedBottomHorizontalPieceIds = remap(td.snappedBottomHorizontalPieceIds);
                    }
                    // Duplicate tokens for numberFrames group members
                    if (_cloned.data.type === 'numberFrames') {
                        var originalTokens = _cloned.data.tokens || {};
                        var oldCounterIds = Object.values(originalTokens);
                        if (oldCounterIds.length > 0) {
                            var idMap_1 = new Map();
                            oldCounterIds.forEach(function (oldId) {
                                var _a, _b;
                                var counterOriginal = prev.find(function (m) { return m.data.id === oldId; });
                                if (!counterOriginal)
                                    return;
                                var newCounterId = "numberFrameCounter_".concat(uuidv4().replace(/-/g, ''));
                                idMap_1.set(oldId, newCounterId);
                                var clonedCounter = structuredClone(counterOriginal);
                                clonedCounter.data = __assign(__assign({}, clonedCounter.data), { id: newCounterId, frameId: newFrameId, center: {
                                        x: (((_a = clonedCounter.data.center) === null || _a === void 0 ? void 0 : _a.x) || 0) + 30,
                                        y: (((_b = clonedCounter.data.center) === null || _b === void 0 ? void 0 : _b.y) || 0) + 30,
                                    } });
                                clonedGroupCounters.push(clonedCounter);
                            });
                            var newTokens = {};
                            for (var _i = 0, _f = Object.entries(originalTokens); _i < _f.length; _i++) {
                                var _g = _f[_i], cellIndex = _g[0], oldId = _g[1];
                                var newId = idMap_1.get(oldId);
                                if (newId)
                                    newTokens[Number(cellIndex)] = newId;
                            }
                            cloned.data.tokens = newTokens;
                        }
                        else {
                            cloned.data.tokens = {};
                        }
                    }
                    return cloned;
                });
                _orgCopy.forEach(function (item) {
                    if (item.data.id) {
                        newStateToSave.push({
                            type: _select,
                            id: item.data.id,
                            propertyName: 'duplicate',
                            old: JSON.stringify(item),
                        });
                    }
                });
                return __spreadArray(__spreadArray(__spreadArray([], prev, true), _orgCopy, true), clonedGroupCounters, true);
            });
        }
        else {
            // Pre-generate the new ID before setState so it's available synchronously
            var idPrefix = getNewIdPrefix(type);
            var newItemId_1 = "".concat(idPrefix).concat(uuidv4().replace(/-/g, ''));
            // When duplicating a single coloredTiles tile that has external linearPiece(s)
            // snapped to its edges, bundle the tile + its duplicated piece(s) into a real
            // group (mirrors the ad-hoc multi-select duplicate behavior) so dragging the
            // duplicate afterward keeps the piece(s) moving with it instead of leaving
            // them behind (group-drag is keyed on shared groupId, not the snap-array ref).
            //
            // This whole branch is computed synchronously against `manipulativeRef.current`
            // (never inside the setManipulative updater below) and returns early: the
            // caller calls `saveState(newStateToSave)` immediately after this function
            // returns, but React defers running a functional setState updater until it
            // flushes the update — so any `newStateToSave.push` done *inside* an updater
            // would still be empty when saveState reads it, silently breaking Undo for
            // this action (the same class of bug fixed for the multi-select batch path).
            if (type === 'coloredTiles') {
                var originalItem = manipulativeRef.current.find(function (m) { return m.data.id === _select; });
                var originalTile = originalItem === null || originalItem === void 0 ? void 0 : originalItem.data;
                var hasSnappedPieces = !!originalTile &&
                    [
                        originalTile.snappedVerticalPieceIds,
                        originalTile.snappedRightVerticalPieceIds,
                        originalTile.snappedHorizontalPieceIds,
                        originalTile.snappedBottomHorizontalPieceIds,
                    ].some(function (arr) { return (arr !== null && arr !== void 0 ? arr : []).some(function (id) { return !!id; }); });
                // A "manual" tile assembled cell-by-cell out of 2+ cells is, from the
                // teacher's point of view, several tiles snapped together even though
                // it's stored as one manipulative with a multi-cell grid — there's no
                // second manipulative to keep dragging together, so this case does NOT
                // get a real groupId/manipulativeGroup_ (that would spuriously add an
                // "Ungroup" option, a dashed group-selection overlay, and route it
                // through GroupController's multi-member scale handling for a "group"
                // of one). It only needs `isGroup: true`, which alone is what gates
                // cell-by-cell extraction (see `ColoredTiles.tsx` — `data.isGroup !==
                // true && !data.groupId` — either flag disables extraction on its own).
                // Scoped to `generationMode === 'manual'` only — random/outline tiles are
                // pre-configured multi-cell grids from creation, not "snapped together",
                // and shouldn't have this behavior change applied to their duplicates.
                var isMultiCellAssembly = !!originalTile &&
                    originalTile.generationMode === 'manual' &&
                    originalTile.rows * originalTile.columns > 1;
                // A real group is only warranted when there's more than one manipulative
                // involved (the tile + its snapped linearPiece(s)) that actually needs to
                // keep dragging together.
                var shouldGroupDuplicate = hasSnappedPieces;
                var shouldLockDuplicate = hasSnappedPieces || isMultiCellAssembly;
                if (shouldLockDuplicate && originalItem) {
                    var singleCtGroupId_1 = shouldGroupDuplicate
                        ? "manipulativeGroup_".concat(uuidv4().replace(/-/g, ''))
                        : undefined;
                    newSelectedIds === null || newSelectedIds === void 0 ? void 0 : newSelectedIds.push(singleCtGroupId_1 !== null && singleCtGroupId_1 !== void 0 ? singleCtGroupId_1 : newItemId_1);
                    var prevSnapshot_1 = manipulativeRef.current;
                    var _cloned = structuredClone(originalItem);
                    var newItem_1 = __assign(__assign({}, _cloned), { widgetId: newItemId_1, data: __assign(__assign(__assign(__assign({}, _cloned.data), { id: newItemId_1, lock: __assign(__assign({}, ((_a = _cloned.data.lock) !== null && _a !== void 0 ? _a : {})), { positioning: false }), center: {
                                x: Number(((_c = (_b = _cloned.data) === null || _b === void 0 ? void 0 : _b.center) === null || _c === void 0 ? void 0 : _c.x) || 0) + 30,
                                y: Number(((_e = (_d = _cloned.data) === null || _d === void 0 ? void 0 : _d.center) === null || _e === void 0 ? void 0 : _e.y) || 0) + 30,
                            } }), (singleCtGroupId_1 && {
                            groupId: singleCtGroupId_1,
                            groupPosition: 0,
                            groupCenter: undefined,
                            beforeGroupScale: _cloned.data.scale,
                            groupScale: 1,
                        })), { isGroup: true }) });
                    var td = newItem_1.data;
                    var groupPos_1 = 1;
                    var clonedPieces_1 = [];
                    var cloneSnapArray = function (oldArr) {
                        if (!oldArr || oldArr.length === 0)
                            return null;
                        return oldArr.map(function (pid) {
                            var _a, _b;
                            if (!pid)
                                return null;
                            var srcPiece = prevSnapshot_1.find(function (m) { return m.data.id === pid; });
                            if (!srcPiece)
                                return null;
                            var newPieceId = "linearPiece_".concat(uuidv4().replace(/-/g, ''));
                            var clonedPiece = structuredClone(srcPiece);
                            clonedPiece.data = __assign(__assign({}, clonedPiece.data), { id: newPieceId, center: {
                                    x: (((_a = clonedPiece.data.center) === null || _a === void 0 ? void 0 : _a.x) || 0) + 30,
                                    y: (((_b = clonedPiece.data.center) === null || _b === void 0 ? void 0 : _b.y) || 0) + 30,
                                }, groupId: singleCtGroupId_1, groupPosition: groupPos_1++, groupCenter: undefined, beforeGroupScale: clonedPiece.data.scale, groupScale: 1 });
                            clonedPieces_1.push(clonedPiece);
                            newStateToSave.push({
                                type: pid,
                                id: newPieceId,
                                propertyName: 'duplicate',
                                old: JSON.stringify(clonedPiece),
                            });
                            return newPieceId;
                        });
                    };
                    var newLeftVIds = cloneSnapArray(td.snappedVerticalPieceIds);
                    if (newLeftVIds)
                        td.snappedVerticalPieceIds = newLeftVIds;
                    var newRightVIds = cloneSnapArray(td.snappedRightVerticalPieceIds);
                    if (newRightVIds)
                        td.snappedRightVerticalPieceIds = newRightVIds;
                    var newTopHIds = cloneSnapArray(td.snappedHorizontalPieceIds);
                    if (newTopHIds)
                        td.snappedHorizontalPieceIds = newTopHIds;
                    var newBottomHIds = cloneSnapArray(td.snappedBottomHorizontalPieceIds);
                    if (newBottomHIds)
                        td.snappedBottomHorizontalPieceIds = newBottomHIds;
                    newStateToSave.push({
                        type: _select,
                        id: newItem_1.data.id,
                        propertyName: 'duplicate',
                        old: JSON.stringify(newItem_1),
                    });
                    setManipulative(function (prevLive) { return __spreadArray(__spreadArray(__spreadArray([], prevLive, true), [newItem_1], false), clonedPieces_1, true); });
                    return;
                }
            }
            newSelectedIds === null || newSelectedIds === void 0 ? void 0 : newSelectedIds.push(newItemId_1);
            // Single item duplicate (dice, spinner, timer, analog, numberChart)
            setManipulative(function (prev) {
                var _a;
                var _b, _c, _d;
                var original = prev.find(function (m) { return m.data.id === _select; });
                if (!original)
                    return prev;
                var _cloned = structuredClone(original);
                var manipulativeType = getManipulativeTypeForDuplicate(type);
                var newItem = __assign(__assign({}, _cloned), { widgetId: newItemId_1, data: __assign(__assign(__assign(__assign({}, _cloned.data), { id: newItemId_1, isPreset: false, 
                        // Strip only the positioning lock (see #6b). Editing locks and
                        // any specialized locks (e.g. JB length) carry over.
                        lock: __assign(__assign({}, ((_b = _cloned.data.lock) !== null && _b !== void 0 ? _b : {})), { positioning: false }) }), (manipulativeType && { type: manipulativeType })), { center: {
                            x: _cloned.data.center.x + 30,
                            y: _cloned.data.center.y + 30,
                        } }) });
                if (type === 'coloredTiles' && newItem.data.isGroup === false) {
                    newItem.data.isGroup = true;
                }
                if (type === 'coloredTiles') {
                    delete newItem.data.groupId;
                    delete newItem.data.groupPosition;
                    delete newItem.data.groupCenter;
                    delete newItem.data.beforeGroupScale;
                    delete newItem.data.groupScale;
                }
                if (type === 'linkingCube') {
                    newItem.data.chainId = undefined;
                    newItem.data.chainIndex = undefined;
                }
                if (type === 'dice') {
                    newItem.data.lock = __assign(__assign({}, ((_c = newItem.data.lock) !== null && _c !== void 0 ? _c : {})), { positioning: false });
                }
                // Standalone numberFrameCounter duplicate: detach from any source frame
                // so the clone renders at the offset center as a free-floating token
                // instead of overlapping the original at the same cell.
                if (type === 'numberFrameCounter') {
                    newItem.data.frameId = undefined;
                    newItem.data.cellIndex = undefined;
                }
                // Card deck duplication: restamp all cards with the new deck id so that
                // share-code reload (mergeDeckWidget) doesn't collide with the original.
                if (type === 'deck') {
                    var deckData = newItem.data;
                    if (Array.isArray(deckData.cards)) {
                        deckData.cards = deckData.cards.map(function (card) { return (__assign(__assign({}, card), { deckId: newItemId_1 })); });
                    }
                }
                // NumberFrame duplication: duplicate tokens placed in the frame
                if (type === 'numberFrame') {
                    var frameData = newItem.data;
                    var originalTokens = frameData.tokens || {};
                    var oldCounterIds = Object.values(originalTokens);
                    if (oldCounterIds.length > 0) {
                        // Clone each counter with a new ID, pointing to the new frame
                        var idMap = new Map(); // old counter ID → new counter ID
                        var clonedCounters = [];
                        // Remap tokens first so we can look up cellIndex per counter
                        var newTokens = {};
                        var _loop_1 = function (cellIndex, oldId) {
                            var counterOriginal = prev.find(function (m) { return m.data.id === oldId; });
                            if (!counterOriginal)
                                return "continue";
                            var newCounterId = "numberFrameCounter_".concat(uuidv4().replace(/-/g, ''));
                            idMap.set(oldId, newCounterId);
                            newTokens[Number(cellIndex)] = newCounterId;
                            var clonedCounter = structuredClone(counterOriginal);
                            // Compute position from the new frame so it exactly matches calculateTokenPosition,
                            // regardless of what the original counter's stored center was.
                            var newCenter = calculateTokenPosition(frameData, Number(cellIndex));
                            clonedCounter.data = __assign(__assign({}, clonedCounter.data), { id: newCounterId, frameId: newItemId_1, center: newCenter, rotation: 0 });
                            clonedCounters.push(clonedCounter);
                            newStateToSave.push({
                                type: oldId,
                                id: newCounterId,
                                propertyName: 'duplicate',
                                old: JSON.stringify(clonedCounter),
                            });
                        };
                        for (var _i = 0, _e = Object.entries(originalTokens); _i < _e.length; _i++) {
                            var _f = _e[_i], cellIndex = _f[0], oldId = _f[1];
                            _loop_1(cellIndex, oldId);
                        }
                        frameData.tokens = newTokens;
                        newStateToSave.push({
                            type: _select,
                            id: newItem.data.id,
                            propertyName: 'duplicate',
                            old: JSON.stringify(newItem),
                        });
                        return __spreadArray(__spreadArray(__spreadArray([], prev, true), [newItem], false), clonedCounters, true);
                    }
                    else {
                        frameData.tokens = {};
                    }
                }
                // Counter duplication: place in next empty frame cell or outside
                if (type === 'numberFrameCounter' && original.data.frameId) {
                    var frameId_1 = original.data.frameId;
                    var frame = prev.find(function (m) { return m.data.id === frameId_1 && m.data.type === 'numberFrames'; });
                    if (frame) {
                        var frameData_1 = frame.data;
                        var emptyCells = findEmptyCells(frameData_1);
                        if (emptyCells.length > 0) {
                            // Place in the first empty cell
                            var cellIndex = emptyCells[0];
                            var pos = calculateTokenPosition(frameData_1, cellIndex);
                            newItem.data.center = pos;
                            newItem.data.frameId = frameId_1;
                            // Update frame tokens map
                            var updatedTokens_1 = __assign(__assign({}, (frameData_1.tokens || {})), (_a = {}, _a[cellIndex] = newItemId_1, _a));
                            var updatedPrev = prev.map(function (m) {
                                if (m.data.id === frameId_1) {
                                    return __assign(__assign({}, m), { data: __assign(__assign({}, frameData_1), { tokens: updatedTokens_1 }) });
                                }
                                return m;
                            });
                            newStateToSave.push({
                                type: _select,
                                id: newItem.data.id,
                                propertyName: 'duplicate',
                                old: JSON.stringify(newItem),
                            });
                            return __spreadArray(__spreadArray([], updatedPrev, true), [newItem], false);
                        }
                        else {
                            // Frame is full - place outside, remove frameId
                            delete newItem.data.frameId;
                            var halfWidth = (frameData_1.cols * NF_CELL_SIZE) / 2;
                            newItem.data.center = {
                                x: frameData_1.center.x + halfWidth + 30,
                                y: frameData_1.center.y,
                            };
                        }
                    }
                    else {
                        // Frame not found, remove frameId
                        delete newItem.data.frameId;
                    }
                }
                if (type === 'deck') {
                    var deckData = newItem.data;
                    newItem.data = __assign(__assign({}, deckData), { isPreset: false, cards: deckData.cards.map(function (_item) {
                            return __assign(__assign({}, _item), { id: "card_".concat(uuidv4().replace(/-/g, '')), placedOnDeck: false, position: {
                                    x: 0,
                                    y: 0,
                                }, showImage: 'front' });
                        }) });
                }
                if (type === 'numberLine') {
                    var nlData = newItem.data;
                    var oldNumberLineId_1 = original.data.id;
                    // Cascade duplicate only the children that are *visually attached*
                    // to the line (#6a). `snappedToLine` is the snap-config flag,
                    // not the "currently on the line" signal — a JB dragged off the
                    // line keeps that flag at `true`. Use vertical proximity instead:
                    // if the bar's center sits within one bar-height of the parent
                    // line, it's considered part of the line. customTicks are always
                    // anchored to the line geometrically, so always cascade those.
                    var JB_BAR_HEIGHT_1 = 30;
                    var lineY_1 = (_d = original.data.center) === null || _d === void 0 ? void 0 : _d.y;
                    var attachedChildren = prev.filter(function (m) {
                        var _a;
                        if (m.data.numberLineId !== oldNumberLineId_1)
                            return false;
                        if (m.data.type === 'customTick')
                            return true;
                        if (m.data.type !== 'jumpBar')
                            return false;
                        if (lineY_1 === undefined)
                            return false;
                        var scale = (_a = m.data.scale) !== null && _a !== void 0 ? _a : 1;
                        var barH = JB_BAR_HEIGHT_1 * scale;
                        var barCenterY = m.data.center.y + barH / 2;
                        return Math.abs(barCenterY - lineY_1) < barH;
                    });
                    var duplicatedJumpBars = attachedChildren.map(function (jb) {
                        var _a;
                        var cloned = structuredClone(jb);
                        var prefix = cloned.data.type === 'customTick' ? 'customTick_' : 'jumpBar_';
                        var newJbId = "".concat(prefix).concat(uuidv4().replace(/-/g, ''));
                        cloned.data.id = newJbId;
                        cloned.data.numberLineId = newItem.data.id;
                        cloned.data.center = {
                            x: cloned.data.center.x + 30,
                            y: cloned.data.center.y + 30,
                        };
                        // Strip only positioning lock on cascade-duplicated children
                        // (matches the global rule applied to standalone duplicates).
                        cloned.data.lock = __assign(__assign({}, ((_a = cloned.data.lock) !== null && _a !== void 0 ? _a : {})), { positioning: false });
                        newStateToSave.push({
                            type: oldNumberLineId_1,
                            id: newJbId,
                            propertyName: 'duplicate',
                            old: JSON.stringify(cloned),
                        });
                        return cloned;
                    });
                    newStateToSave.push({
                        type: _select,
                        id: newItem.data.id,
                        propertyName: 'duplicate',
                        old: JSON.stringify(newItem),
                    });
                    return __spreadArray(__spreadArray(__spreadArray([], prev, true), [newItem], false), duplicatedJumpBars, true);
                }
                newStateToSave.push({
                    type: _select,
                    id: newItem.data.id,
                    propertyName: 'duplicate',
                    old: JSON.stringify(newItem),
                });
                return __spreadArray(__spreadArray([], prev, true), [newItem], false);
            });
        }
    };
    var deleteManipulative = function (_select, setManipulative, newStateToSave) {
        var type = getManipulativeType(_select);
        if (!type)
            return;
        if (type === 'manipulativeGroup') {
            setManipulative(function (prev) {
                var itemsInGroup = prev.filter(function (m) { return m.data.groupId === _select; });
                // If all items in the group are position-locked, don't delete
                if (itemsInGroup.length > 0 && itemsInGroup.every(function (m) { var _a; return (_a = m.data.lock) === null || _a === void 0 ? void 0 : _a.positioning; })) {
                    return prev;
                }
                itemsInGroup.forEach(function (item) {
                    if (item.data.id) {
                        newStateToSave.push({
                            type: _select,
                            id: item.data.id,
                            propertyName: 'delete',
                            old: JSON.stringify(item),
                        });
                    }
                });
                return prev.filter(function (m) { return m.data.groupId !== _select; });
            });
        }
        else {
            // Single item delete (dice, spinner, timer, analog, numberFrame, counter)
            setManipulative(function (prev) {
                var _a, _b, _c, _d;
                // Number line: block delete if ANY lock is set
                if (_select.startsWith('numberLine')) {
                    var nlItem = prev.find(function (m) { return m.data.id === _select; });
                    if (nlItem && (((_a = nlItem.data.lock) === null || _a === void 0 ? void 0 : _a.positioning) || ((_b = nlItem.data.lock) === null || _b === void 0 ? void 0 : _b.editing))) {
                        return prev;
                    }
                }
                // Jump bar: block delete if length lock is set
                if (_select.startsWith('jumpBar')) {
                    var jbItem = prev.find(function (m) { return m.data.id === _select; });
                    if (jbItem && ((_c = jbItem.data.lock) === null || _c === void 0 ? void 0 : _c.length)) {
                        return prev;
                    }
                }
                var itemToDelete = prev.find(function (m) { var _a, _b; return m.data.id === _select && !((_a = m.data.lock) === null || _a === void 0 ? void 0 : _a.editing) && !((_b = m.data.lock) === null || _b === void 0 ? void 0 : _b.positioning); });
                if (itemToDelete) {
                    newStateToSave.push({
                        type: _select,
                        id: _select,
                        propertyName: 'delete',
                        old: JSON.stringify(itemToDelete),
                    });
                }
                // CASCADE DELETE: If deleting a numberFrame, also delete all counters attached to it
                if (_select.startsWith('numberFrame_')) {
                    var countersToDelete = prev.filter(function (m) { return m.data.type === 'numberFrameCounter' && m.data.frameId === _select; });
                    countersToDelete.forEach(function (counter) {
                        newStateToSave.push({
                            type: counter.data.id || 'numberFrameCounter',
                            id: counter.data.id || 'unknown',
                            propertyName: 'delete',
                            old: JSON.stringify(counter),
                        });
                    });
                    // Filter out the frame and all its counters
                    var filteredEl = prev.filter(function (m) {
                        var _a;
                        return (m.data.id !== _select || ((_a = m.data.lock) === null || _a === void 0 ? void 0 : _a.editing)) &&
                            !(m.data.type === 'numberFrameCounter' && m.data.frameId === _select);
                    });
                    return filteredEl;
                }
                // CASCADE DELETE: deleting a numberLine cascades to children that
                // are *visually anchored* to it (#7). `snappedToLine` is the snap
                // configuration flag, not "currently on the line", so we use
                // vertical proximity to the parent line — same rule as the
                // duplicate cascade above. customTicks are always anchored.
                // Floating JBs survive but get their `numberLineId` cleared so they
                // don't carry a dead reference into save state.
                if (_select.startsWith('numberLine')) {
                    var JB_BAR_HEIGHT_2 = 30;
                    var parentNL = prev.find(function (m) { return m.data.id === _select; });
                    var lineY_2 = parentNL ? (_d = parentNL.data.center) === null || _d === void 0 ? void 0 : _d.y : undefined;
                    var isJBOnLine_1 = function (m) {
                        var _a;
                        if (lineY_2 === undefined)
                            return false;
                        var scale = (_a = m.data.scale) !== null && _a !== void 0 ? _a : 1;
                        var barH = JB_BAR_HEIGHT_2 * scale;
                        var barCenterY = m.data.center.y + barH / 2;
                        return Math.abs(barCenterY - lineY_2) < barH;
                    };
                    var isCascadeChild_1 = function (m) {
                        return m.data.numberLineId === _select &&
                            (m.data.type === 'customTick' || (m.data.type === 'jumpBar' && isJBOnLine_1(m)));
                    };
                    var jumpBarsToDelete = prev.filter(isCascadeChild_1);
                    jumpBarsToDelete.forEach(function (jb) {
                        newStateToSave.push({
                            type: jb.data.id || 'jumpBar',
                            id: jb.data.id || 'unknown',
                            propertyName: 'delete',
                            old: JSON.stringify(jb),
                        });
                    });
                    var filteredEl = prev
                        .filter(function (m) { var _a; return (m.data.id !== _select || ((_a = m.data.lock) === null || _a === void 0 ? void 0 : _a.editing)) && !isCascadeChild_1(m); })
                        .map(function (m) {
                        // Detach floating JBs that were children of the deleted NL.
                        if (m.data.type === 'jumpBar' &&
                            m.data.numberLineId === _select &&
                            !isJBOnLine_1(m)) {
                            var oldRef = JSON.stringify(m);
                            var detached = __assign(__assign({}, m), { data: __assign(__assign({}, m.data), { numberLineId: null, snappedPosition: null }) });
                            newStateToSave.push({
                                type: m.data.id || 'jumpBar',
                                id: m.data.id || 'unknown',
                                propertyName: 'completeData',
                                old: oldRef,
                                new: JSON.stringify(detached),
                            });
                            return detached;
                        }
                        return m;
                    });
                    return filteredEl;
                }
                var result = prev.filter(function (m) { var _a; return m.data.id !== _select || ((_a = m.data.lock) === null || _a === void 0 ? void 0 : _a.editing); });
                // NMP snappedId cleanup: if deleting a snapped NMP piece and only 1 remains in cluster, clear its snappedId
                if (itemToDelete &&
                    (itemToDelete.data.type === 'numberPiece' || itemToDelete.data.type === 'moneyPiece')) {
                    var deletedSnappedId_1 = itemToDelete.data.snappedId;
                    if (deletedSnappedId_1) {
                        var remaining = result.filter(function (m) { return m.data.snappedId === deletedSnappedId_1; });
                        if (remaining.length <= 1) {
                            result = result.map(function (m) {
                                return m.data.snappedId === deletedSnappedId_1
                                    ? __assign(__assign({}, m), { data: __assign(__assign({}, m.data), { snappedId: undefined }) }) : m;
                            });
                        }
                    }
                }
                // If deleting a counter that's inside a frame, update the frame's tokens map
                if (itemToDelete &&
                    itemToDelete.data.type === 'numberFrameCounter' &&
                    itemToDelete.data.frameId) {
                    var parentFrameId_1 = itemToDelete.data.frameId;
                    result = result.map(function (m) {
                        if (m.data.id === parentFrameId_1 && m.data.type === 'numberFrames') {
                            var frame = m.data;
                            var updatedTokens = __assign({}, frame.tokens);
                            // Remove the deleted counter from the frame's tokens map
                            for (var _i = 0, _a = Object.entries(updatedTokens); _i < _a.length; _i++) {
                                var _b = _a[_i], cellIndex = _b[0], tokenId = _b[1];
                                if (tokenId === _select) {
                                    delete updatedTokens[cellIndex];
                                    break;
                                }
                            }
                            return __assign(__assign({}, m), { data: __assign(__assign({}, frame), { tokens: updatedTokens }) });
                        }
                        return m;
                    });
                }
                return result;
            });
        }
    };
    // const collapsibleDivObject1 = () => {
    //   let collapsibleGuide = {};
    //   if (selectedTool[0] && selectedTool[0]?.startsWith('spinner')) {
    //     collapsibleGuide = {
    //       toolsCollapsible: {
    //         hiddenElements: ['group'],
    //       },
    //     };
    //   }
    //   return { ...collapsibleGuide };
    // };
    var TOOL_RULES = [
        {
            // Dummy placeholder — any manipulative that opens its toolbar without a real item selected
            match: function (id) { return id.endsWith('_dummyForRightTool'); },
            result: {
                toolsCollapsible: {
                    hiddenElements: ['edit', 'group', 'show5x5Grid'],
                    disabledElements: ['delete', 'duplicate', 'scale', 'lock'],
                },
            },
        },
        {
            match: function (id) { return id.startsWith('linkingCube_'); },
            result: {
                toolsCollapsible: {
                    hiddenElements: ['edit', 'group', 'show5x5Grid'],
                    disabledElements: [],
                },
            },
        },
        {
            match: function (id) { return id.startsWith('numberChart_'); },
            result: {
                toolsCollapsible: {
                    hiddenElements: ['group', 'show5x5Grid'],
                    disabledElements: [],
                },
            },
        },
        {
            match: function (id) { return id.startsWith('protractor_'); },
            result: {
                toolsCollapsible: {
                    hiddenElements: ['group', 'edit', 'lock', 'show5x5Grid'],
                    disabledElements: [],
                },
            },
        },
        {
            match: function (id) { return id.startsWith('spinner_'); },
            result: {
                toolsCollapsible: {
                    hiddenElements: ['group', 'show5x5Grid'],
                    disabledElements: [],
                },
            },
        },
        {
            match: function (id) { return id.startsWith('analog_'); },
            result: {
                toolsCollapsible: {
                    hiddenElements: ['group', 'show5x5Grid'],
                    disabledElements: [],
                },
            },
        },
        {
            match: function (id) { return id.startsWith('timer_'); },
            result: {
                toolsCollapsible: {
                    hiddenElements: ['group', 'show5x5Grid'],
                    disabledElements: [],
                },
            },
        },
        {
            match: function (id) { return id.startsWith('dice_'); },
            result: {
                toolsCollapsible: {
                    hiddenElements: ['show5x5Grid'],
                    disabledElements: [],
                },
            },
        },
        {
            match: function (id) { return id.startsWith('deck_'); },
            result: {
                toolsCollapsible: {
                    hiddenElements: ['group', 'show5x5Grid'],
                    disabledElements: [],
                },
            },
        },
        {
            match: function (id) { return id.startsWith('card_'); },
            result: {
                toolsCollapsible: {
                    hiddenElements: ['group', 'show5x5Grid'],
                    disabledElements: ['duplicate'],
                },
            },
        },
        {
            match: function (id) { return id.startsWith('shades_'); },
            result: {
                toolsCollapsible: {
                    hiddenElements: ['group', 'edit', 'scale', 'show5x5Grid'],
                    disabledElements: [],
                },
            },
        },
        {
            match: function (id) { return id.startsWith('annotations_'); },
            result: {
                toolsCollapsible: {
                    hiddenElements: ['group', 'edit', 'scale', 'show5x5Grid'],
                    disabledElements: [],
                },
            },
        },
        {
            match: function (id) { return id.startsWith('text_'); },
            result: {
                toolsCollapsible: {
                    hiddenElements: ['group', 'edit', 'scale', 'show5x5Grid'],
                    disabledElements: [],
                },
            },
        },
        {
            match: function (id) { return id.startsWith('tableText_'); },
            result: {
                toolsCollapsible: {
                    hiddenElements: ['group', 'edit', 'show5x5Grid'],
                    disabledElements: ['scale'],
                },
            },
        },
        {
            match: function (id) { return id.startsWith('arrayModel_'); },
            result: {
                toolsCollapsible: {
                    hiddenElements: ['group', 'edit', 'show5x5Grid'],
                    disabledElements: [],
                },
            },
        },
        {
            match: function (id) { return id.startsWith('numberRacks_'); },
            result: {
                toolsCollapsible: {
                    hiddenElements: ['group', 'edit', 'show5x5Grid'],
                    disabledElements: [],
                },
            },
        },
        {
            id: 'fractionTiles_',
            match: function (id) { return id.startsWith('fractionTiles_'); },
            result: {
                toolsCollapsible: {
                    hiddenElements: ['show5x5Grid'],
                    disabledElements: [],
                },
            },
        },
        {
            match: function (id) { return id.startsWith('patternShapes_'); },
            result: {
                toolsCollapsible: {
                    hiddenElements: ['edit', 'show5x5Grid'],
                    disabledElements: [],
                },
            },
        },
        {
            match: function (id) { return id.startsWith('counter_') || id.startsWith('numberFrameCounter_'); },
            result: {
                toolsCollapsible: {
                    hiddenElements: ['show5x5Grid', 'edit', 'group'],
                    disabledElements: [],
                },
            },
        },
        {
            // Placed Coins & Counters tile — show edit/group/duplicate/lock/scale,
            // hide the numberFrame-only 5-grid toggle.
            match: function (id) { return id.startsWith('coinsAndCounters_'); },
            result: {
                toolsCollapsible: {
                    hiddenElements: ['show5x5Grid'],
                    disabledElements: [],
                },
            },
        },
        {
            match: function (id) { return id.startsWith('numberFrame_'); },
            result: {
                toolsCollapsible: {
                    hiddenElements: ['edit', 'group'],
                    disabledElements: [],
                },
            },
        },
        {
            id: 'coloredTiles_',
            match: function (id) { return id.startsWith('coloredTiles_'); },
            result: {
                toolsCollapsible: {
                    hiddenElements: ['edit', 'show5x5Grid'],
                    disabledElements: [],
                },
            },
        },
        {
            id: 'linearPiece_',
            match: function (id) { return id.startsWith('linearPiece_'); },
            result: {
                toolsCollapsible: {
                    hiddenElements: ['edit', 'show5x5Grid'],
                    disabledElements: [],
                },
            },
        },
        {
            match: function (id) { return id.startsWith('manipulativeGroup_'); },
            result: {
                toolsCollapsible: {
                    hiddenElements: ['show5x5Grid'],
                    disabledElements: [],
                },
            },
        },
        {
            match: function (id) { return id.startsWith('numberPiece_') || id.startsWith('moneyPiece_'); },
            result: {
                toolsCollapsible: {
                    hiddenElements: ['show5x5Grid'],
                    disabledElements: [],
                },
            },
        },
        {
            match: function (id) { return id.startsWith('numberLine_'); },
            result: {
                toolsCollapsible: {
                    hiddenElements: ['group', 'show5x5Grid'],
                    disabledElements: [],
                },
            },
        },
        {
            match: function (id) { return id.startsWith('jumpBar_'); },
            result: {
                toolsCollapsible: {
                    hiddenElements: ['group', 'edit', 'show5x5Grid'],
                    disabledElements: [],
                },
            },
        },
        {
            match: function (id) { return id.startsWith('customTick_'); },
            result: {
                toolsCollapsible: {
                    hiddenElements: ['group', 'edit', 'show5x5Grid'],
                    disabledElements: [],
                },
            },
        },
        // add more rules here
    ];
    // Token selections persisted here so they survive number frame deselect/reselect
    var _o = useState({
        top: { color: 'RED', shape: 'shape0' },
        bottom: { color: 'BLUE', shape: 'shape4' },
    }), tokenSelections = _o[0], setTokenSelections = _o[1];
    var _p = useState({
        top: false,
        bottom: false,
    }), tokenPanelOpen = _p[0], setTokenPanelOpen = _p[1];
    var checkCollapsibleState = useMemo(function () {
        var _toolRules = [];
        selectedTool.forEach(function (selectedToolId) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j;
            if (selectedToolId.startsWith('analog_clock_')) {
                var manipulativeMatch = manipulative.find(function (item) { return item.data.id === selectedToolId; });
                if (manipulativeMatch) {
                    var _manipulativeData_1 = manipulativeMatch.data;
                    var nextPart = (_a = btnConfig.fractionOverlay.elements) === null || _a === void 0 ? void 0 : _a.map(function (_elem) { return Number(_elem.id); });
                    var _fractionPart = nextPart;
                    if (_fractionPart) {
                        var _activeElements = (_manipulativeData_1 === null || _manipulativeData_1 === void 0 ? void 0 : _manipulativeData_1.fractionOverlayParts) !== null &&
                            (_manipulativeData_1 === null || _manipulativeData_1 === void 0 ? void 0 : _manipulativeData_1.fractionOverlayParts) !== undefined
                            ? _fractionPart.findIndex(function (_id) { return _id === (_manipulativeData_1 === null || _manipulativeData_1 === void 0 ? void 0 : _manipulativeData_1.fractionOverlayParts); })
                            : null;
                        var activeCollapsible = (_manipulativeData_1 === null || _manipulativeData_1 === void 0 ? void 0 : _manipulativeData_1.fractionOverlayParts) !== null ? true : false;
                        if (_activeElements !== null) {
                            _toolRules.push({
                                id: 'fractionOverlay',
                                activeElements: _activeElements,
                                activeCollapsible: activeCollapsible,
                            });
                        }
                    }
                    _toolRules.push({
                        id: 'runAndJump',
                        isActive: _manipulativeData_1.runJumpVisible,
                        activeElements: null,
                        activeCollapsible: false,
                    });
                    _toolRules.push({
                        id: 'digitalDisplay',
                        isActive: _manipulativeData_1.digitalClockVisible,
                        activeElements: null,
                        activeCollapsible: false,
                    });
                    _toolRules.push({
                        id: 'elapsedTime',
                        isActive: (_b = _manipulativeData_1.elapsedTimeDisplay) === null || _b === void 0 ? void 0 : _b.shown,
                        activeElements: null,
                        activeCollapsible: false,
                    });
                }
            }
            if (selectedToolId.startsWith('numberChart_')) {
                var manipulativeMatch = manipulative.find(function (item) { return item.data.id === selectedToolId; });
                if (manipulativeMatch && manipulativeMatch.data.type === 'numberCharts') {
                    // Only show stamp as active when actionType is 'stamp'
                    if (manipulativeMatch.data.actionType === 'stamp') {
                        var _activeElements = -1;
                        var activeCollapsible = false;
                        if (manipulativeMatch.data.stampIndex === null ||
                            manipulativeMatch.data.stampIndex === -1) {
                            activeCollapsible = false;
                        }
                        _activeElements =
                            manipulativeMatch.data.stampIndex === -1 ? null : manipulativeMatch.data.stampIndex;
                        if (_activeElements !== null) {
                            _toolRules.push({
                                id: 'stamp',
                                activeElements: _activeElements,
                                activeCollapsible: activeCollapsible,
                            });
                        }
                    }
                    if (manipulativeMatch.data.showGridLines) {
                        _toolRules.push({
                            id: 'gride',
                            isActive: true,
                            activeElements: null,
                            activeCollapsible: false,
                        });
                    }
                    // Handle actionType to show active state for action buttons
                    var actionType = manipulativeMatch.data.actionType;
                    if (actionType === 'clear') {
                        _toolRules.push({
                            id: 'showHideNumbers',
                            isActive: true,
                            activeElements: null,
                            activeCollapsible: false,
                        });
                    }
                    if (actionType === 'hideStamp') {
                        _toolRules.push({
                            id: 'stampEraser',
                            isActive: true,
                            activeElements: null,
                            activeCollapsible: false,
                        });
                    }
                }
            }
            if (selectedToolId.startsWith('tableText_')) {
            }
            if (selectedToolId.startsWith('arrayModel_') || selectedToolId.startsWith('coloredTiles_')) {
                var manipulativeMatch = manipulative.find(function (item) { return item.data.id === selectedToolId; });
                if (manipulativeMatch &&
                    (manipulativeMatch.data.type === 'arrayModels' ||
                        manipulativeMatch.data.type === 'coloredTiles')) {
                    _toolRules.push({
                        id: 'partMode',
                        isActive: ((_c = manipulativeMatch.data.partModeEnabled) !== null && _c !== void 0 ? _c : true) &&
                            !((_e = (_d = manipulativeMatch.data.lock) === null || _d === void 0 ? void 0 : _d.editing) !== null && _e !== void 0 ? _e : false),
                        activeElements: null,
                        activeCollapsible: false,
                    });
                    _toolRules.push({
                        id: 'selectMode',
                        isActive: (_f = manipulativeMatch.data.selectModeEnabled) !== null && _f !== void 0 ? _f : false,
                        activeElements: null,
                        activeCollapsible: false,
                    });
                }
            }
            if (selectedToolId.startsWith('fractionTiles_')) {
                _toolRules.push({
                    id: 'fractionTiles',
                    isActive: true,
                    activeElements: null,
                    activeCollapsible: false,
                });
            }
            if (selectedToolId.startsWith('numberLine_')) {
                var nlData = (_g = manipulative.find(function (item) { return item.data.id === selectedToolId; })) === null || _g === void 0 ? void 0 : _g.data;
                var isJumpLabelActive = manipulative.some(function (m) { return m.data.numberLineId === selectedToolId && m.data.showNumericalValue; });
                _toolRules.push({
                    id: 'jumpLabel',
                    isActive: isJumpLabelActive,
                    activeElements: null,
                    activeCollapsible: false,
                });
                var isLineMaskingActive = false;
                if (nlData && !nlData.labelsVisible && nlData.lineMode !== 'noTickMarks') {
                    // labelIntervalNum is a tick COUNT: label ticks 0, N, 2N, … within
                    // the T total ticks (T = intervals + 1), so labeled count is
                    // floor((T-1)/N) + 1.
                    var totalTicks = nlData.intervalNum > 0
                        ? Math.round((nlData.endNum - nlData.startNum) / nlData.intervalNum) + 1
                        : 0;
                    var totalLabels = totalTicks > 0 && nlData.labelIntervalNum > 0
                        ? Math.floor((totalTicks - 1) / nlData.labelIntervalNum) + 1
                        : 0;
                    isLineMaskingActive = ((_j = (_h = nlData.unmaskedLabels) === null || _h === void 0 ? void 0 : _h.length) !== null && _j !== void 0 ? _j : 0) < totalLabels;
                }
                _toolRules.push({
                    id: 'lineMasking',
                    isActive: isLineMaskingActive,
                    activeElements: null,
                    activeCollapsible: false,
                });
            }
        });
        return _toolRules;
    }, [selectedTool, manipulative, btnConfig]);
    var collapsibleDivObject = useMemo(function () {
        var _a, _b, _c, _d, _e;
        if (!(selectedTool === null || selectedTool === void 0 ? void 0 : selectedTool.length))
            return undefined;
        var hiddenElementsSet = new Set();
        var disabledElementsSet = new Set();
        var activeElementIds = [];
        for (var _i = 0, TOOL_RULES_1 = TOOL_RULES; _i < TOOL_RULES_1.length; _i++) {
            var rule = TOOL_RULES_1[_i];
            var matched = selectedTool.some(rule.match);
            if (matched) {
                rule.result.toolsCollapsible.hiddenElements.forEach(function (el) { return hiddenElementsSet.add(el); });
                rule.result.toolsCollapsible.disabledElements.forEach(function (el) { return disabledElementsSet.add(el); });
            }
        }
        if (!hiddenElementsSet.has('group') && selectedTool.length < 2) {
            disabledElementsSet.add('group');
        }
        // Set group flipBtn to active state when grouped items are selected (shows "Ungroup")
        // Only show "Ungroup" when exactly one group is selected with nothing else.
        // If a group + other items are selected, keep "Group" so they can be merged.
        if (selectedTool.length === 1 && selectedTool[0].startsWith('manipulativeGroup')) {
            activeElementIds.push('group');
            disabledElementsSet.delete('group');
            // Hide 'edit' (Configure tool) on a group when no member type would show it
            // individually. E.g. coloredTiles + linearPiece groups: both individual rules
            // hide 'edit', so the group should too. NMP groups still expose 'edit' since
            // numberPiece / moneyPiece individual rules don't hide it.
            var gid_1 = selectedTool[0];
            var members = manipulative.filter(function (m) { return m.data.groupId === gid_1; });
            if (members.length > 0) {
                var noMemberShowsEdit = members.every(function (m) {
                    var _a, _b;
                    var mid = (_a = m.data.id) !== null && _a !== void 0 ? _a : '';
                    var memberRule = TOOL_RULES.find(function (r) { return r.match(mid); });
                    return (_b = memberRule === null || memberRule === void 0 ? void 0 : memberRule.result.toolsCollapsible.hiddenElements.includes('edit')) !== null && _b !== void 0 ? _b : false;
                });
                if (noMemberShowsEdit)
                    hiddenElementsSet.add('edit');
            }
        }
        // Coins & Counters: per spec, the Configure (edit) button is grayed out
        // when a group of counters is selected. Re-configuring a single counter
        // is meaningless once it's part of a group; user must ungroup first.
        if (selectedTool.length === 1 && selectedTool[0].startsWith('manipulativeGroup_')) {
            var groupMembers = manipulative.filter(function (m) { return m.data.groupId === selectedTool[0]; });
            if (groupMembers.length > 0 &&
                groupMembers.every(function (m) { return m.data.type === 'coinsAndCounters'; })) {
                disabledElementsSet.add('edit');
            }
        }
        // Set show5x5Grid flipBtn to active state when selected numberFrame has show5x5Grid enabled
        // Disable it when the frame has only 5 cells (rows * cols === 5)
        if (selectedTool.some(function (id) { return id.startsWith('numberFrame_'); })) {
            var selectedFrame = manipulative.find(function (m) { var _a; return m.data.type === 'numberFrames' && selectedTool.includes((_a = m.data.id) !== null && _a !== void 0 ? _a : ''); });
            if (selectedFrame) {
                var nf = selectedFrame.data;
                if (nf.show5x5Grid) {
                    activeElementIds.push('show5x5Grid');
                }
                if (nf.rows <= 5 && nf.cols <= 5) {
                    disabledElementsSet.add('show5x5Grid');
                }
            }
        }
        // When only customTick(s) are selected, only delete should be active
        var isOnlyCustomTicks = selectedTool.every(function (id) { return id.startsWith('customTick_'); });
        if (isOnlyCustomTicks) {
            disabledElementsSet.add('scale');
            disabledElementsSet.add('duplicate');
            disabledElementsSet.add('lock');
        }
        // Disable edit for multi-select and groups, with exception for valid card/deck combos
        var allowEditForCardDeck = false;
        if (selectedTool.length > 1 &&
            selectedTool.every(function (id) { return id.startsWith('card_') || id.startsWith('deck_'); })) {
            var mDecks = selectedTool.filter(function (id) { return id.startsWith('deck_'); });
            var mCards_1 = selectedTool.filter(function (id) { return id.startsWith('card_'); });
            if (mCards_1.length > 0) {
                var cardParentIds_1 = new Set();
                manipulative.forEach(function (item) {
                    if (item.data.type === 'deck' && 'cards' in item.data) {
                        item.data.cards.forEach(function (card) {
                            if (mCards_1.includes(card.id))
                                cardParentIds_1.add(item.data.id);
                        });
                    }
                });
                var onlyOneDeck = cardParentIds_1.size === 1;
                var noExtraDecks = mDecks.length === 0 || (mDecks.length === 1 && cardParentIds_1.has(mDecks[0]));
                allowEditForCardDeck = onlyOneDeck && noExtraDecks;
            }
            // mCards.length === 0 means 2+ decks selected — stays disabled
        }
        if ((!allowEditForCardDeck && selectedTool.length > 1) ||
            selectedTool.some(function (tool) { return tool.startsWith('manipulativeGroup'); })) {
            disabledElementsSet.add('edit');
        }
        // Hide edit for patternShape and coloredTiles groups (all other groups show it as disabled)
        if (selectedTool.every(function (t) { return t.startsWith('manipulativeGroup_'); })) {
            var members = manipulative.filter(function (m) { var _a; return selectedTool.includes((_a = m.data.groupId) !== null && _a !== void 0 ? _a : ''); });
            var allArePatternOrTiles = members.every(function (m) { return m.data.type === 'patternShapes' || m.data.type === 'coloredTiles'; });
            if (members.length > 0 && allArePatternOrTiles) {
                hiddenElementsSet.add('edit');
            }
        }
        // Re-enable edit for multi-selected coinsAndCounters (not grouped).
        // Configure applies to the drawer, not individual counters, so it's always
        // meaningful regardless of how many counters are selected.
        var isAllCcStandalone = selectedTool.length > 1 &&
            !selectedTool.some(function (id) { return id.startsWith('manipulativeGroup_'); }) &&
            selectedTool.every(function (id) { return id.startsWith('coinsAndCounters_'); });
        if (isAllCcStandalone) {
            disabledElementsSet.delete('edit');
        }
        // Re-enable edit for same-pieceType NMP standalone multi-select
        var isAllNmp = selectedTool.length > 1 &&
            !selectedTool.some(function (id) { return id.startsWith('manipulativeGroup_'); }) &&
            selectedTool.every(function (id) { return id.startsWith('numberPiece_') || id.startsWith('moneyPiece_'); });
        if (isAllNmp) {
            var nmpItems_1 = selectedTool
                .map(function (id) { return manipulative.find(function (m) { return m.data.id === id; }); })
                .filter(function (m) { return !!m; });
            var allSamePieceType = nmpItems_1.length === selectedTool.length &&
                nmpItems_1.every(function (m) { return m.data.pieceType === nmpItems_1[0].data.pieceType; });
            if (allSamePieceType) {
                disabledElementsSet.delete('edit');
            }
        }
        var isAllFractionTiles = selectedTool.every(function (tool) { return tool.startsWith('fractionTiles_'); });
        var selectedFractionTiles = isAllFractionTiles
            ? manipulative.filter(function (m) {
                return m.data.id &&
                    selectedTool.some(function (t) { return m.data.id === t.replace(/_custom_label_(rect|circle)_\d+$/, ''); });
            })
            : [];
        var isFractionTileGroup = selectedFractionTiles.length > 0 &&
            selectedFractionTiles.every(function (m) {
                return m.data.shapeType ===
                    selectedFractionTiles[0].data.shapeType;
            });
        if (isFractionTileGroup) {
            disabledElementsSet.delete('edit');
        }
        var selectedPartKeys = selectedManipulativeId &&
            ((_b = (_a = manipulative.find(function (m) { return m.data.id === selectedManipulativeId && m.data.id.startsWith('coloredTiles'); })) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.selectedPartKeys);
        var isSelectColoredLinearPieces = selectedPartKeys && selectedPartKeys.some(function (key) { return key.includes('red'); });
        if (isSelectColoredLinearPieces) {
            disabledElementsSet.add('duplicate');
            disabledElementsSet.add('scale');
            disabledElementsSet.add('lock');
        }
        var isColoredTiles = ((_c = selectedTool[0]) === null || _c === void 0 ? void 0 : _c.startsWith('coloredTiles')) &&
            manipulative.find(function (m) { return m.data.id === selectedTool[0]; });
        if (isColoredTiles && isColoredTiles.data.type === 'coloredTiles') {
            var coloredTilesData = isColoredTiles.data;
            var isManual = coloredTilesData.generationMode === 'manual' &&
                manipulative
                    .filter(function (m) { return m.data.id && selectedTool.includes(m.data.id); })
                    .every(function (m) { return m.data.generationMode === 'manual'; });
            if (selectedTool.length === 1) {
                if (isManual) {
                    var isSingleManual = Object.keys((_d = coloredTilesData.partColors) !== null && _d !== void 0 ? _d : {}).length === 1;
                    if (isSingleManual) {
                        disabledElementsSet.add('group');
                    }
                    else {
                        var isGroup = coloredTilesData.isGroup;
                        if (!isGroup) {
                            disabledElementsSet.delete('group');
                        }
                        else {
                            activeElementIds.push('group');
                            disabledElementsSet.delete('group');
                        }
                    }
                }
                else {
                    var isEmptyOutline = coloredTilesData.generationMode === 'outline' &&
                        !Object.keys((_e = coloredTilesData.partColors) !== null && _e !== void 0 ? _e : {}).length;
                    if (isEmptyOutline) {
                        disabledElementsSet.add('group');
                    }
                    else {
                        var isGroup = coloredTilesData.isGroup;
                        if (!isGroup) {
                            disabledElementsSet.delete('group');
                        }
                        else {
                            activeElementIds.push('group');
                            disabledElementsSet.delete('group');
                        }
                    }
                }
            }
            else {
                disabledElementsSet.delete('group');
            }
        }
        // Custom logic for deck/card delete button
        // Uses the containing deck's ID (not card.deckId, which can be stale after duplication)
        var selectedDecks = selectedTool.filter(function (id) { return id.startsWith('deck_'); });
        var selectedCards = selectedTool.filter(function (id) { return id.startsWith('card_'); });
        if (selectedCards.length > 0) {
            // Find which deck actually contains each selected card
            var cardDeckIds_1 = new Set();
            manipulative.forEach(function (item) {
                if (item.data.type === 'deck' && 'cards' in item.data) {
                    item.data.cards.forEach(function (card) {
                        if (selectedCards.includes(card.id)) {
                            cardDeckIds_1.add(item.data.id);
                        }
                    });
                }
            });
            // If no deck is selected but cards are selected, disable delete
            if (selectedDecks.length === 0) {
                // Only cards selected (no parent deck) - disable delete
                disabledElementsSet.add('delete');
            }
            // Check if cards from different decks are mixed
            else if (cardDeckIds_1.size > 1) {
                // Cards from multiple different decks selected
                // Check if ALL parent decks are selected
                var allParentDecksSelected = Array.from(cardDeckIds_1).every(function (deckId) {
                    return selectedDecks.includes(deckId);
                });
                if (!allParentDecksSelected) {
                    // Case 5: deckA + cards from deckA + cards from deckB (deckB NOT selected)
                    disabledElementsSet.add('delete');
                }
                // Case 4 variant: deckA + deckB + cards from deckA + cards from deckB - allow delete
            }
            else if (cardDeckIds_1.size === 1) {
                // Cards from one deck + deck(s) selected
                var cardDeckId = Array.from(cardDeckIds_1)[0];
                // Check if the card's parent deck is among the selected decks
                var hasParentDeck = selectedDecks.includes(cardDeckId);
                if (!hasParentDeck) {
                    // Case 2: deckA selected + cards from deckB selected (parent deck NOT selected)
                    disabledElementsSet.add('delete');
                }
                // Case 1: deckA + cards from deckA - allow delete (parent deck IS selected)
                // Case 4: deckA + deckB + cards from deckA - allow delete (parent deck IS selected)
            }
        }
        // Disable delete button when any selected tool is locked
        var isAnyToolLocked = selectedTool.some(function (toolId) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3;
            if (toolId.startsWith('text_') || toolId.startsWith('mathtext_')) {
                var idx = Number(toolId.split('_')[1]);
                return (_g = (((_c = (_b = (_a = text[idx]) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.lock) === null || _c === void 0 ? void 0 : _c.positioning) || ((_f = (_e = (_d = text[idx]) === null || _d === void 0 ? void 0 : _d.data) === null || _e === void 0 ? void 0 : _e.lock) === null || _f === void 0 ? void 0 : _f.editing))) !== null && _g !== void 0 ? _g : false;
            }
            else if (toolId.startsWith('annotations_')) {
                var idx = Number(toolId.split('_')[1]);
                return ((_p = (((_k = (_j = (_h = annotations[idx]) === null || _h === void 0 ? void 0 : _h.data) === null || _j === void 0 ? void 0 : _j.lock) === null || _k === void 0 ? void 0 : _k.positioning) || ((_o = (_m = (_l = annotations[idx]) === null || _l === void 0 ? void 0 : _l.data) === null || _m === void 0 ? void 0 : _m.lock) === null || _o === void 0 ? void 0 : _o.editing))) !== null && _p !== void 0 ? _p : false);
            }
            else if (toolId.startsWith('shades_')) {
                var parts = toolId.split('_');
                var idx = +parts[parts.length - 1];
                return (_w = (((_s = (_r = (_q = shades[idx]) === null || _q === void 0 ? void 0 : _q.data) === null || _r === void 0 ? void 0 : _r.lock) === null || _s === void 0 ? void 0 : _s.positioning) || ((_v = (_u = (_t = shades[idx]) === null || _t === void 0 ? void 0 : _t.data) === null || _u === void 0 ? void 0 : _u.lock) === null || _v === void 0 ? void 0 : _v.editing))) !== null && _w !== void 0 ? _w : false;
            }
            else if (toolId.startsWith('manipulativeGroup')) {
                var groupItems = manipulative.filter(function (m) { return m.data.groupId === toolId; });
                return (groupItems.length > 0 &&
                    groupItems.every(function (m) { var _a, _b; return ((_a = m.data.lock) === null || _a === void 0 ? void 0 : _a.positioning) || ((_b = m.data.lock) === null || _b === void 0 ? void 0 : _b.editing); }));
            }
            else {
                var item = manipulative.find(function (m) { return m.data.id === toolId; });
                return ((_3 = (((_y = (_x = item === null || item === void 0 ? void 0 : item.data) === null || _x === void 0 ? void 0 : _x.lock) === null || _y === void 0 ? void 0 : _y.positioning) ||
                    ((_0 = (_z = item === null || item === void 0 ? void 0 : item.data) === null || _z === void 0 ? void 0 : _z.lock) === null || _0 === void 0 ? void 0 : _0.editing) ||
                    ((_2 = (_1 = item === null || item === void 0 ? void 0 : item.data) === null || _1 === void 0 ? void 0 : _1.lock) === null || _2 === void 0 ? void 0 : _2.length))) !== null && _3 !== void 0 ? _3 : false);
            }
        });
        if (isAnyToolLocked) {
            disabledElementsSet.add('delete');
        }
        // Disable edit and delete when any selected item is preset
        var anyPresetSelected = selectedTool.some(function (toolId) {
            var _a, _b;
            if (toolId.startsWith('card_')) {
                return manipulative.some(function (m) {
                    var _a, _b, _c, _d;
                    return ((_a = m.data) === null || _a === void 0 ? void 0 : _a.type) === 'deck' &&
                        ((_b = m.data) === null || _b === void 0 ? void 0 : _b.isPreset) === true &&
                        ((_d = (_c = m.data) === null || _c === void 0 ? void 0 : _c.cards) === null || _d === void 0 ? void 0 : _d.some(function (c) { return c.id === toolId; }));
                });
            }
            if (toolId.startsWith('manipulativeGroup_')) {
                var groupMember = manipulative.find(function (m) { var _a; return ((_a = m.data) === null || _a === void 0 ? void 0 : _a.groupId) === toolId; });
                return ((_a = groupMember === null || groupMember === void 0 ? void 0 : groupMember.data) === null || _a === void 0 ? void 0 : _a.isPreset) === true;
            }
            var item = manipulative.find(function (m) { return m.data.id === toolId; });
            return ((_b = item === null || item === void 0 ? void 0 : item.data) === null || _b === void 0 ? void 0 : _b.isPreset) === true;
        });
        if (anyPresetSelected) {
            disabledElementsSet.add('edit');
            disabledElementsSet.add('delete');
        }
        // Disable lock when table is selected alongside non-table items (inconsistent lock options)
        var hasTable = selectedTool.some(function (t) { return t.startsWith('tableText_'); });
        var hasNonTable = selectedTool.some(function (t) { return !t.startsWith('tableText_'); });
        if (hasTable && hasNonTable) {
            disabledElementsSet.add('lock');
        }
        // Show lock button as active when selected table cell(s) are locked
        if (hasTable && !hasNonTable) {
            var lockState = getContentLockArray({
                selectedTool: selectedTool,
                text: text,
                table: table,
                annotations: annotations,
                manipulative: manipulative,
            });
            if (lockState.editing)
                activeElementIds.push('contentLock');
            if (lockState.positioning)
                activeElementIds.push('positionLock');
            if (lockState.editing || lockState.positioning)
                activeElementIds.push('lock');
        }
        // Multi-select "merge these" only makes sense when every selected item
        // (or, for an existing manipulativeGroup_ selection, its members) is the
        // same manipulative type — e.g. all dice, all fraction tiles. Mixed-type
        // selections (1 die + 1 fraction tile) must not be groupable. NMP
        // (numberPiece + moneyPiece) and coloredTiles + linearPiece are treated
        // as compatible families, mirroring getGroupRightConfigKey's rules. This
        // runs last so it overrides any type-specific branch above (e.g. the
        // coloredTiles block re-enabling 'group' for its own multi-select case).
        if (!hiddenElementsSet.has('group') && selectedTool.length >= 2) {
            var resolvedTypes = selectedTool.map(function (id) {
                var _a, _b;
                if (id.startsWith('manipulativeGroup_')) {
                    return (_a = manipulative.find(function (m) { return m.data.groupId === id; })) === null || _a === void 0 ? void 0 : _a.data.type;
                }
                return (_b = manipulative.find(function (m) { return m.data.id === id; })) === null || _b === void 0 ? void 0 : _b.data.type;
            });
            if (resolvedTypes.every(function (t) { return !!t; })) {
                var types = new Set(resolvedTypes);
                var isNmpFamily = Array.from(types).every(function (t) { return t === 'numberPiece' || t === 'moneyPiece'; });
                var isColoredTilesFamily = Array.from(types).every(function (t) { return t === 'coloredTiles' || t === 'linearPiece'; }) &&
                    types.has('coloredTiles');
                if (types.size > 1 && !isNmpFamily && !isColoredTilesFamily) {
                    disabledElementsSet.add('group');
                }
            }
        }
        if (hiddenElementsSet.size === 0 &&
            disabledElementsSet.size === 0 &&
            activeElementIds.length === 0)
            return undefined;
        return {
            toolsCollapsible: {
                hiddenElements: Array.from(hiddenElementsSet),
                disabledElements: Array.from(disabledElementsSet),
                activeElementIds: activeElementIds,
            },
        };
    }, [selectedTool, manipulative, annotations, text, shades, table, selectedManipulativeId]);
    useEffect(function () {
        return function () {
            setDrawCommands([]);
            setAnnotations([]);
            setText([]);
            setShades([]);
            setManipulative([]);
            setSelectedTool([]);
            setTool(leftSideTools.selection);
            setWidthIndex(0);
            setColor('BLACK');
            setRecenterPan(false);
            setPanningEnable(false);
            setRecenterPanOffset({ x: 0, y: 0 });
        };
    }, []);
    var performResetCommon = function () {
        setDrawCommands([]);
        setSelectedTool([]);
        setSelectedManipulativeId('');
        setActiveManipulator('');
        setManiplulatorComponentVisible(false);
        setShowChoralDrawer(false);
        setShowStampEveryPopup(false);
        setShowShareModal(false);
        setShowSaveModal(false);
        setShowSplitFractionTileModal(false);
        setShowEnterKeyModal(false);
        resetState();
        customEventHandler.dispatchEvent('stateChanged', { type: 'reset' });
    };
    // "Reload this Activity" — restores the activity to its preloaded state.
    // A full page reload is the simplest and most reliable way to re-run the
    // bootstrap path: IDM activities re-fetch their initial/production state,
    // share-code URLs re-fetch the last saved payload, and IDM+shareCode
    // overlays the share code on the IDM baseline. This matches the spec's
    // "similar to the browser refresh" wording.
    var handleReloadActivity = function () {
        window.location.reload();
    };
    // "Start from Scratch" — clears the canvas without reloading. Stays in
    // the current activity context (IDM mapping / share code in URL remain),
    // but every manipulative, annotation, text, shade, and table cell is
    // dropped so the user starts on a blank canvas.
    var handleStartFromScratch = function () {
        // redirect to /
        window.location.replace('/');
        // setText([]);
        // setAnnotations([]);
        // setShades([]);
        // setManipulative([]);
        // setTable([]);
        // performResetCommon();
    };
    // Show "Reload this Activity" only when there's a baseline to reload to —
    // an IDM mapping or a share code in scope. With neither, the only
    // meaningful reset is a blank canvas.
    var hasPreloadedActivity = isIDM || isSwp || !!shareCode;
    var handleDeleteSelected = function (newStateToSave, manipulativeSelections) {
        var textDeletions = [];
        var annotationDeletions = [];
        var shadesDeletions = [];
        var tableDeletions = [];
        var isLinearPeicesDeletions = false;
        // Use ref to avoid stale closure — this function is captured by useEffect with [zoomLevel] deps
        var currentSelectedTool = selectedToolRef.current;
        // Use refs to avoid stale closures — this function is captured by useEffect with [zoomLevel] deps
        var currentText = textRef.current;
        var currentAnnotations = annotationsRef.current;
        var currentShades = shadesRef.current;
        var currentTable = tableRef.current;
        currentSelectedTool.forEach(function (_select) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
            if (_select.startsWith('tableText_')) {
                var pos = Number(_select.split('_')[1]);
                if (!Number.isNaN(pos)) {
                    tableDeletions.push({ select: _select, index: pos });
                }
            }
            else if (_select.startsWith('text') || _select.startsWith('mathtext')) {
                var pos = Number(_select.split('_')[1]);
                var textLock = (_b = (_a = currentText[pos]) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.lock;
                if (!Number.isNaN(pos) && !(textLock === null || textLock === void 0 ? void 0 : textLock.editing) && !(textLock === null || textLock === void 0 ? void 0 : textLock.positioning)) {
                    textDeletions.push({ select: _select, index: pos });
                }
            }
            else if (_select.startsWith('annotation')) {
                var pos = Number(_select.split('_')[1]);
                var annLock = (_d = (_c = currentAnnotations[pos]) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.lock;
                if (!Number.isNaN(pos) && !(annLock === null || annLock === void 0 ? void 0 : annLock.editing) && !(annLock === null || annLock === void 0 ? void 0 : annLock.positioning)) {
                    annotationDeletions.push({ select: _select, index: pos });
                }
            }
            else if (_select.startsWith('shades')) {
                var _splitedShade = _select.split('_');
                var _shadeIndx = +_splitedShade[_splitedShade.length - 1];
                var shadeLock = (_f = (_e = currentShades[_shadeIndx]) === null || _e === void 0 ? void 0 : _e.data) === null || _f === void 0 ? void 0 : _f.lock;
                if (!Number.isNaN(_shadeIndx) && !(shadeLock === null || shadeLock === void 0 ? void 0 : shadeLock.editing) && !(shadeLock === null || shadeLock === void 0 ? void 0 : shadeLock.positioning)) {
                    shadesDeletions.push({ select: _select, index: _shadeIndx });
                }
            }
            else if (_select.startsWith('coloredTiles')) {
                var item = manipulativeRef.current.find(function (m) { return m.data.id === _select; });
                var isLinearPeices = (((_h = (_g = item === null || item === void 0 ? void 0 : item.data) === null || _g === void 0 ? void 0 : _g.selectedPartKeys) === null || _h === void 0 ? void 0 : _h.length) || 0) > 0;
                if (isLinearPeices) {
                    isLinearPeicesDeletions = true;
                }
                else if (!((_j = item === null || item === void 0 ? void 0 : item.data.lock) === null || _j === void 0 ? void 0 : _j.positioning)) {
                    manipulativeSelections.push(_select);
                }
            }
            else if (_select.startsWith('manipulativeGroup')) {
                var currentManips = manipulativeRef.current;
                var groupItems = currentManips.filter(function (m) { return m.data.groupId === _select; });
                var allLocked = groupItems.length > 0 && groupItems.every(function (m) { var _a; return (_a = m.data.lock) === null || _a === void 0 ? void 0 : _a.positioning; });
                if (groupItems.length > 0 && !allLocked) {
                    manipulativeSelections.push(_select);
                }
            }
            else if (_select.startsWith('dice_') ||
                _select.startsWith('deck') ||
                _select.startsWith('spinner') ||
                _select.startsWith('numberChart') ||
                _select.startsWith('linkingCube_') ||
                _select.startsWith('numberFrame_') ||
                _select.startsWith('counter_') ||
                _select.startsWith('numberFrameCounter_') ||
                _select.startsWith('timer') ||
                _select.startsWith('patternShapes') ||
                _select.startsWith('analog') ||
                _select.startsWith('arrayModel') ||
                _select.startsWith('numberRacks') ||
                _select.startsWith('protractor') ||
                _select.startsWith('fractionTiles_') ||
                _select.startsWith('jumpBar') ||
                _select.startsWith('customTick') ||
                _select.startsWith('numberLine') ||
                _select.startsWith('numberPiece_') ||
                _select.startsWith('moneyPiece_') ||
                _select.startsWith('linearPiece_') ||
                _select.startsWith('coinsAndCounters_')) {
                var currentManips = manipulativeRef.current;
                var item = currentManips.find(function (m) { return m.data.id === _select; });
                var deleteId = _select;
                if (!item) {
                    item = currentManips.find(function (m) { return m.data.id && _select.startsWith(m.data.id); });
                    if (item === null || item === void 0 ? void 0 : item.data.id)
                        deleteId = item.data.id;
                }
                if (item && !((_k = item.data.lock) === null || _k === void 0 ? void 0 : _k.positioning)) {
                    manipulativeSelections.push(deleteId);
                }
            }
        });
        if (isLinearPeicesDeletions) {
            customEventHandler.dispatchEvent('bottomPanel', {
                panel: 'bottomPanel',
                id: 'delete',
            });
        }
        // Collect all deleted items with their type and index for atomic undo.
        // Using a single 'mixedDelete' entry ensures undo restores everything at once.
        var mixedDeleteData = { texts: [], annotations: [], shades: [], tables: [], manipulatives: [] };
        if (textDeletions.length > 0) {
            var indicesToDelete_1 = new Set(textDeletions.map(function (d) { return d.index; }));
            textDeletions.forEach(function (_a) {
                var index = _a.index;
                if (currentText[index] !== undefined) {
                    mixedDeleteData.texts.push({ index: index, data: currentText[index] });
                }
            });
            setText(function (prev) { return prev.filter(function (_, idx) { return !indicesToDelete_1.has(idx); }); });
        }
        if (annotationDeletions.length > 0) {
            var indicesToDelete_2 = new Set(annotationDeletions.map(function (d) { return d.index; }));
            // Populate mixedDeleteData SYNCHRONOUSLY from the ref — React 18
            // defers setState updaters, so reading inside the updater is too
            // late (the save runs before the updater executes).
            annotationDeletions.forEach(function (_a) {
                var index = _a.index;
                if (currentAnnotations[index] !== undefined) {
                    mixedDeleteData.annotations.push({ index: index, data: currentAnnotations[index] });
                }
            });
            setAnnotations(function (prev) { return prev.filter(function (_, idx) { return !indicesToDelete_2.has(idx); }); });
        }
        if (shadesDeletions.length > 0) {
            var indicesToDelete_3 = new Set(shadesDeletions.map(function (d) { return d.index; }));
            shadesDeletions.forEach(function (_a) {
                var index = _a.index;
                if (currentShades[index] !== undefined) {
                    mixedDeleteData.shades.push({ index: index, data: currentShades[index] });
                }
            });
            setShades(function (prev) { return prev.filter(function (_, idx) { return !indicesToDelete_3.has(idx); }); });
            announce(t('text.itemDeleted', { type: t('text.shade') }));
        }
        if (tableDeletions.length > 0) {
            var indicesToDelete_4 = new Set(tableDeletions.map(function (d) { return d.index; }));
            tableDeletions.forEach(function (_a) {
                var index = _a.index;
                if (currentTable[index] !== undefined) {
                    mixedDeleteData.tables.push({ index: index, data: currentTable[index] });
                }
            });
            setTable(function (prev) { return prev.filter(function (_, idx) { return !indicesToDelete_4.has(idx); }); });
        }
        if (manipulativeSelections.length > 0) {
            // Compute deletions synchronously from the ref (setManipulative updater is deferred)
            var currentManipulatives_1 = manipulativeRef.current;
            if (manipulativeSelections.length === 1) {
                var sel_1 = manipulativeSelections[0];
                if (sel_1.startsWith('manipulativeGroup')) {
                    var groupItems = currentManipulatives_1.filter(function (m) { var _a; return m.data.groupId === sel_1 && !((_a = m.data.lock) === null || _a === void 0 ? void 0 : _a.editing); });
                    groupItems.forEach(function (item, i) {
                        mixedDeleteData.manipulatives.push({ item: item, index: currentManipulatives_1.indexOf(item) });
                    });
                    setManipulative(function (prev) { return prev.filter(function (m) { var _a; return m.data.groupId !== sel_1 || ((_a = m.data.lock) === null || _a === void 0 ? void 0 : _a.editing); }); });
                }
                else {
                    var item_1 = currentManipulatives_1.find(function (m) { var _a; return m.data.id === sel_1 && !((_a = m.data.lock) === null || _a === void 0 ? void 0 : _a.editing); });
                    if (item_1) {
                        var index = currentManipulatives_1.indexOf(item_1);
                        mixedDeleteData.manipulatives.push({ item: item_1, index: index });
                    }
                    // For a single deleted linearPiece, save snap-array changes so undo can restore them.
                    if (sel_1.startsWith('linearPiece_')) {
                        var sideFields_1 = [
                            'snappedVerticalPieceIds',
                            'snappedRightVerticalPieceIds',
                            'snappedHorizontalPieceIds',
                            'snappedBottomHorizontalPieceIds',
                        ];
                        currentManipulatives_1.forEach(function (m) {
                            if (m.data.type !== 'coloredTiles')
                                return;
                            var td = m.data;
                            sideFields_1.forEach(function (field) {
                                var _a, _b;
                                var oldArr = td[field];
                                if (!(oldArr === null || oldArr === void 0 ? void 0 : oldArr.includes(sel_1)))
                                    return;
                                var newArr = oldArr.map(function (pid) { return (pid === sel_1 ? null : pid); });
                                newStateToSave.push({
                                    type: (_a = m.data.id) !== null && _a !== void 0 ? _a : '',
                                    id: ((_b = m.data.id) !== null && _b !== void 0 ? _b : '').split('_')[1],
                                    propertyName: field,
                                    old: JSON.stringify(oldArr),
                                    new: JSON.stringify(newArr),
                                });
                            });
                        });
                    }
                    // If deleting a framed counter, strip its entry from the parent frame's
                    // `tokens` map so the cell is reported as empty for future placements.
                    // The multi-select path already does this; the single-select path was
                    // missing it, which caused the cell to appear occupied after delete.
                    var isFramedCounter_1 = (item_1 === null || item_1 === void 0 ? void 0 : item_1.data.type) === 'numberFrameCounter' && !!item_1.data.frameId;
                    setManipulative(function (prev) {
                        var next = prev.filter(function (m) { var _a; return m.data.id !== sel_1 || ((_a = m.data.lock) === null || _a === void 0 ? void 0 : _a.editing); });
                        if (isFramedCounter_1) {
                            var parentFrameId_2 = item_1.data.frameId;
                            next = next.map(function (m) {
                                if (m.data.id === parentFrameId_2 && m.data.type === 'numberFrames') {
                                    var frame = m.data;
                                    var tokens = __assign({}, (frame.tokens || {}));
                                    var changed = false;
                                    for (var _i = 0, _a = Object.entries(tokens); _i < _a.length; _i++) {
                                        var _b = _a[_i], cellIndex = _b[0], tokenId = _b[1];
                                        if (tokenId === sel_1) {
                                            delete tokens[cellIndex];
                                            changed = true;
                                            break;
                                        }
                                    }
                                    return changed ? __assign(__assign({}, m), { data: __assign(__assign({}, frame), { tokens: tokens }) }) : m;
                                }
                                return m;
                            });
                        }
                        // If deleting a `linearPiece_`, null its id out of any coloredTiles
                        // snap arrays (all 4 sides) so the slot becomes available again.
                        if (sel_1.startsWith('linearPiece_')) {
                            next = next.map(function (m) {
                                if (m.data.type !== 'coloredTiles')
                                    return m;
                                var td = m.data;
                                var clearOf = function (arr) {
                                    return (arr !== null && arr !== void 0 ? arr : []).map(function (id) { return (id === sel_1 ? null : id); });
                                };
                                return __assign(__assign({}, m), { data: __assign(__assign({}, m.data), { snappedVerticalPieceIds: clearOf(td.snappedVerticalPieceIds), snappedRightVerticalPieceIds: clearOf(td.snappedRightVerticalPieceIds), snappedHorizontalPieceIds: clearOf(td.snappedHorizontalPieceIds), snappedBottomHorizontalPieceIds: clearOf(td.snappedBottomHorizontalPieceIds) }) });
                            });
                        }
                        return next;
                    });
                }
            }
            else {
                var groupSelections_1 = manipulativeSelections.filter(function (s) {
                    return s.startsWith('manipulativeGroup');
                });
                var individualSelections_1 = manipulativeSelections.filter(function (s) { return !s.startsWith('manipulativeGroup'); });
                var deletedFrameIds_1 = new Set(individualSelections_1.filter(function (s) { return s.startsWith('numberFrame_'); }));
                var deletedNLIds_1 = new Set(individualSelections_1.filter(function (s) { return s.startsWith('numberLine'); }));
                // Compute which items to delete synchronously for undo data
                var deletedCounterIds_1 = new Set();
                currentManipulatives_1.forEach(function (m, index) {
                    var _a, _b, _c, _d, _e, _f, _g, _h;
                    var isGroupMember = groupSelections_1.some(function (g) { return m.data.groupId === g; });
                    var isIndividual = individualSelections_1.includes((_a = m.data.id) !== null && _a !== void 0 ? _a : '');
                    var isCascadedCounter = m.data.type === 'numberFrameCounter' &&
                        deletedFrameIds_1.has((_b = m.data.frameId) !== null && _b !== void 0 ? _b : '');
                    var isCascadedNLChild = (m.data.type === 'jumpBar' || m.data.type === 'customTick') &&
                        deletedNLIds_1.has((_c = m.data.numberLineId) !== null && _c !== void 0 ? _c : '');
                    var isNLLocked = m.data.type === 'numberLine' && (((_d = m.data.lock) === null || _d === void 0 ? void 0 : _d.positioning) || ((_e = m.data.lock) === null || _e === void 0 ? void 0 : _e.editing));
                    var isJBLengthLocked = m.data.type === 'jumpBar' && ((_f = m.data.lock) === null || _f === void 0 ? void 0 : _f.length);
                    if ((isGroupMember || isIndividual || isCascadedCounter || isCascadedNLChild) &&
                        !((_g = m.data.lock) === null || _g === void 0 ? void 0 : _g.editing) &&
                        !isNLLocked &&
                        !isJBLengthLocked) {
                        mixedDeleteData.manipulatives.push({ item: m, index: index });
                        if (m.data.type === 'numberFrameCounter' && m.data.frameId) {
                            deletedCounterIds_1.add((_h = m.data.id) !== null && _h !== void 0 ? _h : '');
                        }
                    }
                });
                // Build the set of IDs to delete for the state updater
                var idsToDelete_1 = new Set(mixedDeleteData.manipulatives.map(function (_a) {
                    var item = _a.item;
                    return item.data.id;
                }));
                // G3: precompute tile snap-array property changes for any deleted linearPiece
                // so undo can restore both the piece AND its slot registration in one step.
                var deletedLinearPieceIdsForSave_1 = new Set(Array.from(idsToDelete_1).filter(function (id) { return typeof id === 'string' && id.startsWith('linearPiece_'); }));
                if (deletedLinearPieceIdsForSave_1.size > 0) {
                    var sideFields_2 = [
                        'snappedVerticalPieceIds',
                        'snappedRightVerticalPieceIds',
                        'snappedHorizontalPieceIds',
                        'snappedBottomHorizontalPieceIds',
                    ];
                    manipulative.forEach(function (m) {
                        if (m.data.type !== 'coloredTiles')
                            return;
                        var td = m.data;
                        sideFields_2.forEach(function (field) {
                            var _a, _b;
                            var oldArr = td[field];
                            if (!oldArr)
                                return;
                            var newArr = oldArr.map(function (id) {
                                return id && deletedLinearPieceIdsForSave_1.has(id) ? null : id;
                            });
                            var changed = oldArr.some(function (id, i) { return id !== newArr[i]; });
                            if (changed) {
                                newStateToSave.push({
                                    type: (_a = m.data.id) !== null && _a !== void 0 ? _a : '',
                                    id: ((_b = m.data.id) !== null && _b !== void 0 ? _b : '').split('_')[1],
                                    propertyName: field,
                                    old: JSON.stringify(oldArr),
                                    new: JSON.stringify(newArr),
                                });
                            }
                        });
                    });
                }
                setManipulative(function (prev) {
                    var newState = prev.filter(function (m) { return !idsToDelete_1.has(m.data.id); });
                    // NMP snappedId cleanup: clear snappedId from remaining cluster members if cluster drops to ≤1
                    var deletedSnappedIds = new Set(mixedDeleteData.manipulatives
                        .filter(function (_a) {
                        var item = _a.item;
                        return (item.data.type === 'numberPiece' || item.data.type === 'moneyPiece') &&
                            item.data.snappedId;
                    })
                        .map(function (_a) {
                        var item = _a.item;
                        return item.data.snappedId;
                    }));
                    if (deletedSnappedIds.size > 0) {
                        newState = newState.map(function (m) {
                            var sid = m.data.snappedId;
                            if (sid && deletedSnappedIds.has(sid)) {
                                var remaining = newState.filter(function (n) { return n.data.snappedId === sid; });
                                if (remaining.length <= 1) {
                                    return __assign(__assign({}, m), { data: __assign(__assign({}, m.data), { snappedId: undefined }) });
                                }
                            }
                            return m;
                        });
                    }
                    if (deletedCounterIds_1.size > 0) {
                        newState = newState.map(function (m) {
                            if (m.data.type === 'numberFrames' && m.data.tokens) {
                                var tokens = __assign({}, m.data.tokens);
                                var changed = false;
                                for (var _i = 0, _a = Object.entries(tokens); _i < _a.length; _i++) {
                                    var _b = _a[_i], cellIndex = _b[0], tokenId = _b[1];
                                    if (deletedCounterIds_1.has(tokenId)) {
                                        delete tokens[cellIndex];
                                        changed = true;
                                    }
                                }
                                if (changed) {
                                    return __assign(__assign({}, m), { data: __assign(__assign({}, m.data), { tokens: tokens }) });
                                }
                            }
                            return m;
                        });
                    }
                    // Clear deleted linearPiece IDs from any coloredTiles snapped arrays
                    var deletedLinearPieceIdsArr = Array.from(idsToDelete_1).filter(function (id) {
                        return id.startsWith('linearPiece_');
                    });
                    var deletedLinearPieceIds = new Set(deletedLinearPieceIdsArr);
                    if (deletedLinearPieceIds.size > 0) {
                        newState = newState.map(function (m) {
                            if (m.data.type !== 'coloredTiles')
                                return m;
                            var td = m.data;
                            var clearOf = function (arr) {
                                return (arr !== null && arr !== void 0 ? arr : []).map(function (id) {
                                    return id && deletedLinearPieceIds.has(id) ? null : id;
                                });
                            };
                            return __assign(__assign({}, m), { data: __assign(__assign({}, m.data), { snappedVerticalPieceIds: clearOf(td.snappedVerticalPieceIds), snappedRightVerticalPieceIds: clearOf(td.snappedRightVerticalPieceIds), snappedHorizontalPieceIds: clearOf(td.snappedHorizontalPieceIds), snappedBottomHorizontalPieceIds: clearOf(td.snappedBottomHorizontalPieceIds) }) });
                        });
                    }
                    // If a grouped coloredTile is deleted and only 1 member remains, clear the remaining tile's group fields
                    var deletedCtGroupIds = new Set(mixedDeleteData.manipulatives
                        .filter(function (_a) {
                        var item = _a.item;
                        return item.data.type === 'coloredTiles' && !!item.data.groupId;
                    })
                        .map(function (_a) {
                        var item = _a.item;
                        return item.data.groupId;
                    }));
                    if (deletedCtGroupIds.size > 0) {
                        newState = newState.map(function (m) {
                            if (m.data.type !== 'coloredTiles')
                                return m;
                            var gid = m.data.groupId;
                            if (!gid || !deletedCtGroupIds.has(gid))
                                return m;
                            var remaining = newState.filter(function (x) { return x.data.type === 'coloredTiles' && x.data.groupId === gid; });
                            if (remaining.length >= 2)
                                return m;
                            var d = __assign({}, m.data);
                            delete d.groupId;
                            delete d.groupPosition;
                            delete d.groupCenter;
                            delete d.beforeGroupScale;
                            delete d.groupScale;
                            return __assign(__assign({}, m), { data: d });
                        });
                    }
                    return newState;
                });
            }
        }
        // Save a single mixedDelete entry for all deletions (texts + annotations + shades + tables + manipulatives)
        var hasMixedDeletes = mixedDeleteData.texts.length > 0 ||
            mixedDeleteData.annotations.length > 0 ||
            mixedDeleteData.shades.length > 0 ||
            mixedDeleteData.tables.length > 0 ||
            mixedDeleteData.manipulatives.length > 0;
        if (hasMixedDeletes) {
            newStateToSave.push({
                type: 'mixed',
                id: 'batch',
                propertyName: 'mixedDelete',
                old: JSON.stringify(mixedDeleteData),
            });
        }
        // Announce deletion with type name
        var deletedCount = manipulativeSelections.length +
            textDeletions.length +
            annotationDeletions.length +
            shadesDeletions.length +
            tableDeletions.length;
        if (deletedCount > 0) {
            var typeNameMap = {
                dice: 'text.manipulativeDice',
                deck: 'text.manipulativeCardDeck',
                card: 'text.manipulativeCardDeck',
                analog: 'text.manipulativeClock',
                timer: 'text.manipulativeTimer',
                spinner: 'text.manipulativeSpinner',
                numberChart: 'text.manipulativeNumberChart',
                numberFrame: 'text.manipulativeNumberFrame',
                counter: 'text.manipulativeCounter',
                numberLine: 'text.manipulativeNumberLine',
                fractionTiles: 'text.manipulativeFractionTile',
                linkingCube: 'text.manipulativeLinkingCubes',
                arrayModel: 'text.manipulativeArrayModel',
                numberRacks: 'text.numberRacks',
                protractor: 'text.manipulativeProtractor',
                patternShapes: 'text.manipulativePatternShapes',
                manipulativeGroup: 'text.groupDice',
                annotations: 'text.annotation',
            };
            var currentSelected = selectedToolRef.current;
            var deletedType = currentSelected.length === 1 ? getManipulativeType(currentSelected[0]) : null;
            var typeName = deletedType ? t(typeNameMap[deletedType] || "text.".concat(deletedType)) : '';
            // Focus whiteboard with temporary aria-label so screen reader announces deletion
            var deletedMsg_1 = deletedCount === 1 && typeName
                ? t('text.itemDeleted', { type: typeName })
                : t('text.itemsDeleted', { count: deletedCount });
            // Wait for React + RaphaelCanvas re-render, then prefix aria-label + focus
            setTimeout(function () {
                var _a;
                var focusedEl = null;
                if (annotationDeletions.length === 1) {
                    var deletedIdx = annotationDeletions[0].index;
                    var prevIdx = deletedIdx > 0 ? deletedIdx - 1 : 0;
                    for (var idx = prevIdx; idx >= 0; idx--) {
                        var prevEl = document.querySelector("[data-manipulative-id=\"annotations_".concat(idx, "\"]"));
                        if (prevEl) {
                            focusedEl = prevEl;
                            break;
                        }
                    }
                }
                if (!focusedEl) {
                    var whiteboard = document.querySelector('.whiteboardScrollbar .customScrollbarContent');
                    if (whiteboard) {
                        whiteboard.setAttribute('tabindex', '-1');
                        focusedEl = whiteboard;
                    }
                }
                if (focusedEl) {
                    var existingLabel_1 = (_a = focusedEl.getAttribute('aria-label')) !== null && _a !== void 0 ? _a : '';
                    focusedEl.setAttribute('aria-label', "".concat(deletedMsg_1, ", ").concat(existingLabel_1));
                    focusedEl.focus();
                    setTimeout(function () {
                        if (focusedEl) {
                            focusedEl.setAttribute('aria-label', existingLabel_1);
                            // Clean up whiteboard tabindex if it was the fallback
                            if (focusedEl.classList.contains('customScrollbarContent')) {
                                focusedEl.removeAttribute('tabindex');
                            }
                        }
                    }, 300);
                }
            }, 400);
        }
        var onlyPatternShapesDeleted = manipulativeSelections.length > 0 &&
            manipulativeSelections.every(function (s) {
                if (s.startsWith('patternShapes'))
                    return true;
                if (s.startsWith('manipulativeGroup_')) {
                    var groupMembers = manipulativeRef.current.filter(function (m) { return m.data.groupId === s; });
                    return (groupMembers.length > 0 && groupMembers.every(function (m) { return m.data.type === 'patternShapes'; }));
                }
                return false;
            }) &&
            textDeletions.length === 0 &&
            annotationDeletions.length === 0 &&
            shadesDeletions.length === 0;
        setSelectedTool(onlyPatternShapesDeleted ? ['patternShapes_dummyForRightTool'] : []);
    };
    useEffect(function () {
        var onClick = function (data) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
            // Read latest state from refs to avoid stale closures
            // (this useEffect should NOT re-attach listeners on every array change)
            var manipulative = manipulativeRef.current;
            var text = textRef.current;
            var annotations = annotationsRef.current;
            var shades = shadesRef.current;
            var table = tableRef.current;
            var selectedTool = selectedToolRef.current;
            var color = colorRef.current;
            var tool = toolRef.current;
            var newStateToSave = __spreadArray([], (savedState || []), true);
            var manipulativeSelections = [];
            var _newItem = (_b = (_a = btnConfig[data.id]) === null || _a === void 0 ? void 0 : _a.elements) === null || _b === void 0 ? void 0 : _b[data.data];
            // delete/duplicate events from bottomPanel (keyboard shortcut or button click)
            if (data.panel === 'bottomPanel' && (data.id === 'delete' || data.id === 'duplicate')) {
                _newItem = data;
            }
            var customCursorArray = ['pen', 'highlighter', 'erase'];
            var drawingCanvas = document.querySelector('.drawingCanvas');
            if (!(data.panel && data.panel === 'bottomPanel')) {
                if (drawingCanvas) {
                    drawingCanvas.style.cursor = 'default';
                }
            }
            // ColoredTiles groups should carry along any LinearPieces snapped to their
            // edges, so the pieces inherit the group's groupId and move/scale with it.
            // (A LinearPiece only follows a group drag when it shares the groupId —
            // see LinearPiece.tsx `sameGroup`.) Given the ids being grouped (tile ids
            // and/or existing group ids), return the same ids plus every snapped
            // LinearPiece id referenced by those colored tiles.
            var expandWithSnappedLinearPieces = function (ids, items) {
                var result = new Set(ids);
                // Resolve the set of colored-tile ids covered by `ids` (expanding group ids).
                var tileIds = new Set();
                ids.forEach(function (id) {
                    if (id.startsWith('manipulativeGroup_')) {
                        items.forEach(function (m) {
                            if (m.data.type === 'coloredTiles' && m.data.groupId === id && m.data.id) {
                                tileIds.add(m.data.id);
                            }
                        });
                    }
                    else {
                        var it = items.find(function (m) { return m.data.id === id; });
                        if ((it === null || it === void 0 ? void 0 : it.data.type) === 'coloredTiles' && it.data.id)
                            tileIds.add(it.data.id);
                    }
                });
                items.forEach(function (m) {
                    if (m.data.type !== 'coloredTiles' || !m.data.id || !tileIds.has(m.data.id))
                        return;
                    var td = m.data;
                    [
                        td.snappedVerticalPieceIds,
                        td.snappedRightVerticalPieceIds,
                        td.snappedHorizontalPieceIds,
                        td.snappedBottomHorizontalPieceIds,
                    ].forEach(function (arr) { return (arr !== null && arr !== void 0 ? arr : []).forEach(function (pid) { if (pid)
                        result.add(pid); }); });
                });
                return Array.from(result);
            };
            // Shared helper for grouping manipulatives (used by 'group' and 'groupDiceFromMenu')
            var reassignGroupPositions = function (items, sequence, newGroupId) {
                var groupMap = {};
                var oldGroupData = items.filter(function (item) {
                    var _a;
                    return sequence.includes((_a = item.data.id) !== null && _a !== void 0 ? _a : '') ||
                        (item.data.groupId && sequence.includes(item.data.groupId));
                });
                items.forEach(function (item) {
                    var gid = item.data.groupId;
                    if (!gid)
                        return;
                    if (!groupMap[gid])
                        groupMap[gid] = [];
                    groupMap[gid].push(item);
                });
                Object.keys(groupMap).forEach(function (gid) {
                    groupMap[gid] = __spreadArray([], groupMap[gid], true).sort(function (a, b) { var _a, _b; return ((_a = a.data.groupPosition) !== null && _a !== void 0 ? _a : 0) - ((_b = b.data.groupPosition) !== null && _b !== void 0 ? _b : 0); });
                });
                var pos = 0;
                var updatedItems = structuredClone(items);
                var sequenceWithPosition = sequence
                    .map(function (token) {
                    var _a, _b;
                    if (token.startsWith('manipulativeGroup_')) {
                        var groupItems = groupMap[token] || [];
                        var minX = groupItems.length > 0
                            ? Math.min.apply(Math, groupItems.map(function (gItem) { var _a, _b; return (_b = (_a = gItem.data.center) === null || _a === void 0 ? void 0 : _a.x) !== null && _b !== void 0 ? _b : Infinity; })) : Infinity;
                        return { token: token, x: minX };
                    }
                    else {
                        var item = items.find(function (u) { return u.data.id === token; });
                        return { token: token, x: (_b = (_a = item === null || item === void 0 ? void 0 : item.data.center) === null || _a === void 0 ? void 0 : _a.x) !== null && _b !== void 0 ? _b : Infinity };
                    }
                })
                    .sort(function (a, b) { return a.x - b.x; })
                    .map(function (t) { return t.token; });
                sequenceWithPosition.forEach(function (token) {
                    if (token.startsWith('manipulativeGroup_')) {
                        var groupItems = groupMap[token] || [];
                        groupItems.forEach(function (gItem) {
                            var target = updatedItems.find(function (u) { return u.data.id === gItem.data.id; });
                            if (!target)
                                return;
                            target.data.groupPosition = pos++;
                            target.data.groupId = newGroupId;
                            target.data.beforeGroupScale = target.data.scale;
                            target.data.groupScale = 1;
                            // Clear stale groupCenter from the old group so ManipulativeGroup
                            // recomputes the wrapper position from member centers on first render
                            target.data.groupCenter = undefined;
                        });
                    }
                    else {
                        var target = updatedItems.find(function (u) { return u.data.id === token; });
                        if (!target)
                            return;
                        target.data.groupPosition = pos++;
                        target.data.groupId = newGroupId;
                        target.data.beforeGroupScale = target.data.scale;
                        target.data.groupScale = 1;
                    }
                });
                var newGroupData = updatedItems.filter(function (item) { return item.data.groupId === newGroupId; });
                return { updatedItems: updatedItems, oldGroupData: oldGroupData, newGroupData: newGroupData };
            };
            // ── Math Tool usage: whiteboard creation tools ─────────────────────────
            // Manipulatives report their own usage from ManipulativeTool; these are
            // the canvas creation tools dispatched through this handler. Tracking at
            // this single choke point keeps the "Math Tool" usage report complete
            // without instrumenting each individual case below.
            var WHITEBOARD_CREATE_TOOLS = [
                'text',
                'math',
                'lineCollapsible',
                'shapesCollapsible',
                'table',
                'shade',
            ];
            if (typeof (data === null || data === void 0 ? void 0 : data.id) === 'string' && WHITEBOARD_CREATE_TOOLS.includes(data.id)) {
                trackEvent(AnalyticsCategory.mathTool, 'open', data.id);
            }
            switch (data.id) {
                case 'lang':
                    applyLanguage(data.data === 'EN' ? 'en' : 'es');
                    break;
                // Cards Flip
                case 'flip':
                    // Handle card flip for selected cards
                    var cardFlipSelections_1 = selectedTool.filter(function (_select) { return _select.startsWith('card_'); });
                    if (cardFlipSelections_1.length > 0) {
                        var affectedDecksFlip_1 = [];
                        var _newStateFlip_1 = manipulative.map(function (_item) {
                            if (_item.data.type !== 'deck')
                                return _item;
                            // Check if any selected card belongs to this deck
                            var hasSelectedCard = _item.data.cards.some(function (_card) {
                                return cardFlipSelections_1.includes(_card.id);
                            });
                            if (!hasSelectedCard)
                                return _item;
                            var _newItem = __assign(__assign({}, _item), { data: __assign(__assign({}, _item.data), { cards: _item.data.cards.map(function (_card) {
                                        if (cardFlipSelections_1.includes(_card.id)) {
                                            return __assign(__assign({}, _card), { showImage: (_card.showImage === 'back'
                                                    ? 'front'
                                                    : 'back') });
                                        }
                                        return _card;
                                    }) }) });
                            affectedDecksFlip_1.push({ old: _item, new: _newItem });
                            return _newItem;
                        });
                        if (affectedDecksFlip_1.length === 1) {
                            newStateToSave.push({
                                type: affectedDecksFlip_1[0].new.data.id,
                                id: affectedDecksFlip_1[0].new.data.id.split('_')[1],
                                propertyName: 'cards',
                                old: JSON.stringify(affectedDecksFlip_1[0].old.data.cards),
                                new: JSON.stringify(affectedDecksFlip_1[0].new.data.cards),
                            });
                        }
                        else if (affectedDecksFlip_1.length > 1) {
                            newStateToSave.push({
                                type: 'multipleManipulatives',
                                id: 'batch',
                                propertyName: 'multipleCompleteData',
                                old: JSON.stringify(affectedDecksFlip_1.map(function (d) { return d.old; })),
                                new: JSON.stringify(affectedDecksFlip_1.map(function (d) { return d.new; })),
                            });
                        }
                        setManipulative(function () { return _newStateFlip_1; });
                        playAudio('flipCards');
                    }
                    break;
                case 'scaleMinus':
                case 'scalePlus':
                    var isPlus_1 = data.id === 'scalePlus';
                    // ── Pattern shapes scale (grouped or multi-selected) ──
                    var psSelections_1 = selectedTool.filter(function (s) { return s.startsWith('patternShapes_'); });
                    var groupSelections_2 = selectedTool.filter(function (s) { return s.startsWith('manipulativeGroup_'); });
                    var psShapesToScale = [];
                    if (groupSelections_2.length === 1) {
                        var gid_2 = groupSelections_2[0];
                        var members = manipulative.filter(function (m) { return m.data.groupId === gid_2; });
                        if (members.length > 0 && members.every(function (m) { return m.data.type === 'patternShapes'; })) {
                            psShapesToScale = members;
                        }
                    }
                    else if (groupSelections_2.length > 1) {
                        // Multiple PS groups multi-selected — collect all members from all selected groups
                        var allMembers = manipulative.filter(function (m) { return m.data.groupId != null && groupSelections_2.includes(m.data.groupId); });
                        if (allMembers.length > 0 && allMembers.every(function (m) { return m.data.type === 'patternShapes'; })) {
                            psShapesToScale = allMembers;
                        }
                    }
                    else if (psSelections_1.length > 1) {
                        // Multi-selected pattern shapes (may or may not be grouped)
                        psShapesToScale = manipulative.filter(function (m) { var _a; return psSelections_1.includes((_a = m.data.id) !== null && _a !== void 0 ? _a : ''); });
                    }
                    else if (psSelections_1.length === 1) {
                        // Single grouped pattern shape — scale the whole group
                        var singleShape = manipulative.find(function (m) { return m.data.id === psSelections_1[0]; });
                        var gid_3 = singleShape && singleShape.data.groupId;
                        if (gid_3) {
                            var members = manipulative.filter(function (m) { return m.data.groupId === gid_3; });
                            if (members.length > 1 && members.every(function (m) { return m.data.type === 'patternShapes'; })) {
                                psShapesToScale = members;
                            }
                        }
                    }
                    // ── Colored tiles group scale (also accepts linearPiece members) ──
                    var ctShapesToScale = [];
                    if (groupSelections_2.length === 1) {
                        var gid_4 = groupSelections_2[0];
                        var members = manipulative.filter(function (m) { return m.data.groupId === gid_4; });
                        if (members.length > 0 &&
                            members.every(function (m) { return m.data.type === 'coloredTiles' || m.data.type === 'linearPiece'; })) {
                            ctShapesToScale = members;
                        }
                    }
                    if (ctShapesToScale.length > 0) {
                        // Same as NMP: update data.scale directly. Both coloredTiles and linearPiece
                        // carry data.scale, so a uniform update works for either.
                        // Read scale from the first coloredTiles member — linearPiece may differ.
                        var scaleSource = (_c = ctShapesToScale.find(function (m) { return m.data.type === 'coloredTiles'; })) !== null && _c !== void 0 ? _c : ctShapesToScale[0];
                        var oldScale = (_d = scaleSource.data.scale) !== null && _d !== void 0 ? _d : 1;
                        var newScale_1 = isPlus_1
                            ? Math.min(5, Math.round((oldScale + 0.1) * 10) / 10)
                            : Math.max(0.5, Math.round((oldScale - 0.1) * 10) / 10);
                        if (newScale_1 !== oldScale) {
                            var ctIds_1 = new Set(ctShapesToScale.map(function (m) { return m.data.id; }));
                            var oldGroupData_1 = ctShapesToScale.map(function (m) { return (__assign({}, m)); });
                            // Mirror the per-side reposition logic in ColoredTiles' widget-level
                            // scale path so a snapped linearPiece in the group stays pinned to its
                            // tile's edge after rescale.
                            var WORKSPACE_CELL_SIZE_1 = 110;
                            var tilesInGroup_1 = new Map();
                            ctShapesToScale.forEach(function (m) {
                                if (m.data.type === 'coloredTiles') {
                                    tilesInGroup_1.set(m.data.id, m.data);
                                }
                            });
                            var tilesInGroupArr_1 = Array.from(tilesInGroup_1.values());
                            var findSnap_1 = function (lpId) {
                                var _a, _b, _c, _d;
                                for (var _i = 0, tilesInGroupArr_2 = tilesInGroupArr_1; _i < tilesInGroupArr_2.length; _i++) {
                                    var td = tilesInGroupArr_2[_i];
                                    var li = ((_a = td.snappedVerticalPieceIds) !== null && _a !== void 0 ? _a : []).indexOf(lpId);
                                    if (li >= 0)
                                        return { tile: td, side: 'left', slot: li };
                                    var ri = ((_b = td.snappedRightVerticalPieceIds) !== null && _b !== void 0 ? _b : []).indexOf(lpId);
                                    if (ri >= 0)
                                        return { tile: td, side: 'right', slot: ri };
                                    var ti = ((_c = td.snappedHorizontalPieceIds) !== null && _c !== void 0 ? _c : []).indexOf(lpId);
                                    if (ti >= 0)
                                        return { tile: td, side: 'top', slot: ti };
                                    var bi = ((_d = td.snappedBottomHorizontalPieceIds) !== null && _d !== void 0 ? _d : []).indexOf(lpId);
                                    if (bi >= 0)
                                        return { tile: td, side: 'bottom', slot: bi };
                                }
                                return null;
                            };
                            var repositions_1 = new Map();
                            ctShapesToScale.forEach(function (m) {
                                if (m.data.type !== 'linearPiece')
                                    return;
                                var snap = findSnap_1(m.data.id);
                                if (!snap)
                                    return;
                                var tile = snap.tile, side = snap.side, slot = snap.slot;
                                var scaledCell = WORKSPACE_CELL_SIZE_1 * newScale_1;
                                var tLeft = tile.center.x - (tile.columns * scaledCell) / 2;
                                var tTop = tile.center.y - (tile.rows * scaledCell) / 2;
                                var tRight = tLeft + tile.columns * scaledCell;
                                var tBottom = tTop + tile.rows * scaledCell;
                                if (side === 'left') {
                                    repositions_1.set(m.data.id, {
                                        x: tLeft - 22 * newScale_1,
                                        y: tTop + slot * scaledCell + scaledCell / 2,
                                    });
                                }
                                else if (side === 'right') {
                                    repositions_1.set(m.data.id, {
                                        x: tRight + 22 * newScale_1,
                                        y: tTop + slot * scaledCell + scaledCell / 2,
                                    });
                                }
                                else if (side === 'top') {
                                    repositions_1.set(m.data.id, {
                                        x: tLeft + slot * scaledCell + scaledCell / 2,
                                        y: tTop - 21 * newScale_1,
                                    });
                                }
                                else {
                                    repositions_1.set(m.data.id, {
                                        x: tLeft + slot * scaledCell + scaledCell / 2,
                                        y: tBottom + 21 * newScale_1,
                                    });
                                }
                            });
                            var _newStateCTScale_1 = manipulative.map(function (item) {
                                if (!ctIds_1.has(item.data.id))
                                    return item;
                                var newCenter = item.data.id ? repositions_1.get(item.data.id) : undefined;
                                if (newCenter) {
                                    return __assign(__assign({}, item), { data: __assign(__assign({}, item.data), { scale: newScale_1, center: newCenter }) });
                                }
                                return __assign(__assign({}, item), { data: __assign(__assign({}, item.data), { scale: newScale_1 }) });
                            });
                            newStateToSave.push({
                                type: 'multipleManipulatives',
                                id: 'batch',
                                propertyName: 'multipleCompleteData',
                                old: JSON.stringify(oldGroupData_1),
                                new: JSON.stringify(_newStateCTScale_1.filter(function (m) { return ctIds_1.has(m.data.id); })),
                            });
                            setManipulative(function () { return _newStateCTScale_1; });
                        }
                        break;
                    }
                    if (psShapesToScale.length > 1) {
                        var oldScale = (_e = psShapesToScale[0].data.scale) !== null && _e !== void 0 ? _e : 1;
                        var newScale_2 = isPlus_1
                            ? Math.min(5, Math.round((oldScale + 0.1) * 10) / 10)
                            : Math.max(0.5, Math.round((oldScale - 0.1) * 10) / 10);
                        if (newScale_2 !== oldScale) {
                            var scaleFactor_1 = newScale_2 / oldScale;
                            var sumX_1 = 0, sumY_1 = 0;
                            psShapesToScale.forEach(function (m) {
                                var d = m.data;
                                var b = SHAPE_BOUNDS[d.shapeType] || {
                                    x: 0,
                                    y: 0,
                                    w: UNIT,
                                    h: UNIT,
                                };
                                sumX_1 += d.center.x + b.w / 2;
                                sumY_1 += d.center.y + b.h / 2;
                            });
                            var gcx_1 = sumX_1 / psShapesToScale.length;
                            var gcy_1 = sumY_1 / psShapesToScale.length;
                            var psIds_1 = new Set(psShapesToScale.map(function (m) { return m.data.id; }));
                            var oldGroupData_2 = psShapesToScale.map(function (m) { return (__assign({}, m)); });
                            var _newStatePSScale_1 = manipulative.map(function (item) {
                                if (!psIds_1.has(item.data.id))
                                    return item;
                                var d = item.data;
                                var b = SHAPE_BOUNDS[d.shapeType] || {
                                    x: 0,
                                    y: 0,
                                    w: UNIT,
                                    h: UNIT,
                                };
                                var oldVcx = d.center.x + b.w / 2;
                                var oldVcy = d.center.y + b.h / 2;
                                var newVcx = gcx_1 + (oldVcx - gcx_1) * scaleFactor_1;
                                var newVcy = gcy_1 + (oldVcy - gcy_1) * scaleFactor_1;
                                return __assign(__assign({}, item), { data: __assign(__assign({}, item.data), { scale: newScale_2, center: { x: newVcx - b.w / 2, y: newVcy - b.h / 2 } }) });
                            });
                            newStateToSave.push({
                                type: 'multipleManipulatives',
                                id: 'batch',
                                propertyName: 'multipleCompleteData',
                                old: JSON.stringify(oldGroupData_2),
                                new: JSON.stringify(_newStatePSScale_1.filter(function (m) { return psIds_1.has(m.data.id); })),
                            });
                            setManipulative(function () { return _newStatePSScale_1; });
                        }
                        break;
                    }
                    // ── NMP group scale ──
                    // Scale all NMP pieces on the canvas (not just group members) to stay in sync,
                    // matching the solo-scale behavior where all same-type pieces scale together.
                    var nmpShapesToScale = [];
                    if (groupSelections_2.length === 1) {
                        var gid_5 = groupSelections_2[0];
                        var members = manipulative.filter(function (m) { return m.data.groupId === gid_5; });
                        if (members.length > 0 &&
                            members.every(function (m) { return m.data.type === 'numberPiece' || m.data.type === 'moneyPiece'; })) {
                            nmpShapesToScale = manipulative.filter(function (m) { return m.data.type === 'numberPiece' || m.data.type === 'moneyPiece'; });
                        }
                    }
                    if (nmpShapesToScale.length > 0) {
                        var oldScale_1 = (_f = nmpShapesToScale[0].data.scale) !== null && _f !== void 0 ? _f : 1;
                        var newScale_3 = isPlus_1
                            ? Math.min(5, Math.round((oldScale_1 + 0.1) * 10) / 10)
                            : Math.max(0.5, Math.round((oldScale_1 - 0.1) * 10) / 10);
                        if (newScale_3 !== oldScale_1) {
                            var nmpIds_1 = new Set(nmpShapesToScale.map(function (m) { return m.data.id; }));
                            var oldGroupData_3 = nmpShapesToScale.map(function (m) { return (__assign({}, m)); });
                            // Reposition snapped clusters so pieces stay touching after scale.
                            // Use proximity-based clustering (not snappedId) so this works even after
                            // a group drag that clears snappedId.
                            var PIECE_GRID_VAL_1 = 55;
                            var clusterPositionUpdates_1 = new Map();
                            var oldStep_1 = PIECE_GRID_VAL_1 * oldScale_1;
                            var newStep_1 = PIECE_GRID_VAL_1 * newScale_3;
                            var TOL = 2;
                            // Build clusters via union-find on proximity
                            var nmpArr = nmpShapesToScale.map(function (m) {
                                var _a;
                                var d = m.data;
                                var dims = (_a = d.defaultDimensions) !== null && _a !== void 0 ? _a : {
                                    width: PIECE_GRID_VAL_1,
                                    height: PIECE_GRID_VAL_1,
                                };
                                var w = dims.width * oldScale_1;
                                var h = dims.height * oldScale_1;
                                return {
                                    id: m.data.id,
                                    d: d,
                                    dims: dims,
                                    tlX: d.center.x - w / 2,
                                    tlY: d.center.y - h / 2,
                                    w: w,
                                    h: h,
                                };
                            });
                            // Union-find helpers
                            var parent_1 = {};
                            nmpArr.forEach(function (n) {
                                parent_1[n.id] = n.id;
                            });
                            var find_1 = function (x) {
                                if (parent_1[x] !== x)
                                    parent_1[x] = find_1(parent_1[x]);
                                return parent_1[x];
                            };
                            var union = function (a, b) {
                                parent_1[find_1(a)] = find_1(b);
                            };
                            // Connect pieces that are grid-aligned to each other
                            for (var i = 0; i < nmpArr.length; i++) {
                                for (var j = i + 1; j < nmpArr.length; j++) {
                                    var a = nmpArr[i], b = nmpArr[j];
                                    if (a.d.type !== b.d.type)
                                        continue;
                                    var hOverlap = a.tlX < b.tlX + b.w + TOL && a.tlX + a.w > b.tlX - TOL;
                                    var vOverlap = a.tlY < b.tlY + b.h + TOL && a.tlY + a.h > b.tlY - TOL;
                                    if (!hOverlap || !vOverlap)
                                        continue;
                                    var dx = a.tlX - b.tlX;
                                    var dy = a.tlY - b.tlY;
                                    var xAligned = Math.abs(Math.round(dx / oldStep_1) * oldStep_1 - dx) < TOL;
                                    var yAligned = Math.abs(Math.round(dy / oldStep_1) * oldStep_1 - dy) < TOL;
                                    if (xAligned && yAligned)
                                        union(a.id, b.id);
                                }
                            }
                            // Group by cluster root
                            var clusters_1 = new Map();
                            nmpArr.forEach(function (n) {
                                var root = find_1(n.id);
                                if (!clusters_1.has(root))
                                    clusters_1.set(root, []);
                                clusters_1.get(root).push(n);
                            });
                            clusters_1.forEach(function (clusterMembers) {
                                if (clusterMembers.length < 2)
                                    return;
                                clusterMembers.sort(function (a, b) { return a.tlY - b.tlY || a.tlX - b.tlX; });
                                var anchor = clusterMembers[0];
                                var anchorNewTLX = anchor.d.center.x - (anchor.dims.width * newScale_3) / 2;
                                var anchorNewTLY = anchor.d.center.y - (anchor.dims.height * newScale_3) / 2;
                                clusterMembers.slice(1).forEach(function (_a) {
                                    var mid = _a.id, tlX = _a.tlX, tlY = _a.tlY, dims = _a.dims;
                                    var gx = Math.round((tlX - anchor.tlX) / oldStep_1);
                                    var gy = Math.round((tlY - anchor.tlY) / oldStep_1);
                                    clusterPositionUpdates_1.set(mid, {
                                        x: anchorNewTLX + gx * newStep_1 + (dims.width * newScale_3) / 2,
                                        y: anchorNewTLY + gy * newStep_1 + (dims.height * newScale_3) / 2,
                                    });
                                });
                            });
                            newStateToSave.push({
                                type: 'multipleManipulatives',
                                id: 'batch',
                                propertyName: 'multipleCompleteData',
                                old: JSON.stringify(oldGroupData_3),
                                new: JSON.stringify(nmpShapesToScale.map(function (m) { return (__assign(__assign({}, m), { data: __assign(__assign(__assign({}, m.data), { scale: newScale_3 }), (clusterPositionUpdates_1.has(m.data.id) && {
                                        center: clusterPositionUpdates_1.get(m.data.id),
                                    })) })); })),
                            });
                            setManipulative(function (prev) {
                                return prev.map(function (item) {
                                    if (!nmpIds_1.has(item.data.id))
                                        return item;
                                    var newCenter = clusterPositionUpdates_1.get(item.data.id);
                                    return __assign(__assign({}, item), { data: __assign(__assign(__assign({}, item.data), { scale: newScale_3 }), (newCenter && { center: newCenter })) });
                                });
                            });
                        }
                        break;
                    }
                    var deckSelections_1 = selectedTool.filter(function (s) { return s.startsWith('deck_'); });
                    var cardSelections_1 = selectedTool.filter(function (s) { return s.startsWith('card_'); });
                    // Only apply to deck and card manipulatives
                    if (deckSelections_1.length === 0 && cardSelections_1.length === 0)
                        break;
                    var affectedDecksScale_1 = [];
                    var _newStateScale_1 = manipulative.map(function (item) {
                        var _a;
                        if (item.data.type !== 'deck')
                            return item;
                        // Deck selected → scale deck + all cards
                        if (deckSelections_1.includes(item.data.id)) {
                            var oldScale = (_a = item.data.scale) !== null && _a !== void 0 ? _a : 1;
                            var newScale_4 = isPlus_1 ? oldScale + 0.1 : Math.max(0.5, oldScale - 0.1);
                            if (newScale_4 === oldScale)
                                return item;
                            var _newItem_1 = __assign(__assign({}, item), { data: __assign(__assign({}, item.data), { scale: newScale_4, cards: item.data.cards.map(function (c) { return (__assign(__assign({}, c), { scale: newScale_4 })); }) }) });
                            affectedDecksScale_1.push({ old: item, new: _newItem_1 });
                            return _newItem_1;
                        }
                        // Card selected → scale only selected cards
                        var hasSelectedCard = item.data.cards.some(function (c) { return cardSelections_1.includes(c.id); });
                        if (!hasSelectedCard)
                            return item;
                        var _newItem = __assign(__assign({}, item), { data: __assign(__assign({}, item.data), { cards: item.data.cards.map(function (c) {
                                    var _a, _b;
                                    if (!cardSelections_1.includes(c.id))
                                        return c;
                                    var oldCardScale = (_b = (_a = c.scale) !== null && _a !== void 0 ? _a : item.data.scale) !== null && _b !== void 0 ? _b : 1;
                                    var newCardScale = isPlus_1
                                        ? oldCardScale + 0.1
                                        : Math.max(0.5, oldCardScale - 0.1);
                                    return __assign(__assign({}, c), { scale: newCardScale });
                                }) }) });
                        affectedDecksScale_1.push({ old: item, new: _newItem });
                        return _newItem;
                    });
                    if (affectedDecksScale_1.length === 1) {
                        newStateToSave.push({
                            type: affectedDecksScale_1[0].new.data.id,
                            id: affectedDecksScale_1[0].new.data.id.split('_')[1],
                            propertyName: 'completeData',
                            old: JSON.stringify(affectedDecksScale_1[0].old.data),
                            new: JSON.stringify(affectedDecksScale_1[0].new.data),
                        });
                    }
                    else if (affectedDecksScale_1.length > 1) {
                        newStateToSave.push({
                            type: 'multipleManipulatives',
                            id: 'batch',
                            propertyName: 'multipleCompleteData',
                            old: JSON.stringify(affectedDecksScale_1.map(function (d) { return d.old; })),
                            new: JSON.stringify(affectedDecksScale_1.map(function (d) { return d.new; })),
                        });
                    }
                    setManipulative(function () { return _newStateScale_1; });
                    // Announce scale change for cards
                    if (affectedDecksScale_1.length > 0) {
                        var scaledItem = affectedDecksScale_1[0].new;
                        var newScale = (_g = scaledItem.data.scale) !== null && _g !== void 0 ? _g : 1;
                        var name_1 = deckSelections_1.length > 0 ? t('text.manipulativeCardDeck') : t('text.playingCard');
                        announce(t('text.manipulativeScaled', {
                            name: name_1,
                            direction: isPlus_1 ? t('text.up') : t('text.down'),
                            value: newScale.toFixed(1),
                        }));
                    }
                    break;
                // Cards Stack
                case 'stack':
                    // Handle card stack for selected cards
                    var cardStackSelections_1 = selectedTool.filter(function (_select) { return _select.startsWith('card_'); });
                    if (cardStackSelections_1.length > 0) {
                        var affectedDecksStack_1 = [];
                        var _newStateStack_1 = manipulative.map(function (_item) {
                            if (_item.data.type !== 'deck')
                                return _item;
                            var cards = _item.data.cards;
                            // Check if any selected card belongs to this deck
                            var hasSelectedCard = cards.some(function (_card) { return cardStackSelections_1.includes(_card.id); });
                            if (!hasSelectedCard)
                                return _item;
                            // Separate selected and non-selected cards
                            var selectedCards = cards.filter(function (_card) { return cardStackSelections_1.includes(_card.id); });
                            var nonSelectedCards = cards.filter(function (_card) { return !cardStackSelections_1.includes(_card.id); });
                            // Update selected cards to stack position
                            var updatedSelectedCards = selectedCards.map(function (_card) { return (__assign(__assign({}, _card), { showImage: 'front', position: { x: 0, y: 0 }, placedOnDeck: false })); });
                            // Put selected cards on top (at the beginning)
                            var reorderedCards = __spreadArray(__spreadArray([], updatedSelectedCards, true), nonSelectedCards, true);
                            var _newItem = __assign(__assign({}, _item), { data: __assign(__assign({}, _item.data), { cards: reorderedCards }) });
                            affectedDecksStack_1.push({ old: _item, new: _newItem });
                            return _newItem;
                        });
                        if (affectedDecksStack_1.length === 1) {
                            newStateToSave.push({
                                type: affectedDecksStack_1[0].new.data.id,
                                id: affectedDecksStack_1[0].new.data.id.split('_')[1],
                                propertyName: 'completeData',
                                old: JSON.stringify(affectedDecksStack_1[0].old.data),
                                new: JSON.stringify(affectedDecksStack_1[0].new.data),
                            });
                        }
                        else if (affectedDecksStack_1.length > 1) {
                            newStateToSave.push({
                                type: 'multipleManipulatives',
                                id: 'batch',
                                propertyName: 'multipleCompleteData',
                                old: JSON.stringify(affectedDecksStack_1.map(function (d) { return d.old; })),
                                new: JSON.stringify(affectedDecksStack_1.map(function (d) { return d.new; })),
                            });
                        }
                        setManipulative(function () { return _newStateStack_1; });
                        playAudio('cardStack');
                        setSelectedTool([]);
                    }
                    break;
                case 'group':
                    {
                        // Check if we are grouping a single unmerged coloredTile representation
                        if (selectedTool.length === 1 && selectedTool[0].startsWith('coloredTiles_')) {
                            var targetIdx_1 = manipulative.findIndex(function (m) { return m.data.id === selectedTool[0]; });
                            if (targetIdx_1 !== -1) {
                                var oldTarget = manipulative[targetIdx_1];
                                var ctData = oldTarget.data;
                                if (!ctData.isGroup) {
                                    var newTarget_1 = __assign(__assign({}, oldTarget), { data: __assign(__assign({}, ctData), { isGroup: true }) });
                                    newStateToSave.push({
                                        type: ctData.id,
                                        id: ctData.id.split('_')[1],
                                        propertyName: 'completeData',
                                        old: JSON.stringify(ctData),
                                        new: JSON.stringify(newTarget_1.data),
                                    });
                                    setManipulative(function (prev) {
                                        var next = __spreadArray([], prev, true);
                                        next[targetIdx_1] = newTarget_1;
                                        return next;
                                    });
                                    break; // Handled 'group' for coloredTiles explicitly
                                }
                            }
                        }
                    }
                    var groupId_1 = "manipulativeGroup_".concat(uuidv4().replace(/-/g, ''));
                    // Pull snapped LinearPieces into the group so they move/scale with it.
                    var groupSequence = expandWithSnappedLinearPieces(selectedTool, manipulative);
                    // Pre-compute group data from current state (before the updater)
                    var _o = reassignGroupPositions(manipulative, groupSequence, groupId_1), groupedItems_1 = _o.updatedItems, oldGroupData = _o.oldGroupData, newGroupData = _o.newGroupData;
                    newStateToSave.push({
                        type: groupId_1,
                        id: groupId_1.split('_')[1],
                        propertyName: 'completeData',
                        old: JSON.stringify(oldGroupData),
                        new: JSON.stringify(newGroupData),
                    });
                    setManipulative(function () { return __spreadArray([], groupedItems_1, true); });
                    // Auto-select the new group if all members are pattern shapes or NMP (immediate visual feedback)
                    var allNmpOrPsOrCt = groupedItems_1
                        .filter(function (i) { return i.data.groupId === groupId_1; })
                        .every(function (i) {
                        return i.data.type === 'patternShapes' ||
                            i.data.type === 'numberPiece' ||
                            i.data.type === 'moneyPiece' ||
                            i.data.type === 'coloredTiles' ||
                            i.data.type === 'linearPiece' ||
                            i.data.type === 'coinsAndCounters' ||
                            i.data.type === 'fractionTiles';
                    });
                    setSelectedTool(allNmpOrPsOrCt ? [groupId_1] : []);
                    break;
                case 'ungroup': {
                    if (selectedTool.length === 1 && selectedTool[0].startsWith('coloredTiles_')) {
                        var targetIdx_2 = manipulative.findIndex(function (m) { return m.data.id === selectedTool[0]; });
                        if (targetIdx_2 !== -1) {
                            var oldTarget = manipulative[targetIdx_2];
                            var ctData = oldTarget.data;
                            if (ctData.isGroup === true) {
                                var newTarget_2 = __assign(__assign({}, oldTarget), { data: __assign(__assign({}, ctData), { isGroup: false }) });
                                newStateToSave.push({
                                    type: ctData.id,
                                    id: ctData.id.split('_')[1],
                                    propertyName: 'completeData',
                                    old: JSON.stringify(ctData),
                                    new: JSON.stringify(newTarget_2.data),
                                });
                                setManipulative(function (prev) {
                                    var next = __spreadArray([], prev, true);
                                    next[targetIdx_2] = newTarget_2;
                                    return next;
                                });
                                break; // Handled 'ungroup' for coloredTiles explicitly
                            }
                        }
                    }
                    // Pre-compute ungroup data from current state (before the updater)
                    var _oldUngroupData_1 = [];
                    var _newUngroupData_1 = [];
                    var _ungroupId_1 = '';
                    manipulative.forEach(function (item) {
                        var _a, _b, _c;
                        if (item.data.groupId && selectedTool.includes(item.data.groupId)) {
                            _ungroupId_1 = item.data.groupId;
                            _oldUngroupData_1.push(item);
                            var ungroupedScale = item.type === 'numberPiece' ||
                                item.type === 'moneyPiece' ||
                                item.type === 'coloredTiles' ||
                                item.type === 'linearPiece' ||
                                item.type === 'patternShapes' ||
                                item.type === 'fractionTiles'
                                ? ((_a = item.data.scale) !== null && _a !== void 0 ? _a : 1)
                                : ((_b = item.data.beforeGroupScale) !== null && _b !== void 0 ? _b : 1) * ((_c = item.data.groupScale) !== null && _c !== void 0 ? _c : 1);
                            _newUngroupData_1.push(__assign(__assign({}, item), { data: __assign(__assign({}, item.data), { scale: ungroupedScale, groupId: undefined, groupPosition: undefined, beforeGroupScale: undefined, groupScale: undefined, groupCenter: undefined }) }));
                        }
                    });
                    if (_ungroupId_1 !== '' && _oldUngroupData_1.length > 0 && _newUngroupData_1.length > 0) {
                        newStateToSave.push({
                            type: _ungroupId_1,
                            id: _ungroupId_1.split('_')[1],
                            propertyName: 'completeData',
                            old: JSON.stringify(_oldUngroupData_1),
                            new: JSON.stringify(_newUngroupData_1),
                        });
                    }
                    var ungroupIdsToUpdate_1 = new Set(_oldUngroupData_1.map(function (item) { return item.data.id; }));
                    var newUngroupMap_1 = new Map(_newUngroupData_1.map(function (item) { return [item.data.id, item]; }));
                    setManipulative(function (prev) {
                        return prev.map(function (item) {
                            var _a;
                            if (ungroupIdsToUpdate_1.has(item.data.id)) {
                                return (_a = newUngroupMap_1.get(item.data.id)) !== null && _a !== void 0 ? _a : item;
                            }
                            return item;
                        });
                    });
                    // For PS groups: focus the first ungrouped member instead of clearing selection
                    var isPSUngroup = _newUngroupData_1.length > 0 &&
                        _newUngroupData_1.every(function (m) { return m.data.type === 'patternShapes'; });
                    if (isPSUngroup && _newUngroupData_1[0].data.id) {
                        var firstId_1 = _newUngroupData_1[0].data.id;
                        setSelectedTool([firstId_1]);
                        setTimeout(function () {
                            var el = document.querySelector("[data-manipulative-id=\"".concat(firstId_1, "\"]"));
                            if (el)
                                el.focus();
                        }, 100);
                    }
                    else {
                        setSelectedTool([]);
                    }
                    break;
                }
                case 'groupDiceFromMenu': {
                    var diceIds = (_h = data.diceIds) !== null && _h !== void 0 ? _h : [];
                    if (diceIds.length < 2)
                        break;
                    // Pull snapped LinearPieces into the group so they move/scale with it.
                    var menuGroupSequence_1 = expandWithSnappedLinearPieces(diceIds, manipulative);
                    var menuGroupId_1 = "manipulativeGroup_".concat(uuidv4().replace(/-/g, ''));
                    var _p = reassignGroupPositions(manipulative, menuGroupSequence_1, menuGroupId_1), menuGroupedItems = _p.updatedItems, menuOldGroupData = _p.oldGroupData, menuNewGroupData = _p.newGroupData;
                    newStateToSave.push({
                        type: menuGroupId_1,
                        id: menuGroupId_1.split('_')[1],
                        propertyName: 'completeData',
                        old: JSON.stringify(menuOldGroupData),
                        new: JSON.stringify(menuNewGroupData),
                    });
                    var menuGroupedUnlocked_1 = menuGroupedItems.map(function (item) {
                        var _a;
                        return item.data.id != null && menuGroupSequence_1.includes(item.data.id)
                            ? __assign(__assign({}, item), { data: __assign(__assign({}, item.data), { lock: __assign(__assign({}, ((_a = item.data.lock) !== null && _a !== void 0 ? _a : { positioning: false, editing: false })), { positioning: false }) }) }) : item;
                    });
                    setManipulative(function () { return __spreadArray([], menuGroupedUnlocked_1, true); });
                    setSelectedTool([menuGroupId_1]);
                    // Delay focus until after the browser restores focus to the previously-focused element
                    // (which happens asynchronously when the context menu unmounts).
                    {
                        var allMenuCc_1 = menuGroupedItems
                            .filter(function (i) { return i.data.groupId === menuGroupId_1; })
                            .every(function (i) { return i.data.type === 'coinsAndCounters'; });
                        setTimeout(function () {
                            if (allMenuCc_1) {
                                customEventHandler.dispatchEvent('focusCcGroup', { groupId: menuGroupId_1 });
                            }
                            else {
                                customEventHandler.dispatchEvent('focusPsGroup', { groupId: menuGroupId_1 });
                            }
                        }, 150);
                    }
                    break;
                }
                case 'ungroupDiceFromMenu': {
                    var targetGroupId_1 = (_j = data.groupId) !== null && _j !== void 0 ? _j : '';
                    if (!targetGroupId_1)
                        break;
                    var _oldUngroupMenuData_1 = [];
                    var _newUngroupMenuData_1 = [];
                    manipulative.forEach(function (item) {
                        var _a, _b, _c;
                        if (item.data.groupId && item.data.groupId === targetGroupId_1) {
                            _oldUngroupMenuData_1.push(item);
                            var ungroupedScale = item.type === 'numberPiece' ||
                                item.type === 'moneyPiece' ||
                                item.type === 'coloredTiles' ||
                                item.type === 'linearPiece' ||
                                item.type === 'patternShapes' ||
                                item.type === 'coinsAndCounters'
                                ? ((_a = item.data.scale) !== null && _a !== void 0 ? _a : 1)
                                : ((_b = item.data.beforeGroupScale) !== null && _b !== void 0 ? _b : 1) * ((_c = item.data.groupScale) !== null && _c !== void 0 ? _c : 1);
                            _newUngroupMenuData_1.push(__assign(__assign({}, item), { data: __assign(__assign({}, item.data), { scale: ungroupedScale, groupId: undefined, groupPosition: undefined, beforeGroupScale: undefined, groupScale: undefined, groupCenter: undefined }) }));
                        }
                    });
                    if (targetGroupId_1 && _oldUngroupMenuData_1.length > 0 && _newUngroupMenuData_1.length > 0) {
                        newStateToSave.push({
                            type: targetGroupId_1,
                            id: targetGroupId_1.split('_')[1],
                            propertyName: 'completeData',
                            old: JSON.stringify(_oldUngroupMenuData_1),
                            new: JSON.stringify(_newUngroupMenuData_1),
                        });
                    }
                    var ungroupMenuIdsToUpdate_1 = new Set(_oldUngroupMenuData_1.map(function (item) { return item.data.id; }));
                    var newUngroupMenuMap_1 = new Map(_newUngroupMenuData_1.map(function (item) { return [item.data.id, item]; }));
                    setManipulative(function (prev) {
                        return prev.map(function (item) {
                            var _a;
                            if (ungroupMenuIdsToUpdate_1.has(item.data.id)) {
                                return (_a = newUngroupMenuMap_1.get(item.data.id)) !== null && _a !== void 0 ? _a : item;
                            }
                            return item;
                        });
                    });
                    setSelectedTool([]);
                    break;
                }
                case 'undo':
                    executeUndo({
                        setDrawCommands: setDrawCommands,
                        setAnnotations: setAnnotations,
                        setText: setText,
                        setShades: setShades,
                        setManipulative: setManipulative,
                        setTable: setTable,
                    });
                    setSelectedTool([]);
                    customEventHandler.dispatchEvent('stateChanged', { type: 'undo' });
                    break;
                case 'redo':
                    executeRedo({
                        setDrawCommands: setDrawCommands,
                        setAnnotations: setAnnotations,
                        setText: setText,
                        setShades: setShades,
                        setManipulative: setManipulative,
                        setTable: setTable,
                    });
                    setSelectedTool([]);
                    customEventHandler.dispatchEvent('stateChanged', { type: 'redo' });
                    break;
                case 'reload':
                case 'reset':
                    setShowResetModal(true);
                    break;
                case 'shapesCollapsible': {
                    setTool(leftSideTools.selection);
                    var _saveData = drawAnnotations(data);
                    if (_saveData !== null) {
                        newStateToSave.push({
                            type: 'annotations',
                            id: annotations.length,
                            propertyName: 'create',
                            old: JSON.stringify(_saveData),
                        });
                    }
                    break;
                }
                case 'selection':
                    setTool(leftSideTools.selection);
                    break;
                case 'text':
                    setTool(leftSideTools.selection);
                    setText(function (text) {
                        setSelectedTool(['text_' + text.length]);
                        var _a = getPositionForNewItem(), newX = _a.x, newY = _a.y;
                        var _saveData = {
                            text: '',
                            color: ColorEnum[color],
                            lineWidth: 300,
                            height: 100,
                            size: 30,
                            rotation: 0,
                            lock: {
                                positioning: false,
                                editing: false,
                            },
                            position: {
                                x: newX,
                                y: newY,
                                z: 0,
                            },
                        };
                        return __spreadArray(__spreadArray([], text, true), [
                            {
                                type: 'text',
                                data: _saveData,
                            },
                        ], false);
                    });
                    break;
                case 'math':
                    setText(function (text) {
                        setSelectedTool(['text_' + text.length]);
                        var _a = getPositionForNewItem(), newX = _a.x, newY = _a.y;
                        var _saveData = {
                            text: '',
                            color: ColorEnum[color],
                            lineWidth: 300,
                            height: 100,
                            size: 30,
                            rotation: 0,
                            lock: {
                                positioning: false,
                                editing: false,
                            },
                            position: {
                                x: newX,
                                y: newY,
                                z: 0,
                            },
                        };
                        return __spreadArray(__spreadArray([], text, true), [
                            {
                                type: 'equation',
                                data: _saveData,
                            },
                        ], false);
                    });
                    break;
                case 'lineCollapsible':
                    var _q = getPositionForNewItem(), lineX = _q.x, lineY = _q.y;
                    var _saveDataLine_1 = {
                        type: 'line',
                        data: {
                            points: [
                                {
                                    x: lineX,
                                    y: lineY,
                                },
                                {
                                    x: lineX + 200,
                                    y: lineY,
                                },
                            ],
                            arrowheadStyle: {
                                start: data.data > 1 ? 'arrow' : '',
                                end: data.data > 0 ? 'arrow' : '',
                            },
                            color: ColorEnum[color],
                            thickness: thicknessRef.current,
                        },
                    };
                    newStateToSave.push({
                        type: 'annotations',
                        id: annotations.length,
                        propertyName: 'create',
                        old: JSON.stringify(_saveDataLine_1),
                    });
                    {
                        var lineTypeKey = data.data > 1
                            ? 'text.doubleArrowLineCreated'
                            : data.data > 0
                                ? 'text.arrowLineCreated'
                                : 'text.lineCreated';
                        // Capture newId BEFORE the updater (annotations.length is current)
                        var newId_1 = "annotations_".concat(annotations.length);
                        setAnnotations(function (_ann) { return __spreadArray(__spreadArray([], _ann, true), [_saveDataLine_1], false); });
                        announce(t(lineTypeKey));
                        setTimeout(function () {
                            setSelectedTool([newId_1]);
                        }, 400);
                    }
                    break;
                case 'table':
                    setTool(leftSideTools.selection);
                    setTablePopup(true);
                    break;
                case 'shade':
                    setTool(leftSideTools.selection);
                    var _r = getPositionForNewItem(), shadeX_1 = _r.x, shadeY_1 = _r.y;
                    var newShadeId_1 = "id_".concat(uuidv4().replace(/-/g, ''));
                    setShades(function (prev) {
                        var newShade = {
                            id: newShadeId_1,
                            type: 'shade',
                            data: {
                                position: {
                                    x: shadeX_1,
                                    y: shadeY_1,
                                    z: 0,
                                },
                                dimensions: {
                                    width: 359,
                                    height: 183,
                                },
                                revealed: false,
                            },
                        };
                        saveState({
                            type: 'shades',
                            id: String(prev.length),
                            propertyName: 'create',
                            old: JSON.stringify(newShade),
                        });
                        customEventHandler.dispatchEvent('stateChanged', { type: 'save' });
                        announce(t('text.shadeAddedAnnouncement'));
                        // Defer setSelectedTool to avoid setState-during-render warning
                        var shadeIdx = prev.length;
                        queueMicrotask(function () { return setSelectedTool(["shades_".concat(newShadeId_1, "_").concat(shadeIdx)]); });
                        // Move keyboard / screen-reader focus onto the newly created
                        // shade. Shades.tsx renders the focusable inner div with
                        // id={`${data.id}_${index}`} and tabIndex=0.
                        var focusableId = "".concat(newShadeId_1, "_").concat(shadeIdx);
                        var focusShade = function () {
                            var target = document.getElementById(focusableId);
                            if (target) {
                                target.focus();
                                return true;
                            }
                            return false;
                        };
                        requestAnimationFrame(function () {
                            if (!focusShade())
                                setTimeout(focusShade, 100);
                        });
                        return __spreadArray(__spreadArray([], prev, true), [newShade], false);
                    });
                    break;
                case 'keys':
                    setShowEnterKeyModal(function (prev) { return !prev; });
                    break;
                case 'share':
                    setShowShareModal(function (prev) { return !prev; });
                    break;
                case 'save':
                    setShowSaveModal(function (prev) { return !prev; });
                    break;
                case 'viewEditMode':
                    var nextMode = data.data === 'left' ? 'view' : 'edit';
                    // Reminder: when a user switches view→edit on someone else's share
                    // code, prompt them to save their edits (it isn't theirs to change
                    // in place). Never shown on your own code — toggling view/edit there
                    // is free. The popup carries a "don't remind me again" checkbox,
                    // persisted in localStorage. Read via refs so the closure isn't
                    // pinned to initial flag values (isAdmin settles after checkAuth).
                    if (nextMode === 'edit' &&
                        !!shareCodeRef.current &&
                        !isAdminRef.current &&
                        !isSaveEditsReminderSuppressed()) {
                        setShowSaveEditsReminder(true);
                    }
                    setViewEditMode(nextMode);
                    trackEvent(AnalyticsCategory.mode, 'switch', nextMode);
                    break;
            }
            // For delete/duplicate: fall back to data.id when _newItem is undefined
            // (context menu and keyboard shortcuts send { id: 'delete'/'duplicate' } without _newItem)
            // Do NOT use data.id fallback for other cases — 'edit' re-dispatches bottomPanel causing infinite loop
            var switchId = (_k = _newItem === null || _newItem === void 0 ? void 0 : _newItem.id) !== null && _k !== void 0 ? _k : (data.id === 'delete' || data.id === 'duplicate' ? data.id : undefined);
            // ── Math Tool usage: drawing tools (pen / highlighter / eraser) ────────
            var DRAWING_TOOLS = ['pen', 'pencil', 'highlighter', 'erase', 'eraseAll'];
            if (typeof switchId === 'string' && DRAWING_TOOLS.includes(switchId)) {
                trackEvent(AnalyticsCategory.mathTool, 'open', switchId);
            }
            switch (switchId) {
                case 'pen':
                    setTool(leftSideTools.pen);
                    if (drawingCanvas) {
                        drawingCanvas.style.cursor = "url('./assets/images/pencil/pencil_normal.svg') 10 32, auto";
                    }
                    break;
                case 'highlighter':
                    setTool(leftSideTools.highlighter);
                    if (drawingCanvas) {
                        drawingCanvas.style.cursor = "url('./assets/images/highlighter/highlighter_normal.svg') 10 32, auto";
                    }
                    break;
                case 'erase':
                    setTool(leftSideTools.eraser);
                    if (drawingCanvas) {
                        drawingCanvas.style.cursor = "url('./assets/images/eraser_normal.svg') 25 32, auto";
                    }
                    break;
                case 'eraseAll':
                    setTool(leftSideTools.eraserAll);
                    break;
                case 'duplicate':
                    // Force MathEditor to sync its DOM content to state before reading
                    customEventHandler.dispatchEvent('forceSync', {});
                    var annotationDupMsg_1 = '';
                    var newSelectedIds_1 = [];
                    var textDuplicates_1 = [];
                    var annotationDuplicates_1 = [];
                    var shadesDuplicates_1 = [];
                    var tableDuplicates_1 = [];
                    selectedTool.forEach(function (_select) {
                        if (_select.startsWith('tableText_')) {
                            var pos = Number(_select.split('_')[1]);
                            if (!Number.isNaN(pos)) {
                                tableDuplicates_1.push({ select: _select, index: pos });
                            }
                        }
                        else if (_select.startsWith('text') || _select.startsWith('mathtext')) {
                            var pos = Number(_select.split('_')[1]);
                            if (!Number.isNaN(pos)) {
                                textDuplicates_1.push({ select: _select, index: pos });
                            }
                        }
                        else if (_select.startsWith('annotation')) {
                            var pos = Number(_select.split('_')[1]);
                            if (!Number.isNaN(pos)) {
                                annotationDuplicates_1.push({ select: _select, index: pos });
                            }
                        }
                        else if (_select.startsWith('shades')) {
                            var _splitedShade = _select.split('_');
                            var _shadeIndx = +_splitedShade[_splitedShade.length - 1];
                            if (!Number.isNaN(_shadeIndx)) {
                                shadesDuplicates_1.push({ select: _select, index: _shadeIndx });
                            }
                        }
                        else if (_select.startsWith('dice_') ||
                            _select.startsWith('deck') ||
                            _select.startsWith('manipulativeGroup') ||
                            _select.startsWith('spinner') ||
                            _select.startsWith('numberChart') ||
                            _select.startsWith('linkingCube_') ||
                            _select.startsWith('counter_') ||
                            _select.startsWith('numberFrameCounter_') ||
                            _select.startsWith('timer') ||
                            _select.startsWith('patternShapes') ||
                            _select.startsWith('analog') ||
                            _select.startsWith('arrayModel') ||
                            _select.startsWith('numberRacks') ||
                            _select.startsWith('protractor') ||
                            _select.startsWith('fractionTiles_') ||
                            _select.startsWith('jumpBar') ||
                            _select.startsWith('customTick') ||
                            _select.startsWith('numberLine') ||
                            _select.startsWith('numberFrame_') ||
                            _select.startsWith('numberPiece_') ||
                            _select.startsWith('moneyPiece_') ||
                            _select.startsWith('coloredTiles') ||
                            _select.startsWith('linearPiece_') ||
                            _select.startsWith('coinsAndCounters_')) {
                            // Strip _custom_label_(rect|circle)_N suffix that gets set when a
                            // fraction tile label input has focus — the actual manipulative ID
                            // never includes this suffix, so duplicating with it finds no match.
                            var cleanedSelect = _select.replace(/_custom_label_(rect|circle)_\d+$/, '');
                            manipulativeSelections.push(cleanedSelect);
                        }
                    });
                    // Skip jumpBars/customTicks whose parent numberLine is also selected (numberLine duplication cascades its children)
                    var selectedNumberLines = manipulativeSelections.filter(function (s) {
                        return s.startsWith('numberLine');
                    });
                    if (selectedNumberLines.length > 0) {
                        var nlIds_1 = new Set(selectedNumberLines);
                        var childrenToRemove = manipulativeSelections.filter(function (s) {
                            if (!s.startsWith('jumpBar') && !s.startsWith('customTick'))
                                return false;
                            var child = manipulative.find(function (m) { return m.data.id === s; });
                            return child && nlIds_1.has(child.data.numberLineId);
                        });
                        childrenToRemove.forEach(function (childId) {
                            var idx = manipulativeSelections.indexOf(childId);
                            if (idx !== -1)
                                manipulativeSelections.splice(idx, 1);
                        });
                    }
                    // Pre-compute new selection IDs before any setState calls
                    textDuplicates_1.forEach(function (_a, i) {
                        var select = _a.select;
                        var prefix = select.split('_')[0];
                        newSelectedIds_1.push("".concat(prefix, "_").concat(text.length + i));
                    });
                    annotationDuplicates_1.forEach(function (_, i) {
                        newSelectedIds_1.push("annotations_".concat(annotations.length + i));
                    });
                    shadesDuplicates_1.forEach(function (_, i) {
                        newSelectedIds_1.push("shades_".concat(shades.length + i));
                    });
                    if (textDuplicates_1.length > 0) {
                        setText(function (prev) {
                            var baseLength = prev.length;
                            var newItems = [];
                            textDuplicates_1.forEach(function (_a) {
                                var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
                                var select = _a.select, index = _a.index;
                                var src = prev[index];
                                if (!src)
                                    return;
                                var newData = __assign(__assign({}, src), { data: __assign(__assign({}, src.data), { lock: { positioning: false, editing: false }, position: {
                                            x: ((_b = src.data.position) === null || _b === void 0 ? void 0 : _b.x)
                                                ? ((_c = src.data.position) === null || _c === void 0 ? void 0 : _c.x) + 30
                                                : ((_e = (_d = src.data.position) === null || _d === void 0 ? void 0 : _d.x) !== null && _e !== void 0 ? _e : 0),
                                            y: ((_f = src.data.position) === null || _f === void 0 ? void 0 : _f.y)
                                                ? ((_g = src.data.position) === null || _g === void 0 ? void 0 : _g.y) + 30
                                                : ((_j = (_h = src.data.position) === null || _h === void 0 ? void 0 : _h.y) !== null && _j !== void 0 ? _j : 0),
                                            z: (_l = (_k = src.data.position) === null || _k === void 0 ? void 0 : _k.z) !== null && _l !== void 0 ? _l : 0,
                                        } }) });
                                var newIndex = baseLength + newItems.length;
                                newStateToSave.push({
                                    type: select,
                                    id: newIndex,
                                    propertyName: 'create',
                                    old: JSON.stringify(newData),
                                });
                                newItems.push(newData);
                            });
                            if (newItems.length === 0)
                                return prev;
                            return __spreadArray(__spreadArray([], prev, true), newItems, true);
                        });
                    }
                    if (annotationDuplicates_1.length > 0) {
                        setAnnotations(function (prev) {
                            var baseLength = prev.length;
                            var newItems = [];
                            annotationDuplicates_1.forEach(function (_a) {
                                var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
                                var select = _a.select, index = _a.index;
                                var src = prev[index];
                                if (!src)
                                    return;
                                var elem = structuredClone(src);
                                elem.data.lock = { positioning: false, editing: false };
                                if (elem.type === 'line') {
                                    elem.data.points = [
                                        {
                                            x: ((_b = elem.data.points) === null || _b === void 0 ? void 0 : _b[0].x)
                                                ? ((_c = elem.data.points) === null || _c === void 0 ? void 0 : _c[0].x) + 30
                                                : ((_e = (_d = elem.data.points) === null || _d === void 0 ? void 0 : _d[0].x) !== null && _e !== void 0 ? _e : 0),
                                            y: ((_f = elem.data.points) === null || _f === void 0 ? void 0 : _f[0].y)
                                                ? ((_g = elem.data.points) === null || _g === void 0 ? void 0 : _g[0].y) + 30
                                                : ((_j = (_h = elem.data.points) === null || _h === void 0 ? void 0 : _h[0].y) !== null && _j !== void 0 ? _j : 0),
                                        },
                                        {
                                            x: ((_k = elem.data.points) === null || _k === void 0 ? void 0 : _k[1].x)
                                                ? ((_l = elem.data.points) === null || _l === void 0 ? void 0 : _l[1].x) + 30
                                                : ((_o = (_m = elem.data.points) === null || _m === void 0 ? void 0 : _m[1].x) !== null && _o !== void 0 ? _o : 0),
                                            y: ((_p = elem.data.points) === null || _p === void 0 ? void 0 : _p[1].y)
                                                ? ((_q = elem.data.points) === null || _q === void 0 ? void 0 : _q[1].y) + 30
                                                : ((_s = (_r = elem.data.points) === null || _r === void 0 ? void 0 : _r[1].y) !== null && _s !== void 0 ? _s : 0),
                                        },
                                    ];
                                }
                                else {
                                    elem.data.center = elem.data.center
                                        ? __assign(__assign({}, elem.data.center), { x: elem.data.center.x + 30, y: elem.data.center.y + 30 }) : undefined;
                                }
                                var newIndex = baseLength + newItems.length;
                                newStateToSave.push({
                                    type: select,
                                    id: newIndex,
                                    propertyName: 'create',
                                    old: JSON.stringify(elem),
                                });
                                newItems.push(elem);
                            });
                            if (newItems.length === 0)
                                return prev;
                            return __spreadArray(__spreadArray([], prev, true), newItems, true);
                        });
                        // Build the duplication message for aria-label prefix on the new element
                        if (annotationDuplicates_1.length >= 1) {
                            var src = annotations[annotationDuplicates_1[0].index];
                            var dupTypeName = (_l = src === null || src === void 0 ? void 0 : src.type) !== null && _l !== void 0 ? _l : 'annotation';
                            if ((src === null || src === void 0 ? void 0 : src.type) === 'line' && src.data.arrowheadStyle) {
                                var _s = src.data.arrowheadStyle, start = _s.start, end = _s.end;
                                if (start === 'arrow' && end === 'arrow')
                                    dupTypeName = t('text.doubleArrowLine');
                                else if (start === 'arrow' || end === 'arrow')
                                    dupTypeName = t('text.arrowLine');
                                else
                                    dupTypeName = t('text.line');
                            }
                            annotationDupMsg_1 =
                                annotationDuplicates_1.length === 1
                                    ? t('text.annotationDuplicated', { name: dupTypeName })
                                    : t('text.annotationsDuplicated', { count: annotationDuplicates_1.length });
                        }
                    }
                    if (shadesDuplicates_1.length > 0) {
                        setShades(function (prev) {
                            var baseLength = prev.length;
                            var newItems = [];
                            shadesDuplicates_1.forEach(function (_a) {
                                var select = _a.select, index = _a.index;
                                var src = prev[index];
                                if (!src)
                                    return;
                                var _prevData = src.data;
                                var _newData = {
                                    id: "id_".concat(uuidv4().replace(/-/g, '')),
                                    type: 'shade',
                                    data: {
                                        lock: { positioning: false, editing: false },
                                        position: {
                                            x: _prevData.position.x + 30,
                                            y: _prevData.position.y + 30,
                                            z: _prevData.position.z,
                                        },
                                        dimensions: __assign({}, _prevData.dimensions),
                                        revealed: _prevData.revealed,
                                    },
                                };
                                var newIndex = baseLength + newItems.length;
                                newStateToSave.push({
                                    type: select,
                                    id: newIndex,
                                    propertyName: 'create',
                                    old: JSON.stringify(_newData),
                                });
                                newItems.push(_newData);
                            });
                            if (newItems.length === 0)
                                return prev;
                            return __spreadArray(__spreadArray([], prev, true), newItems, true);
                        });
                        // Match the spinner's duplicate announcement format:
                        //   "{{name}} is duplicated successfully"
                        announce(t('text.duplicatedAnnounce', { name: t('text.shade') }));
                    }
                    if (tableDuplicates_1.length > 0) {
                        // Ask TableManipulativeComp to handle cell-level duplication if cells are selected
                        var uniqueTableIndicesForCellCheck = Array.from(new Set(tableDuplicates_1.map(function (d) { return d.index; })));
                        uniqueTableIndicesForCellCheck.forEach(function (tableIdx) {
                            customEventHandler.dispatchEvent('cellDuplicate', { index: tableIdx });
                        });
                        if (getSkipTableDuplicate()) {
                            setSkipTableDuplicate(false);
                        }
                        else {
                            var uniqueTableIndices_1 = Array.from(new Set(tableDuplicates_1.map(function (d) { return d.index; })));
                            uniqueTableIndices_1.forEach(function (_, i) {
                                newSelectedIds_1.push("tableText_".concat(table.length + i));
                            });
                            setTable(function (prev) {
                                var baseLength = prev.length;
                                var newItems = [];
                                uniqueTableIndices_1.forEach(function (tableIdx) {
                                    var _a, _b, _c, _d, _e;
                                    var src = prev[tableIdx];
                                    if (!src)
                                        return;
                                    var duplicated = structuredClone(src);
                                    duplicated.data.lock = { positioning: false, editing: false };
                                    duplicated.data.position = {
                                        x: ((_b = (_a = duplicated.data.position) === null || _a === void 0 ? void 0 : _a.x) !== null && _b !== void 0 ? _b : 0) + 30,
                                        y: ((_d = (_c = duplicated.data.position) === null || _c === void 0 ? void 0 : _c.y) !== null && _d !== void 0 ? _d : 0) + 30,
                                        z: (_e = duplicated.data.position) === null || _e === void 0 ? void 0 : _e.z,
                                    };
                                    var newIndex = baseLength + newItems.length;
                                    newStateToSave.push({
                                        type: 'table',
                                        id: newIndex,
                                        propertyName: 'duplicate',
                                        old: JSON.stringify(duplicated),
                                    });
                                    newItems.push(duplicated);
                                });
                                if (newItems.length === 0)
                                    return prev;
                                return __spreadArray(__spreadArray([], prev, true), newItems, true);
                            });
                        }
                    }
                    // Track new CC group IDs so we can focus their overlay after the
                    // ContextMenu findAndFocus polling may have focused a member element.
                    var newCcGroupIdsForFocus_1 = [];
                    // Manipulatives duplication - batch multiple duplications
                    if (manipulativeSelections.length > 0) {
                        if (manipulativeSelections.length === 1) {
                            // Single duplication - use existing individual duplicate logic
                            var singleSelect_1 = manipulativeSelections[0];
                            duplicateManipulative(singleSelect_1, setManipulative, newStateToSave, newSelectedIds_1);
                            // Track CC group so we can refocus its overlay after findAndFocus polling
                            if (singleSelect_1.startsWith('manipulativeGroup_') &&
                                manipulative.some(function (m) { return m.data.groupId === singleSelect_1 && m.data.type === 'coinsAndCounters'; })) {
                                // newSelectedIds now contains the new group ID pushed by duplicateManipulative
                                var newId = newSelectedIds_1[newSelectedIds_1.length - 1];
                                if (newId)
                                    newCcGroupIdsForFocus_1.push(newId);
                            }
                        }
                        else {
                            // Separate group selections from individual items
                            var groupSelections_3 = manipulativeSelections.filter(function (s) {
                                return s.startsWith('manipulativeGroup');
                            });
                            var individualSelections = manipulativeSelections.filter(function (s) { return !s.startsWith('manipulativeGroup'); });
                            // Pre-generate new group IDs for each group
                            var groupIdMap_1 = new Map();
                            groupSelections_3.forEach(function (_select) {
                                var newGroupId = "manipulativeGroup_".concat(uuidv4().replace(/-/g, ''));
                                groupIdMap_1.set(_select, newGroupId);
                                newSelectedIds_1.push(newGroupId);
                                // Track CC groups so we can refocus their overlay after duplicate
                                if (manipulative.some(function (m) { return m.data.groupId === _select && m.data.type === 'coinsAndCounters'; })) {
                                    newCcGroupIdsForFocus_1.push(newGroupId);
                                }
                            });
                            // When duplicating 2+ ad-hoc-selected (ungrouped) coloredTiles together,
                            // bundle the duplicates into a real group so they keep dragging together
                            // after the duplicate action ends (an ad-hoc multi-select is transient —
                            // it's lost as soon as the user clicks elsewhere).
                            var coloredTilesIndividualSelections = individualSelections.filter(function (s) { return getManipulativeType(s) === 'coloredTiles'; });
                            var newCtGroupId_1 = coloredTilesIndividualSelections.length > 1
                                ? "manipulativeGroup_".concat(uuidv4().replace(/-/g, ''))
                                : undefined;
                            if (newCtGroupId_1)
                                newSelectedIds_1.push(newCtGroupId_1);
                            // Pre-generate new IDs for individual items
                            var preGeneratedIds_1 = [];
                            var chainIdMap_1 = new Map();
                            individualSelections.forEach(function (_select) {
                                var original = manipulative.find(function (m) { return m.data.id === _select; });
                                if (!original)
                                    return;
                                // Use getNewIdPrefix to ensure correct prefix (e.g. 'numberFrame_' not 'numberFrames_')
                                var itemType = getManipulativeType(_select);
                                var idPrefix = itemType ? getNewIdPrefix(itemType) : "".concat(original.data.type, "_");
                                var newId = "".concat(idPrefix).concat(uuidv4().replace(/-/g, ''));
                                var newChainId;
                                if ('chainId' in original.data && original.data.chainId) {
                                    if (!chainIdMap_1.has(original.data.chainId)) {
                                        chainIdMap_1.set(original.data.chainId, "chain_".concat(uuidv4().replace(/-/g, '')));
                                    }
                                    newChainId = chainIdMap_1.get(original.data.chainId);
                                }
                                preGeneratedIds_1.push({ selectId: _select, newId: newId, chainId: newChainId });
                                // When these are being bundled into newCtGroupId, select the group
                                // instead of each member (matches the explicit 'group' action's selection).
                                if (!newCtGroupId_1 || itemType !== 'coloredTiles') {
                                    newSelectedIds_1.push(newId);
                                }
                            });
                            // Pre-generate counter ID mappings for numberFrame individual duplicates (makes setManipulative pure)
                            var frameCounterMappings_1 = new Map();
                            preGeneratedIds_1.forEach(function (_a) {
                                var selectId = _a.selectId;
                                var original = manipulative.find(function (m) { return m.data.id === selectId; });
                                if (!original || original.data.type !== 'numberFrames')
                                    return;
                                var frameData = original.data;
                                var tokens = frameData.tokens || {};
                                var counterIdMap = new Map();
                                Object.values(tokens).forEach(function (oldId) {
                                    counterIdMap.set(oldId, "numberFrameCounter_".concat(uuidv4().replace(/-/g, '')));
                                });
                                frameCounterMappings_1.set(selectId, counterIdMap);
                            });
                            // Handle ALL duplications (groups + individuals) in a single setManipulative call
                            var duplicatedItems_1 = [];
                            // Computed synchronously (not inside the setManipulative updater) so
                            // `duplicatedItems` is populated before `saveState(newStateToSave)` runs
                            // right after this switch — the updater callback itself only runs once
                            // React flushes the update, by which point saveState has already read
                            // (and would otherwise capture an empty) `duplicatedItems`.
                            var newItems_1 = (function () {
                                var prev = manipulative;
                                var newItems = [];
                                // Assign z-indices above the current max so duplicates surface as a unit
                                var batchMaxZ = prev
                                    .filter(function (m) { return m.data.type === 'numberPiece' || m.data.type === 'moneyPiece'; })
                                    .reduce(function (acc, m) { var _a; return Math.max(acc, (_a = m.data.zIndex) !== null && _a !== void 0 ? _a : 1); }, 0);
                                var batchNextZ = batchMaxZ + 1;
                                var ctGroupPos = 0;
                                // Duplicate group members
                                groupSelections_3.forEach(function (_select) {
                                    var newGroupId = groupIdMap_1.get(_select);
                                    var members = prev.filter(function (m) { return m.data.groupId === _select; });
                                    // Pre-generate IDs for linearPiece members so coloredTiles snap arrays
                                    // can be remapped to the new IDs before the duplicates are pushed.
                                    var lpIdMap = new Map();
                                    members.forEach(function (m) {
                                        if (m.data.type === 'linearPiece') {
                                            lpIdMap.set(m.data.id, "linearPiece_".concat(uuidv4().replace(/-/g, '')));
                                        }
                                    });
                                    members.forEach(function (member) {
                                        var _a, _b, _c, _d;
                                        var cloned = structuredClone(member);
                                        var newFrameId = cloned.data.type === 'linearPiece'
                                            ? lpIdMap.get(cloned.data.id)
                                            : "".concat(cloned.data.type || 'dice', "_").concat(uuidv4().replace(/-/g, ''));
                                        var isNmp = cloned.data.type === 'numberPiece' || cloned.data.type === 'moneyPiece';
                                        var duplicated = __assign(__assign({}, cloned), { widgetId: newFrameId, data: __assign(__assign(__assign(__assign({}, cloned.data), { id: newFrameId, groupId: newGroupId, lock: { positioning: false, editing: false }, center: {
                                                    x: Number(((_b = (_a = cloned.data) === null || _a === void 0 ? void 0 : _a.center) === null || _b === void 0 ? void 0 : _b.x) || 0) + 30,
                                                    y: Number(((_d = (_c = cloned.data) === null || _c === void 0 ? void 0 : _c.center) === null || _d === void 0 ? void 0 : _d.y) || 0) + 30,
                                                } }), (cloned.data.groupCenter && {
                                                groupCenter: {
                                                    x: cloned.data.groupCenter.x + 30,
                                                    y: cloned.data.groupCenter.y + 30,
                                                },
                                            })), (isNmp && { zIndex: batchNextZ++ })) });
                                        // Duplicate tokens for numberFrames group members
                                        if (cloned.data.type === 'numberFrames') {
                                            var originalTokens = cloned.data.tokens || {};
                                            var oldCounterIds = Object.values(originalTokens);
                                            if (oldCounterIds.length > 0) {
                                                var idMap_2 = new Map();
                                                oldCounterIds.forEach(function (oldId) {
                                                    idMap_2.set(oldId, "numberFrameCounter_".concat(uuidv4().replace(/-/g, '')));
                                                });
                                                var newTokens = {};
                                                for (var _i = 0, _e = Object.entries(originalTokens); _i < _e.length; _i++) {
                                                    var _f = _e[_i], cellIndex = _f[0], oldId = _f[1];
                                                    var mapped = idMap_2.get(oldId);
                                                    if (mapped)
                                                        newTokens[Number(cellIndex)] = mapped;
                                                }
                                                duplicated.data.tokens = newTokens;
                                                // Push frame first so counters render on top in DOM
                                                newItems.push(duplicated);
                                                duplicatedItems_1.push({ original: member, duplicate: duplicated });
                                                oldCounterIds.forEach(function (oldId) {
                                                    var _a, _b;
                                                    var counterOriginal = prev.find(function (m) { return m.data.id === oldId; });
                                                    if (!counterOriginal)
                                                        return;
                                                    var newCounterId = idMap_2.get(oldId);
                                                    if (!newCounterId)
                                                        return;
                                                    var clonedCounter = structuredClone(counterOriginal);
                                                    clonedCounter.data = __assign(__assign({}, clonedCounter.data), { id: newCounterId, frameId: newFrameId, center: {
                                                            x: (((_a = clonedCounter.data.center) === null || _a === void 0 ? void 0 : _a.x) || 0) + 30,
                                                            y: (((_b = clonedCounter.data.center) === null || _b === void 0 ? void 0 : _b.y) || 0) + 30,
                                                        } });
                                                    newItems.push(clonedCounter);
                                                    duplicatedItems_1.push({
                                                        original: counterOriginal,
                                                        duplicate: clonedCounter,
                                                    });
                                                });
                                                return; // already pushed duplicated above
                                            }
                                            else {
                                                duplicated.data.tokens = {};
                                            }
                                        }
                                        // Remap coloredTiles snap arrays to reference the new linearPiece IDs.
                                        if (duplicated.data.type === 'coloredTiles' && lpIdMap.size > 0) {
                                            var td = duplicated.data;
                                            var remap = function (arr) {
                                                return arr === null || arr === void 0 ? void 0 : arr.map(function (pid) { return (pid && lpIdMap.has(pid) ? lpIdMap.get(pid) : pid); });
                                            };
                                            if (td.snappedVerticalPieceIds)
                                                td.snappedVerticalPieceIds = remap(td.snappedVerticalPieceIds);
                                            if (td.snappedRightVerticalPieceIds)
                                                td.snappedRightVerticalPieceIds = remap(td.snappedRightVerticalPieceIds);
                                            if (td.snappedHorizontalPieceIds)
                                                td.snappedHorizontalPieceIds = remap(td.snappedHorizontalPieceIds);
                                            if (td.snappedBottomHorizontalPieceIds)
                                                td.snappedBottomHorizontalPieceIds = remap(td.snappedBottomHorizontalPieceIds);
                                        }
                                        newItems.push(duplicated);
                                        duplicatedItems_1.push({ original: member, duplicate: duplicated });
                                    });
                                });
                                // Duplicate individual items
                                preGeneratedIds_1.forEach(function (_a) {
                                    var _b, _c;
                                    var selectId = _a.selectId, newId = _a.newId, chainId = _a.chainId;
                                    var original = prev.find(function (m) { return m.data.id === selectId; });
                                    if (!original)
                                        return;
                                    var isNmpIndividual = original.data.type === 'numberPiece' || original.data.type === 'moneyPiece';
                                    var duplicated = structuredClone(original);
                                    duplicated.widgetId = newId;
                                    duplicated.data = __assign(__assign(__assign({}, duplicated.data), { id: newId, lock: { positioning: false, editing: false }, center: {
                                            x: (((_b = duplicated.data.center) === null || _b === void 0 ? void 0 : _b.x) || 0) + 30,
                                            y: (((_c = duplicated.data.center) === null || _c === void 0 ? void 0 : _c.y) || 0) + 30,
                                        } }), (isNmpIndividual && { zIndex: batchNextZ++ }));
                                    if (chainId) {
                                        duplicated.data.chainId = chainId;
                                    }
                                    if (duplicated.data.type === 'coloredTiles') {
                                        if (newCtGroupId_1) {
                                            // Bundle the ad-hoc multi-selected duplicates into a real group
                                            // (mirrors the explicit 'group' action) so they keep dragging
                                            // together after this transient selection is lost.
                                            duplicated.data.groupId = newCtGroupId_1;
                                            duplicated.data.groupPosition = ctGroupPos++;
                                            duplicated.data.groupCenter = undefined;
                                            duplicated.data.beforeGroupScale = duplicated.data.scale;
                                            duplicated.data.groupScale = 1;
                                            duplicated.data.isGroup = true;
                                        }
                                        else {
                                            delete duplicated.data.groupId;
                                            delete duplicated.data.groupPosition;
                                            delete duplicated.data.groupCenter;
                                            delete duplicated.data.beforeGroupScale;
                                            delete duplicated.data.groupScale;
                                        }
                                        // G4: clone any linearPieces snapped to this tile (all 4 sides), with
                                        // new IDs and matching +30/+30 offset, then update the duplicate tile's
                                        // snap arrays to reference the new piece IDs so undo/redo restores them.
                                        var td = duplicated.data;
                                        var cloneSnapArray = function (oldArr) {
                                            if (!oldArr || oldArr.length === 0)
                                                return null;
                                            return oldArr.map(function (pid) {
                                                var _a, _b;
                                                if (!pid)
                                                    return null;
                                                var srcPiece = prev.find(function (m) { return m.data.id === pid; });
                                                if (!srcPiece)
                                                    return null;
                                                var newPieceId = "linearPiece_".concat(uuidv4().replace(/-/g, ''));
                                                var clonedPiece = structuredClone(srcPiece);
                                                clonedPiece.data = __assign(__assign(__assign({}, clonedPiece.data), { id: newPieceId, center: {
                                                        x: (((_a = clonedPiece.data.center) === null || _a === void 0 ? void 0 : _a.x) || 0) + 30,
                                                        y: (((_b = clonedPiece.data.center) === null || _b === void 0 ? void 0 : _b.y) || 0) + 30,
                                                    } }), (newCtGroupId_1 && {
                                                    groupId: newCtGroupId_1,
                                                    groupPosition: ctGroupPos++,
                                                    groupCenter: undefined,
                                                    beforeGroupScale: clonedPiece.data.scale,
                                                    groupScale: 1,
                                                }));
                                                newItems.push(clonedPiece);
                                                duplicatedItems_1.push({ original: srcPiece, duplicate: clonedPiece });
                                                return newPieceId;
                                            });
                                        };
                                        var newLeftVIds = cloneSnapArray(td.snappedVerticalPieceIds);
                                        if (newLeftVIds)
                                            td.snappedVerticalPieceIds = newLeftVIds;
                                        var newRightVIds = cloneSnapArray(td.snappedRightVerticalPieceIds);
                                        if (newRightVIds)
                                            td.snappedRightVerticalPieceIds = newRightVIds;
                                        var newTopHIds = cloneSnapArray(td.snappedHorizontalPieceIds);
                                        if (newTopHIds)
                                            td.snappedHorizontalPieceIds = newTopHIds;
                                        var newBottomHIds = cloneSnapArray(td.snappedBottomHorizontalPieceIds);
                                        if (newBottomHIds)
                                            td.snappedBottomHorizontalPieceIds = newBottomHIds;
                                    }
                                    // NumberFrame batch duplicate: also duplicate tokens placed in the frame
                                    if (duplicated.data.type === 'numberFrames') {
                                        var originalTokens = duplicated.data.tokens || {};
                                        var oldCounterIds = Object.values(originalTokens);
                                        if (oldCounterIds.length > 0) {
                                            var idMap_3 = frameCounterMappings_1.get(selectId) || new Map();
                                            var newTokens = {};
                                            for (var _i = 0, _d = Object.entries(originalTokens); _i < _d.length; _i++) {
                                                var _e = _d[_i], cellIndex = _e[0], oldId = _e[1];
                                                var mapped = idMap_3.get(oldId);
                                                if (mapped)
                                                    newTokens[Number(cellIndex)] = mapped;
                                            }
                                            duplicated.data.tokens = newTokens;
                                            // Push frame first so counters render on top in DOM
                                            newItems.push(duplicated);
                                            duplicatedItems_1.push({ original: original, duplicate: duplicated });
                                            oldCounterIds.forEach(function (oldId) {
                                                var _a, _b;
                                                var counterOriginal = prev.find(function (m) { return m.data.id === oldId; });
                                                if (!counterOriginal)
                                                    return;
                                                var newCounterId = idMap_3.get(oldId);
                                                if (!newCounterId)
                                                    return;
                                                var clonedCounter = structuredClone(counterOriginal);
                                                clonedCounter.data = __assign(__assign({}, clonedCounter.data), { id: newCounterId, frameId: newId, center: {
                                                        x: (((_a = clonedCounter.data.center) === null || _a === void 0 ? void 0 : _a.x) || 0) + 30,
                                                        y: (((_b = clonedCounter.data.center) === null || _b === void 0 ? void 0 : _b.y) || 0) + 30,
                                                    } });
                                                newItems.push(clonedCounter);
                                                duplicatedItems_1.push({
                                                    original: counterOriginal,
                                                    duplicate: clonedCounter,
                                                });
                                            });
                                            return; // already pushed duplicated above
                                        }
                                        else {
                                            duplicated.data.tokens = {};
                                        }
                                    }
                                    newItems.push(duplicated);
                                    duplicatedItems_1.push({ original: original, duplicate: duplicated });
                                });
                                return newItems;
                            })();
                            setManipulative(function (prevLive) { return __spreadArray(__spreadArray([], prevLive, true), newItems_1, true); });
                            // Save all duplications as a single state change
                            if (duplicatedItems_1.length > 0) {
                                newStateToSave.push({
                                    type: 'multipleManipulatives',
                                    id: 'batch',
                                    propertyName: 'multipleDuplicate',
                                    old: JSON.stringify(duplicatedItems_1),
                                });
                            }
                        }
                    }
                    // Mark IDs as duplicated BEFORE setSelectedTool triggers mount
                    // The useDuplicateAnnounce hook reads this synchronously on initial render
                    if (newSelectedIds_1.length > 0) {
                        newSelectedIds_1.forEach(function (newId) { return markAsDuplicated(newId); });
                    }
                    // Delay selection so React re-renders new annotations/manipulatives first;
                    // RaphaelCanvas focus useEffect needs the DOM element to exist before it can focus it.
                    if (annotationDuplicates_1.length > 0) {
                        setTimeout(function () {
                            var _a;
                            setSelectedTool(newSelectedIds_1);
                            // Prepend duplication message to the new annotation's aria-label
                            var newAnnId = newSelectedIds_1.find(function (id) { return id.startsWith('annotations_'); });
                            if (newAnnId && annotationDupMsg_1) {
                                var el_1 = document.querySelector("[data-manipulative-id=\"".concat(newAnnId, "\"]"));
                                if (el_1) {
                                    var existingLabel_2 = (_a = el_1.getAttribute('aria-label')) !== null && _a !== void 0 ? _a : '';
                                    el_1.setAttribute('aria-label', "".concat(annotationDupMsg_1, ", ").concat(existingLabel_2));
                                    el_1.focus();
                                    setTimeout(function () {
                                        el_1.setAttribute('aria-label', existingLabel_2);
                                    }, 300);
                                }
                            }
                        }, 400);
                    }
                    else {
                        setSelectedTool(newSelectedIds_1);
                    }
                    // After the ContextMenu's findAndFocus polling (50ms) has run and may have
                    // focused an individual counter element, shift focus to the CC group overlay.
                    // Only focus the first CC group — focus can be on one element at a time,
                    // and the user can Tab to reach additional duplicated groups.
                    if (newCcGroupIdsForFocus_1.length > 0) {
                        setTimeout(function () {
                            customEventHandler.dispatchEvent('focusCcGroup', { groupId: newCcGroupIdsForFocus_1[0] });
                        }, 150);
                    }
                    break;
                case 'delete':
                    handleDeleteSelected(newStateToSave, manipulativeSelections);
                    break;
                case 'outline':
                    // Group selected pattern shapes and change their color to dark navy blue
                    var outlineGroupId_1 = "manipulativeGroup_".concat(uuidv4().replace(/-/g, ''));
                    var patternShapesToOutline_1 = selectedTool.filter(function (t) {
                        return manipulative.some(function (m) { return m.data.id === t && m.type === 'patternShapes'; });
                    });
                    if (patternShapesToOutline_1.length > 0) {
                        setManipulative(function (prev) {
                            var oldOutlineData = [];
                            var newOutlineData = [];
                            var updated = prev.map(function (item) {
                                var _a;
                                // Only apply to selected pattern shapes
                                if (patternShapesToOutline_1.includes((_a = item.data.id) !== null && _a !== void 0 ? _a : '')) {
                                    oldOutlineData.push(structuredClone(item));
                                    var newItem = __assign(__assign({}, item), { data: __assign(__assign({}, item.data), { groupId: outlineGroupId_1, color: 'DARK_NAVY_BLUE', lock: {
                                                positioning: true,
                                                editing: item.data.lock.editing,
                                            } }) });
                                    newOutlineData.push(structuredClone(newItem));
                                    return newItem;
                                }
                                return item;
                            });
                            // Save state for undo/redo
                            if (oldOutlineData.length > 0) {
                                newStateToSave.push({
                                    type: outlineGroupId_1,
                                    id: outlineGroupId_1.split('_')[1],
                                    propertyName: 'completeData',
                                    old: JSON.stringify(oldOutlineData),
                                    new: JSON.stringify(newOutlineData),
                                });
                            }
                            return updated;
                        });
                        setSelectedTool([outlineGroupId_1]);
                    }
                    break;
                case 'edit':
                    customEventHandler.dispatchEvent('bottomPanel', { id: 'edit' });
                    break;
                default:
                    break;
            }
            // Save all state changes as a batch
            if (newStateToSave.length > 0) {
                saveState(newStateToSave);
                customEventHandler.dispatchEvent('stateChanged', { type: 'save' });
            }
            if ((_m = data.id) === null || _m === void 0 ? void 0 : _m.startsWith('highlighterCollapsible')) {
                var idx = Number(data.id.split('_')[1]);
                setWidthIndex(idx);
            }
        };
        customEventHandler.addEventListener('sidebarClicked', onClick);
        customEventHandler.addEventListener('headerClicked', onClick);
        customEventHandler.addEventListener('bottomBar', onClick);
        customEventHandler.addEventListener('bottomPanel', onClick);
        return function () {
            customEventHandler.removeEventListener('sidebarClicked', onClick);
            customEventHandler.removeEventListener('headerClicked', onClick);
            customEventHandler.removeEventListener('bottomBar', onClick);
            customEventHandler.removeEventListener('bottomPanel', onClick);
        };
    }, [zoomLevel]);
    // Handle editNumberFrame button when the numberFrames dummy or a counter is selected (no real frame mounted)
    useEffect(function () {
        var handleDummyEditFrame = function (event) {
            if (event.id !== 'editNumberFrame')
                return;
            var selected = selectedToolRef.current;
            if (selected.length === 0)
                return;
            var isDummy = selected.every(function (t) { return t.endsWith('_dummyForRightTool') && t.startsWith('numberFrame_'); });
            var isCounter = selected.some(function (t) {
                return manipulativeRef.current.some(function (m) { return m.data.id === t && m.data.type === 'numberFrameCounter'; });
            });
            if (isDummy || isCounter) {
                setSelectedManipulativeId('');
                setManiplulatorComponentVisible(true);
                setActiveManipulator('numberFrames');
            }
        };
        customEventHandler.addEventListener('bottomPanel', handleDummyEditFrame);
        return function () { return customEventHandler.removeEventListener('bottomPanel', handleDummyEditFrame); };
    }, []);
    // ── Region navigation shortcuts (Ctrl+Shift+Number) ──
    useRegionNavigation([
        { key: 'digit1', selector: 'header, footer' },
        { key: 'digit2', selector: 'nav[aria-label]' },
        { key: 'digit3', selector: '[role="application"]' },
        { key: 'digit4', selector: '.manipulativeToolSettings' },
        { key: 'digit5', selector: '.zoomAndPanControlPanel' },
    ]);
    // ── Screen reader announcements for manipulative changes ──
    var prevManipCountRef = useRef(manipulative.length);
    useEffect(function () {
        var _a, _b, _c, _d, _e;
        var prevCount = prevManipCountRef.current;
        var newCount = manipulative.length;
        prevManipCountRef.current = newCount;
        if (newCount > prevCount) {
            // New manipulative(s) added — announce the last one
            var added = manipulative[manipulative.length - 1];
            if (added) {
                var rawType = added.type || ((_a = added.data) === null || _a === void 0 ? void 0 : _a.type) || '';
                // For NMP additions, count how many pieces of the same type just
                // arrived in this batch so the announcement reflects the real count
                // (e.g. duplicating 5 selected pieces says "5 number pieces added"
                // instead of the previously-hardcoded "1 number piece"). Cubes,
                // shapes, etc. are unaffected.
                var addedDelta = newCount - prevCount;
                var recentlyAdded = manipulative.slice(prevCount, newCount);
                var numberPieceCount = recentlyAdded.filter(function (m) { var _a; return (m.type || ((_a = m.data) === null || _a === void 0 ? void 0 : _a.type)) === 'numberPiece'; }).length;
                var moneyPieceCount = recentlyAdded.filter(function (m) { var _a; return (m.type || ((_a = m.data) === null || _a === void 0 ? void 0 : _a.type)) === 'moneyPiece'; }).length;
                // Linear pieces can be added in batches of BOTH orientations at once —
                // e.g. creating a tile with "Red linear pieces" adds one vertical piece
                // per row AND one horizontal piece per column in a single update, and
                // "Add All" adds every piece on an edge. This effect otherwise only
                // describes manipulative[-1] (the last appended item), so the earlier
                // orientation (and the tile itself) would never be announced. Detect
                // multi-piece batches and announce both orientations (and the tile).
                var verticalLPCount = recentlyAdded.filter(function (m) {
                    var _a, _b;
                    return (m.type || ((_a = m.data) === null || _a === void 0 ? void 0 : _a.type)) === 'linearPiece' &&
                        ((_b = m.data) === null || _b === void 0 ? void 0 : _b.orientation) === 'vertical';
                }).length;
                var horizontalLPCount = recentlyAdded.filter(function (m) {
                    var _a, _b;
                    return (m.type || ((_a = m.data) === null || _a === void 0 ? void 0 : _a.type)) === 'linearPiece' &&
                        ((_b = m.data) === null || _b === void 0 ? void 0 : _b.orientation) === 'horizontal';
                }).length;
                if (verticalLPCount + horizontalLPCount >= 2) {
                    var parts = [];
                    if (verticalLPCount > 0) {
                        parts.push(t('text.coloredTilesVerticalPiecesN', { count: verticalLPCount }));
                    }
                    if (horizontalLPCount > 0) {
                        parts.push(t('text.coloredTilesHorizontalPiecesN', { count: horizontalLPCount }));
                    }
                    var piecesText = parts.join(" ".concat(t('text.and'), " "));
                    var hasTile = recentlyAdded.some(function (m) { var _a; return (m.type || ((_a = m.data) === null || _a === void 0 ? void 0 : _a.type)) === 'coloredTiles'; });
                    announce(hasTile
                        ? t('text.coloredTilesAddedWithLinearPieces', { pieces: piecesText })
                        : t('text.coloredTilesLinearPiecesAddedSummary', { pieces: piecesText }));
                    return;
                }
                // Manual-mode creates an INVISIBLE placeholder tile and opens the right
                // panel so the user drags colored blocks in. Don't announce it as
                // "Colored Tiles added to workspace at position X, Y" (it's invisible and
                // the coords are meaningless) — announce the next step instead.
                if (rawType === 'coloredTiles' && ((_b = added.data) === null || _b === void 0 ? void 0 : _b.isInvisible)) {
                    announce(t('text.coloredTilesManualPlaceholder'));
                    return;
                }
                // Map internal type identifiers to user-friendly translated names so
                // announcements never leak raw strings like "dice_pool" to users.
                var typeNameMap = {
                    dice: t('text.dice'),
                    spinner: t('text.spinner'),
                    analog: t('text.manipulativeClock'),
                    timer: t('text.manipulativeTimer'),
                    numberChart: t('text.manipulativeNumberChart'),
                    numberLine: t('text.manipulativeNumberLine'),
                    numberFrame: t('text.manipulativeNumberFrame'),
                    counter: t('text.manipulativeCounter'),
                    linkingCubes: t('text.manipulativeLinkingCubes'),
                    fractionTiles: t('text.manipulativeFractionTile'),
                    coloredTiles: t('text.manipulativeColoredTile'),
                    patternShapes: t('text.manipulativePatternBlock'),
                    arrayModel: t('text.manipulativeArrayModel'),
                    protractor: t('text.manipulativeProtractor'),
                    numberRacks: t('text.numberRack'),
                    numberPiece: numberPieceCount > 1
                        ? t('text.numberPieceItems', { count: numberPieceCount })
                        : t('text.numberPieceItem', { count: numberPieceCount || 1 }),
                    moneyPiece: moneyPieceCount > 1
                        ? t('text.moneyPieceItems', { count: moneyPieceCount })
                        : t('text.moneyPieceItem', { count: moneyPieceCount || 1 }),
                    deck: t('text.manipulativeCardDeck'),
                    deck_pool: t('text.manipulativeCardDeck'),
                };
                // Suppress the unused warning when no NMP add happened.
                void addedDelta;
                // linearPiece needs orientation-aware naming — not a static map entry.
                var friendly = rawType === 'linearPiece'
                    ? (((_c = added.data) === null || _c === void 0 ? void 0 : _c.orientation) === 'horizontal'
                        ? t('text.horizontalLinearPiece')
                        : t('text.verticalLinearPiece'))
                    : ((_d = typeNameMap[rawType]) !== null && _d !== void 0 ? _d : rawType);
                var center = (_e = added.data) === null || _e === void 0 ? void 0 : _e.center;
                // Raw canvas coordinates like "at position 1114, 1397" aren't
                // meaningful to users. For linear pieces specifically, the relevant
                // context is the snap state (row/column on a tile), which is
                // announced separately by the piece widget itself. Skip the
                // position suffix for those.
                var omitPosition = rawType === 'linearPiece';
                var posText = center && !omitPosition
                    ? " ".concat(t('text.atPosition', { x: Math.round(center.x), y: Math.round(center.y) }))
                    : '';
                // numberRacks announces its own richer creation message from ManipulativeTool
                // (rows + bead colors + resting state); skip the generic one here to avoid overlap.
                // coinsAndCounters is announced by CoinsAndCountersToolbar with the specific
                // coin name (e.g. "Penny added to workspace") — skip the generic fallback here.
                if (rawType !== 'numberRacks' && rawType !== 'coinsAndCounters') {
                    announce("".concat(t('text.manipulativeAddedWithPos', { type: friendly })).concat(posText));
                }
            }
        }
        else if (newCount < prevCount) {
            var removed = prevCount - newCount;
            announce(t('text.manipulativeRemoved', { count: removed, remaining: newCount }));
        }
    }, [manipulative.length]);
    // ── Global keyboard shortcuts ──
    // Avoids conflicts with JAWS (Insert+key), VoiceOver (Ctrl+Option),
    // and browser defaults (Ctrl+T/D/L/I/K/S).
    // Single-letter keys only fire when the user is NOT in a text input.
    useEffect(function () {
        var ZOOM_LEVELS = [0.25, 0.5, 1, 1.5, 2];
        var handleKeyDown = function (e) {
            var _a, _b;
            // Read latest state from refs to avoid stale closures
            var selectedTool = selectedToolRef.current;
            var language = languageRef.current;
            var zoomLevel = zoomLevelRef.current;
            var activeEl = document.activeElement;
            var isTyping = activeEl &&
                (activeEl.tagName === 'INPUT' ||
                    activeEl.tagName === 'TEXTAREA' ||
                    activeEl.tagName === 'MATH-FIELD' ||
                    activeEl.isContentEditable ||
                    !!activeEl.closest('[contenteditable="true"]') ||
                    !!activeEl.closest('math-field'));
            // Plain Cmd+S or plain Ctrl+S → Save dialog (prevent browser save).
            // `e.ctrlKey !== e.metaKey` is XOR for booleans — exactly one of the
            // two modifiers must be held, never both (so Cmd+Ctrl+S is excluded).
            // Excluding Alt and Shift lets Cmd+Alt+S fall through to the Share
            // shortcut below, and keeps Ctrl+Shift+S branches reachable.
            // if (e.ctrlKey !== e.metaKey && !e.shiftKey && !e.altKey && e.key.toLowerCase() === 's') {
            //   e.preventDefault();
            //   setShowSaveModal(prev => !prev);
            //   return;
            // }
            // Cmd+Alt+S (Mac) / Ctrl+Alt+S (PC) → toggle the iwb-sharePopup
            // (rendered by IwbSharePopup.tsx). Gated on the same rule as the
            // InputWithBtn Share button (line 1031): `!hasShareCode || isIDM`
            // disabled, i.e. enabled iff `!!shareCode && !isIDM`. Reads via refs
            // to avoid stale closures. Uses `e.code === 'KeyS'` so Mac
            // Option+S character mapping (e.g. 'ß' on US layout) doesn't break
            // the match. Placed above the typing guard for the same reason as
            // Save: the shortcut should fire whether or not focus is in an input.
            // if ((e.ctrlKey || e.metaKey) && e.altKey && !e.shiftKey && e.code === 'KeyS') {
            //   e.preventDefault();
            //   const shareAvailable = !isIDMRef.current && !!shareCodeRef.current;
            //   if (shareAvailable) {
            //     setShowIwbSharePopup(prev => !prev);
            //   }
            //   return;
            // }
            // Skip remaining shortcuts when typing in text fields
            // console.log(
            //   '[KB] keydown:',
            //   e.key,
            //   'isTyping:',
            //   isTyping,
            //   'activeEl:',
            //   activeEl?.tagName,
            //   activeEl?.className,
            // );
            if (isTyping)
                return;
            switch (e.key) {
                case 'Delete':
                case 'Backspace': {
                    var anyPresetSelected = selectedTool.some(function (toolId) {
                        var _a;
                        if (toolId.startsWith('card_')) {
                            return manipulative.some(function (m) {
                                var _a, _b, _c, _d;
                                return ((_a = m.data) === null || _a === void 0 ? void 0 : _a.type) === 'deck' &&
                                    ((_b = m.data) === null || _b === void 0 ? void 0 : _b.isPreset) === true &&
                                    ((_d = (_c = m.data) === null || _c === void 0 ? void 0 : _c.cards) === null || _d === void 0 ? void 0 : _d.some(function (c) { return c.id === toolId; }));
                            });
                        }
                        var item = manipulative.find(function (m) { return m.data.id === toolId; });
                        return ((_a = item === null || item === void 0 ? void 0 : item.data) === null || _a === void 0 ? void 0 : _a.isPreset) === true;
                    });
                    if (selectedTool.length > 0 && !anyPresetSelected) {
                        e.preventDefault();
                        customEventHandler.dispatchEvent('bottomPanel', {
                            id: 'delete',
                            panel: 'bottomPanel',
                        });
                    }
                    break;
                }
                case 'd':
                case 'D':
                    // Duplicate moved to Ctrl+Alt+C — handled in the default block via
                    // e.code so Ctrl+Alt layout quirks don't break it.
                    break;
                case 'k':
                case 'K':
                    if (e.ctrlKey && e.shiftKey) {
                        e.preventDefault();
                        setShowEnterKeyModal(function (prev) { return !prev; });
                    }
                    break;
                // case 'f':
                // case 'F':
                //   if (e.ctrlKey && e.shiftKey) {
                //     e.preventDefault();
                //     setShowSaveModal(prev => !prev);
                //   }
                //   break;
                case 'l':
                case 'L':
                    if (e.ctrlKey && e.shiftKey) {
                        e.preventDefault();
                        applyLanguage(language === 'en' ? 'es' : 'en');
                    }
                    break;
                case '=':
                case '+': {
                    if (!(e.ctrlKey || e.metaKey))
                        break;
                    e.preventDefault();
                    // Snap up to the next preset greater than the current value — works
                    // even when zoomLevel is between steps (e.g. 0.36 from fit-to-view).
                    var next = ZOOM_LEVELS.find(function (l) { return l > zoomLevel; });
                    if (next !== undefined)
                        setUserZoom(next);
                    break;
                }
                case '-': {
                    if (!(e.ctrlKey || e.metaKey))
                        break;
                    e.preventDefault();
                    var prev = void 0;
                    for (var _i = 0, ZOOM_LEVELS_1 = ZOOM_LEVELS; _i < ZOOM_LEVELS_1.length; _i++) {
                        var l = ZOOM_LEVELS_1[_i];
                        if (l < zoomLevel)
                            prev = l;
                        else
                            break;
                    }
                    if (prev !== undefined)
                        setUserZoom(prev);
                    break;
                }
                case '?':
                case '/':
                    if (e.ctrlKey && e.shiftKey) {
                        e.preventDefault();
                        setShowShortcutsModal(function (prev) { return !prev; });
                    }
                    break;
                default:
                    // Ctrl+Alt+T — Add text box (use e.code because Ctrl+Alt changes e.key on some layouts)
                    if (e.ctrlKey && e.altKey && e.code === 'KeyT') {
                        e.preventDefault();
                        customEventHandler.dispatchEvent('sidebarClicked', { id: 'text' });
                    }
                    // Ctrl+Alt+C — Duplicate selected (moved from Ctrl+Shift+D to avoid
                    // clashing with the browser's DevTools "Inspect Element" shortcut).
                    if (e.ctrlKey && e.altKey && e.code === 'KeyC' && selectedTool.length > 0) {
                        e.preventDefault();
                        customEventHandler.dispatchEvent('bottomPanel', {
                            id: 'duplicate',
                            panel: 'bottomPanel',
                        });
                    }
                    // Ctrl+Alt+I — Open help for selected manipulative. With no
                    // selection, fall back to the general "Introduction" help PDF.
                    if (e.ctrlKey && e.altKey && e.code === 'KeyI') {
                        e.preventDefault();
                        var helpList = (_b = (_a = mainConfig === null || mainConfig === void 0 ? void 0 : mainConfig.helpBtn) === null || _a === void 0 ? void 0 : _a.btnList) !== null && _b !== void 0 ? _b : [];
                        if (selectedTool.length === 0) {
                            var intro = helpList.find(function (h) { return h.id === 'introduction'; });
                            if (intro === null || intro === void 0 ? void 0 : intro.pdf) {
                                // Mirror HelpTool's openMaterial tracking so support-material
                                // usage via the keyboard shortcut is counted too.
                                trackEvent(AnalyticsCategory.support, 'openMaterial', 'introduction');
                                window.open(intro.pdf, '_blank', 'noopener,noreferrer');
                            }
                            break;
                        }
                        var prefixToHelpId = {
                            arrayModel: 'helpArrayModels',
                            deck: 'helpCards',
                            card: 'helpCards',
                            analog: 'helpClocks',
                            timer: 'helpClocks',
                            counter: 'helpCoinsCounters',
                            coloredTiles: 'helpColoredTiles',
                            dice_: 'helpDice',
                            manipulativeGroup: 'helpDice',
                            fractionTiles: 'helpFractionTiles',
                            linkingCube: 'helpLinkingCubes',
                            numberChart: 'helpNumberCharts',
                            numberFrame: 'helpNumberFrames',
                            numberLine: 'helpNumberLines',
                            jumpBar: 'helpNumberLines',
                            customTick: 'helpNumberLines',
                            numberPiece: 'helpNumberMoneyPieces',
                            moneyPiece: 'helpNumberMoneyPieces',
                            numberRack: 'helpNumberRacks',
                            patternShape: 'helpPatternShapes',
                            protractor: 'helpProtractor',
                            spinner: 'helpSpinners',
                            tableText: 'helpTable',
                        };
                        var sel = selectedTool[0];
                        var helpId_1;
                        for (var _c = 0, _d = Object.entries(prefixToHelpId); _c < _d.length; _c++) {
                            var _e = _d[_c], prefix = _e[0], id = _e[1];
                            if (sel.startsWith(prefix)) {
                                helpId_1 = id;
                                break;
                            }
                        }
                        if (helpId_1) {
                            var item = helpList.find(function (h) { return h.id === helpId_1; });
                            if (item === null || item === void 0 ? void 0 : item.pdf) {
                                trackEvent(AnalyticsCategory.support, 'openMaterial', helpId_1);
                                window.open(item.pdf, '_blank', 'noopener,noreferrer');
                            }
                        }
                    }
                    break;
            }
        };
        document.addEventListener('keydown', handleKeyDown);
        return function () { return document.removeEventListener('keydown', handleKeyDown); };
    }, [applyLanguage, setUserZoom, mainConfig]);
    // Listen for keyboard shortcuts modal toggle from SettingWithPopup button
    useEffect(function () {
        var handler = function () { return setShowShortcutsModal(function (prev) { return !prev; }); };
        customEventHandler.addEventListener('toggleKeyboardShortcuts', handler);
        return function () { return customEventHandler.removeEventListener('toggleKeyboardShortcuts', handler); };
    }, []);
    var onTableSelect = function (id, data) {
        var rowsNum = data.rowsNum, colsNum = data.colsNum;
        var tableWidth = colsNum * 150;
        var tableHeight = rowsNum * 100;
        var scrollEl = document.querySelector('.whiteboardScrollbar .customScrollbarContent');
        var centerX = scrollEl
            ? scrollEl.scrollLeft / zoomLevel + scrollEl.clientWidth / zoomLevel / 2
            : 0;
        var centerY = scrollEl
            ? scrollEl.scrollTop / zoomLevel + scrollEl.clientHeight / zoomLevel / 2
            : 0;
        var x = centerX - tableWidth / 2;
        var y = centerY - tableHeight / 2;
        var rowsHeight = Array(rowsNum).fill(90);
        var colWidth = Array(colsNum).fill(150);
        var cellIdCounter = 0;
        var cellData = Array(rowsNum * colsNum)
            .fill(0)
            .map(function () { return ({
            type: 'text',
            data: {
                text: '',
                color: ColorEnum[colorRef.current],
                size: 30,
            },
            cellId: "cell_".concat(Date.now(), "_").concat(++cellIdCounter),
        }); });
        var newTable = {
            type: 'table',
            data: {
                dimensions: {
                    width: colsNum * 150,
                    height: rowsNum * 90,
                },
                position: {
                    x: x,
                    y: y,
                    z: 0,
                },
                rowsHeight: rowsHeight,
                colWidth: colWidth,
                cellData: cellData,
            },
        };
        var newIndex = table.length;
        saveState({
            type: 'table',
            id: newIndex,
            propertyName: 'create',
            old: JSON.stringify(newTable),
        });
        setTable(function (prev) { return __spreadArray(__spreadArray([], prev, true), [newTable], false); });
        setTimeout(function () {
            setSelectedTool(['tableText_' + newIndex]);
            requestAnimationFrame(function () {
                // Focus the sentinel button (primary SR tab stop for the table).
                // Querying by data-manipulative-id is explicit and avoids accidentally
                // landing on a cell picker button which would enter cell-edit mode.
                var sentinel = document.querySelector("[data-manipulative-id=\"tableText_".concat(newIndex, "\"]"));
                sentinel === null || sentinel === void 0 ? void 0 : sentinel.focus();
            });
        }, 50);
    };
    var drawAnnotations = function (data) {
        var setType = data.data < 2 ? 'rectangle' : 'ellipse';
        var setStyle = data.data % 2 === 0 ? 'fill' : 'outline';
        var active = data.data % 2 === 0 ? false : true;
        var _a = getPositionForNewItem(), x = _a.x, y = _a.y;
        var currentColor = colorRef.current;
        var _saveData = {
            center: {
                x: x,
                y: y,
            },
            dimensions: {
                width: 200,
                height: 200,
            },
            active: active,
            lock: {
                positioning: false,
                editing: false,
            },
            rotation: 0,
            style: setStyle,
            color: ColorEnum[currentColor],
            thickness: 2,
        };
        var shapeTypeKeys = {
            rectangle_fill: 'text.filledRectangleCreated',
            rectangle_outline: 'text.outlineRectangleCreated',
            ellipse_fill: 'text.filledEllipseCreated',
            ellipse_outline: 'text.outlineEllipseCreated',
        };
        var shapeTypeKey = shapeTypeKeys["".concat(setType, "_").concat(setStyle)] || 'text.shapeCreated';
        var newId = "annotations_".concat(annotationsRef.current.length);
        setAnnotations(function (_ann) { return __spreadArray(__spreadArray([], _ann, true), [
            {
                type: setType,
                data: _saveData,
            },
        ], false); });
        // Announce creation via live region (same as manipulatives).
        // Do NOT move focus — VoiceOver ignores preventScroll and platform-scrolls
        // the canvas to 0,0 whenever focus lands on an SVG inside the canvas.
        announce(t(shapeTypeKey));
        setTimeout(function () {
            setSelectedTool([newId]);
        }, 400);
        return {
            type: setType,
            data: _saveData,
        };
    };
    var sidebarDisabledButtons = useMemo(function () {
        var _a;
        var disabledButtons = getDisabledButtonsByLock({
            selectedTool: selectedTool,
            text: text,
            table: table,
            annotations: annotations,
            shades: shades,
            manipulative: manipulative,
        });
        if (!selectedTool.some(function (t) {
            return t.includes('manipulativeGroup') ||
                t.includes('manipulative') ||
                t.includes('numberChart') ||
                t.includes('linkingCube') ||
                t.includes('numberLine') ||
                t.includes('patternShape') ||
                t.includes('numberRack') ||
                t.includes('dice_') ||
                t.includes('protractor_') ||
                t.includes('spinner_') ||
                t.includes('timer') ||
                t.includes('analog') ||
                t.includes('numberCharts') ||
                t.includes('linkingCubes') ||
                t.includes('numberLines') ||
                t.includes('patternShapes') ||
                t.includes('numberRacks') ||
                t.includes('deck_') ||
                t.includes('card_') ||
                t.includes('text') ||
                t.includes('tableText') ||
                t.includes('mathText') ||
                t.includes('shades_') ||
                t.includes('annotations_') ||
                t.includes('arrayModel') ||
                t.includes('fractionTiles_') ||
                t.startsWith('counter_') ||
                t.startsWith('numberFrameCounter_') ||
                t.includes('numberFrame_') ||
                t.includes('numberPiece_') ||
                t.includes('moneyPiece_') ||
                t.includes('jumpBar_') ||
                t.includes('customTick_') ||
                t.includes('coloredTiles_') ||
                t.includes('linearPiece_') ||
                t.includes('coinsAndCounters_');
        })) {
            disabledButtons.push('toolsCollapsible');
        }
        if ((_a = selectedTool[0]) === null || _a === void 0 ? void 0 : _a.startsWith('nl_')) {
            disabledButtons.push('toolsCollapsible');
        }
        // Common: when only dummy placeholders are active, disable delete and edit tools
        if (selectedTool.length > 0 && selectedTool.every(function (t) { return t.endsWith('_dummyForRightTool'); })) {
            if (!disabledButtons.includes('delete'))
                disabledButtons.push('delete');
            if (!disabledButtons.includes('toolsCollapsible'))
                disabledButtons.push('toolsCollapsible');
        }
        if (nmpIsAnimating) {
            if (!disabledButtons.includes('delete'))
                disabledButtons.push('delete');
            if (!disabledButtons.includes('toolsCollapsible'))
                disabledButtons.push('toolsCollapsible');
        }
        // Disable colorPlate when numberFrame, counter, or coinsAndCounters is selected
        if (selectedTool.some(function (t) {
            return t.startsWith('numberFrame_') ||
                t.startsWith('counter_') ||
                t.startsWith('numberFrameCounter_') ||
                t.startsWith('coinsAndCounters_');
        })) {
            if (!disabledButtons.includes('colorPlate'))
                disabledButtons.push('colorPlate');
        }
        // Disable colorPlate, delete, and toolbox while a manipulative popup is open
        if (maniplulatorComponentVisible && activeManipulator) {
            if (!disabledButtons.includes('colorPlate'))
                disabledButtons.push('colorPlate');
            if (!disabledButtons.includes('delete'))
                disabledButtons.push('delete');
            if (!disabledButtons.includes('toolsCollapsible'))
                disabledButtons.push('toolsCollapsible');
        }
        // Disable delete + toolbox when the only selected colored tile is the invisible placeholder
        // (manual mode opens the right panel before any real block is dragged from the tray).
        var hasInvisibleColoredTile = selectedTool.length > 0 &&
            selectedTool.every(function (t) { return t.startsWith('coloredTiles_'); }) &&
            selectedTool.every(function (t) {
                var _a;
                var item = manipulative.find(function (m) { return m.data.id === t; });
                return !item || !!((_a = item.data) === null || _a === void 0 ? void 0 : _a.isInvisible);
            });
        if (hasInvisibleColoredTile) {
            if (!disabledButtons.includes('delete'))
                disabledButtons.push('delete');
            if (!disabledButtons.includes('toolsCollapsible'))
                disabledButtons.push('toolsCollapsible');
        }
        return disabledButtons;
    }, [
        selectedTool,
        text,
        table,
        annotations,
        shades,
        manipulative,
        nmpIsAnimating,
        maniplulatorComponentVisible,
        activeManipulator,
    ]);
    var handleCloseTooManyItems = useCallback(function () { return setShowTooManyItemsModal(false); }, []);
    useEffect(function () {
        if (process.env.NODE_ENV === 'development' && typeof window !== 'undefined') {
            setTimeout(function () {
                import('@axe-core/react')
                    .then(function (_a) {
                    var axe = _a.default;
                    axe(React, ReactDOM, 1000);
                })
                    .catch(function () {
                    /* @axe-core/react not yet installed — ignore */
                });
            }, 1000);
        }
    }, [manipulative.length]);
    // console.log('manipulative.length', {annotations, entities:manipulative, drawCommands,text, shades, zoomLevel });
    return (_jsxs("div", { className: "mainContainer ".concat(displayNone ? 'hidden' : ''), "aria-hidden": displayNone, children: [_jsx(DummyCanvas, {}), displayMode === 'normal' && _jsx(Header, {}, "header"), _jsxs("div", { className: "mainContent", children: [displayMode === 'normal' && (_jsx(Sidebar, { toolChange: toolChange, collapsibleGuide: collapsibleDivObject, disabledButtons: sidebarDisabledButtons })), displayMode === 'smartBoard' && (_jsx(Footer, { toolChange: toolChange, collapsibleGuide: collapsibleDivObject, disabledButtons: sidebarDisabledButtons })), _jsx(WhiteBoard, {})] }), _jsx(ManipulativeTool, {}), tool === leftSideTools.eraserAll && _jsx(Eraser, {}), hasBottomPanelContent && _jsx(ToolBottomPanel, {}, "toolBottomPanel"), gameLoaded && hasRightPanelContent && (_jsx(RightSideToolPanel, { collapsibleState: checkCollapsibleState, tokenSelections: tokenSelections, setTokenSelections: setTokenSelections, tokenPanelOpen: tokenPanelOpen, setTokenPanelOpen: setTokenPanelOpen, hideTrayCounter: hideTrayCounter }, "rightSideToolPanel")), _jsx(ManipulativePopup, {}), showTablePopup && (_jsx(InsertTablePopup, { id: "table", isOpen: showTablePopup, setIsOpen: setTablePopup, onClick: onTableSelect })), _jsx(ZoomAndPanController, {}), showEnterKeyModal && (_jsx(EnterKeyModal, { setShowModal: setShowEnterKeyModal, showModal: showEnterKeyModal })), showSaveEditsReminder && (_jsx(SaveEditsReminderModal, { showModal: showSaveEditsReminder, setShowModal: setShowSaveEditsReminder, onContinue: function () { }, onSaveNow: function () { return setShowSaveModal(true); } })), showResetModal && (_jsx(ResetModal, { showModal: showResetModal, setShowModal: setShowResetModal, hasPreloadedActivity: hasPreloadedActivity, onReloadActivity: handleReloadActivity, onStartFromScratch: handleStartFromScratch })), showSplitFractionTileModal && (_jsx(SplitFractionTileModal, { showModal: showSplitFractionTileModal, setShowModal: setShowSplitFractionTileModal, currentDenominator: splitFractionTileCurrentDenominator, currentNumerator: splitFractionTileCurrentNumerator, returnFocusTo: splitModalReturnFocusRef, onDone: function (parts, currentDenominator) {
                    customEventHandler.dispatchEvent('bottomPanel', {
                        id: 'splitFractionTileDone',
                        data: { parts: parts, currentDenominator: currentDenominator },
                    });
                } })), showShortcutsModal && (_jsx(KeyboardShortcutsModal, { showModal: showShortcutsModal, setShowModal: setShowShortcutsModal })), _jsx(FractionTileController, {}), _jsx(ColoredTileController, {})] }));
};
export default GameController;
